export default {
    "AI 员工": "AI 직원",
    "18 位 AI 员工": "18명의 AI 직원",
    "最忙的是拉流量那几位": "가장 바쁜 것은 트래픽을 유입시키는 역할입니다",
    "商品有人采、图片有人翻、订单有人盯——这些都不难。真正决定一间店活不活得下去的，是": "상품 채택, 이미지 번역, 주문 관리 등은 어렵지 않습니다. 진정한 성공 요인은",
    "有没有人来": "누군가 방문하는지",
    "。所以增长组的 5 位员工，天天在做的就是这件事：先把店修到能接住流量，再把流量一处一处引过来。": "에 달려있습니다. 그래서 성장팀의 5명의 직원들은 매일 이 일에 집중합니다: 먼저 트래픽을 받을 수 있는 가게를 만들고, 그 다음에는 트래픽을 하나씩 유입시킵니다.",
    "免费开店，让 AI 员工先体检一遍": "무료로 가게 오픈하고, AI 직원이 첫 검사를 진행해보세요",
    "看自动营销怎么跑": "자동 마케팅 어떻게 작동하는지 확인해보세요",
    "18 位员工，四组分工": "18명의 직원, 네 그룹으로 나누어 작업",
    "9 个内容渠道": "9개의 콘텐츠 채널",
    "12 项店铺体检": "12개의 가게 건강 체크 항목",
    "4 条自动序列": "4개의 자동 시퀀스",
    "这页分两半。前半说": "이 페이지는 두 부분으로 나뉩니다. 앞부분은",
    "流量是怎么被拉进来的": "트래픽이 어떻게 유입되는지",
    "，后半是 18 位员工分别管什么。赶时间就直接往下翻到「30 天」。": "설명하며, 뒷부분은 18명의 직원들이 각각 어떤 일을 하는지 설명합니다. 시간이 없다면 바로 '30일'로 스크롤하세요.",
    "位 AI 员工，分四组": "명의 AI 직원, 네 그룹으로 분류",
    "个内容渠道一件商品全铺": "개의 콘텐츠 채널에 상품 전체 배포",
    "项店铺体检，按浪费钱排序": "개의 가게 건강 체크 항목, 돈 낭비 순으로 정렬",
    "条自动营销序列": "개의 자동 마케팅 시퀀스",
    "先找堵点": "먼저 막히는 지점을 찾아보세요",
    "流量不是没来，是被挡住了": "트래픽이 오지 않는 것이 아니라 막혔어요",
    "很多店花了力气发内容，还是没单。问题常常不在内容，而在「页面接不住」——标题是中文、没主图、没描述、价格离谱。这些不修，来多少人都一样。": "많은 가게들이 콘텐츠를 게시하는데 많은 노력을 기울였음에도 주문이 들어오지 않습니다. 문제는 종종 콘텐츠가 아닌 '페이지가 받아들일 수 없다'에 있습니다 - 제목이 중국어, 메인 이미지 없음, 설명 없음, 가격이 비현실적. 이 부분들을 수정하지 않으면 얼마나 많은 트래픽이 와도 마찬가지입니다.",
    "12 项体检，按「会不会浪费钱」排序": "12개 항목 체크, `돈 낭비` 여부로 정렬",
    "先花三分钟，把店过一遍": "먼저 3분 동안 가게 전체를 살펴보세요",
    "「推广总控」打开就跑一次体检：不是给你一张漂亮的分数表，而是直接告诉你哪几项": "`프로모션 총제어`를 실행하면 자동으로 체크: 예쁜 점수표가 아니라 바로 어떤 항목을 고쳐야 하는지 알려줍니다.",
    "现在推就等于扔钱": "지금 프로모션 하면 돈 버리는 것과 같아요",
    "，该修的先修，能放的最后再说。": ", 고쳐야 할 건 먼저 고치고, 나중에 할 건 나중에 하세요.",
    "阻塞项 / 建议修 / 已通过，三档分清": "차단 / 수정 권장 / 통과, 세 단계로 구분",
    "每一项都写清楚「不修的后果」，不是打分了事": "각 항목마다 `수정하지 않은 결과`를 명확히 적어둡니다, 점수만 매기는 것이 아닙니다.",
    "体检完直接收敛到 15 个商品，不让你 65 个一起推": "체크 후 65개 상품 대신 15개 상품으로 집중",
    "体检用的是你店里的真实数据：商品数、SEO 地址、主图、描述、分类、价格分布、买家数。": "체크는 실제 가게 데이터를 사용합니다: 상품 수, SEO 주소, 메인 이미지, 설명, 카테고리, 가격 분포, 구매자 수.",
    "不是模板打分": "템플릿 점수가 아닙니다",
    "。": ".",
    "店铺体检": "가게 체크",
    "刚刚 · 65 个在售商品": "방금 · 65개 판매 중인 상품",
    "3 项待修": "3개 항목 수정 필요",
    "商品标题语言": "상품 제목 언어",
    "阻塞": "차단",
    "52 / 65 个标题疑似中文，而站点语言是 Deutsch": "52/65개의 제목이 중국어로 의심되며, 사이트 언어는 Deutsch입니다",
    "先改主推那 10 个，不用 65 个一起改 →": "우선 주력 상품 10개부터 수정하세요, 65개 모두 수정할 필요 없습니다 →",
    "商品主图": "상품 메인 이미지",
    "只有 41 / 65 个商品有主图": "41 / 65 개의 상품만 메인 이미지가 있습니다",
    "没图的既进不了 Merchant Feed，也做不了 Pinterest": "이미지가 없는 경우 Merchant Feed에 들어갈 수 없으며 Pinterest도 만들 수 없습니다",
    "价格合理性": "가격 합리성",
    "建议修": "수정 권장",
    "2 个价格明显异常（最高 ¥38,600）": "2개의 가격이 명백히 비정상적입니다 (최고 ¥38,600)",
    "大概率是导入时汇率算错，逐个改回合理价": "대부분 환율 계산 오류로 인한 것으로 보이며, 각각 합리적인 가격으로 수정하세요",
    "品类归属": "카테고리 소속",
    "通过": "통과",
    "品类集中在 3 个类目": "카테고리는 3개의 분류에 집중되어 있습니다",
    "体检项": "건강 체크 항목",
    "卡住会怎样": "문제가 발생하면 어떻게 될까요",
    "谁来修": "누가 수정할까요",
    "在售商品": "판매 중인 상품",
    "可正常打开的商品不到 5 个，投多少流量都白搭": "정상적으로 열리는 상품이 5개 미만이라면, 어떤 양의 트래픽을 투입해도 효과가 없습니다",
    "你上架，巡检官列缺项": "당신이 상품을 등록하고, 검사관이 부족한 부분을 지적합니다",
    "站点是德语、标题还是中文，当地人根本搜不到": "사이트는 독일어지만 제목은 중국어로, 현지인들이 찾기 어려울 것입니다",
    "翻译本地化官": "번역 및 현지화 담당자",
    "SEO 描述": "SEO 설명",
    "搜索结果里没摘要，收录会慢上好几周": "검색 결과에 요약이 없으면 인덱싱이 몇 주 더 걸립니다",
    "SEO 优化师": "SEO 최적화 전문가",
    "进不了 Merchant Feed，也做不了 Pinterest": "Merchant Feed에 접근할 수 없고, Pinterest도 할 수 없습니다",
    "图片处理官": "이미지 처리 담당자",
    "分不清卖什么，就选不了渠道和人群": "무엇을 판매하는지 구분하지 못하면 채널과 대상을 선택할 수 없습니다",
    "你归类，AI 给建议": "카테고리를 지정하면 AI가 제안합니다",
    "汇率算错留个「¥38,600」的杯子，来人也转化不了": "환율 계산 오류로 「¥38,600」의 컵을 남겨두면, 고객도 변환되지 않습니다",
    "定价策略官": "가격 책정 전략 담당자",
    "库存": "재고",
    "推爆了发现没货，等于白推一轮": "상품이 품절된 상태에서 홍보하면, 노력이 헛될 수 있습니다",
    "订单管家": "주문 관리자",
    "SEO 地基": "SEO 기초",
    "没有 sitemap，搜索引擎不知道你有多少页": "사이트맵이 없으면 검색 엔진이 페이지 수를 알 수 없습니다",
    "平台自动生成": "플랫폼 자동 생성",
    "另外还有合规页面、已发内容、站内文章、已成交买家四项，一起算在 12 项里。": "또한 준수 페이지, 게시된 콘텐츠, 사이트 내 기사, 거래 완료된 구매자 4가지를 포함하여 총 12개 항목으로 계산됩니다.",
    "最实在的一步": "가장 실질적인 단계",
    "30 天，每天做什么已经写好了": "30일 동안 매일 해야 할 일이 이미 작성되어 있습니다",
    "体检完点一下「生成 30 天方案」，出来的不是一份「建议加强内容运营」的空话，而是 30 条具体任务：哪天做什么、为什么做、点开能直接跳到该改的页面。": "건강 체크 후 「30일 계획 생성」을 클릭하면, '콘텐츠 운영 강화 필요'라는 공허한 말이 아닌 30개의 구체적인 작업: 언제 무엇을 하는지, 왜 그렇게 하는지, 클릭하면 수정해야 하는 페이지로 바로 이동합니다.",
    "第 1 周 · 修地基": "1주차 · 기초 다지기",
    "这周": "이 주",
    "故意不产出任何对外内容": "외부 콘텐츠를 일부러 생산하지 않습니다",
    "。页面接不住流量，发了也是白花。先把 sitemap 交上去、异常价格改掉、商品归类、选出主推。": ".페이지 트래픽을 처리하지 못하면, 아무리 보내도 소용없습니다. 먼저 sitemap을 제출하고, 잘못된 가격을 수정하며, 상품을 분류하고, 주력 상품을 선택하세요.",
    "提交 sitemap 与 Merchant Feed": "sitemap과 Merchant Feed 제출",
    "改掉汇率算错的价格": "환율 계산 오류로 인한 가격 수정",
    "主推的 10 个商品改本地语言": "주력 10개 상품의 언어를 현지화",
    "第 2 周 · 铺图钉": "제 2 주 · 이미지 업로드",
    "Pinterest 每天 2 个，一直排到第 14 天。商品主图现成，竖版 2:3 就是内容，不需要另外拍。": "Pinterest에 매일 2개씩, 14일까지 계속 업로드합니다. 상품 메인 이미지는 준비되어 있으며, 세로형 2:3 비율의 이미지를 콘텐츠로 사용하므로 별도로 촬영할 필요가 없습니다.",
    "零授权、零成本": "무료, 제로 코스트",
    "描述里带商品链接": "상품 링크 포함한 설명",
    "有买家的话加一封新品通知": "구매자가 있다면 신상품 알림 이메일 추가",
    "第 3 周 · 写长尾": "제 3 주 · 장기 키워드 작성",
    "站内博客 3 篇，每篇围绕一个真实搜索词，正文 800 字，中间内链到商品页。发出去会进 sitemap，慢慢带收录。": "사이트 내 블로그 3편, 각각 실제 검색어를 중심으로 800자 본문 작성, 중간에 상품 페이지로의 내부 링크 삽입. 게시 후 sitemap에 포함되며, 점진적으로 인덱싱됩니다.",
    "「XX おすすめ」这种词": "「XX おすすめ」와 같은 단어",
    "一键发成站内文章": "한 번의 클릭으로 사이트 내 게시물 생성",
    "比广告便宜，比广告久": "광고보다 저렴하고, 광고보다 오래 지속됨",
    "第 4 周 · 复盘加码": "제 4 주 · 리뷰 및 강화",
    "看四个数：收录页数、站外访问、加购、订单。哪个渠道有访问就挪 70% 精力过去，其他的先停。": "네 가지 수치 확인: 인덱스된 페이지 수, 외부 방문, 장바구니 담기, 주문. 어느 채널에서든 방문이 발생하면 그 채널에 70%의 노력을 집중하고, 나머지는 일시 중단합니다.",
    "收录没动 → 查抓取错误": "인덱스 변동 없음 → 크롤링 오류 확인",
    "有点击没加购 → 补商品页细节": "클릭은 있으나 장바구니 담기 없음 → 상품 페이지 세부 정보 보완",
    "有加购没下单 → 查运费和支付": "장바구니 담기는 있으나 주문 없음 → 배송비와 결제 방식 확인",
    "第 1 周的实际任务": "제 1 주의 실제 작업",
    "来自一份真实生成的方案 · 节奏和顺序都由店铺数据决定": "데이터로 생성된 실제 계획 · 리듬과 순서는 가게 데이터에 따라 결정됩니다",
    "把站点地图提交给 Google": "사이트맵을 Google에 제출하세요",
    "打开 Search Console 提交 sitemap.xml；顺手在 Merchant Center 添加 feed/google.xml。这两步不花时间，但是后面所有流量的入口。": "Search Console에서 sitemap.xml을 제출하고, Merchant Center에 feed/google.xml을 추가하세요. 이 두 단계는 시간이 많이 걸리지 않지만, 모든 트래픽의 출발점입니다.",
    "第 1 天 · 不花钱": "1일차 · 비용 없음",
    "改掉异常价格": "비정상적인 가격 수정하기",
    "这些商品价格明显不对，多半是导入时汇率算错。价格离谱的页面，投多少流量都转化不了。": "이 제품들의 가격이 명백히 잘못되었습니다. 대부분 환율 계산 오류 때문입니다. 가격이 너무 높거나 낮은 페이지는 아무리 트래픽을 유입해도 전환이 이루어지지 않습니다.",
    "第 1 天 · 点开就到商品列表": "1일차 · 클릭하면 상품 목록으로",
    "选出这次主推的 10 个商品": "이번에 주력할 10개의 상품 선택하기",
    "系统按「有图、有详情、有 SEO 地址、价格正常、有库存」排过序。这 30 天只推这批，其余先不动。": "시스템은 이미 '이미지, 상세 정보, SEO 주소, 정상 가격, 재고 있음' 기준으로 정렬했습니다. 이번 30일 동안에는 이 제품들만 집중적으로 프로모션합니다.",
    "第 3 天": "3일차",
    "主推商品的标题改成 Deutsche": "주력 상품의 제목을 Deutsche로 변경하기",
    "只改主推那 10 个，不要 65 个一起改。标题里带上「是什么 + 给谁用 + 关键属性」——当地用户搜的是这个词，不是中文直译。": "단지 주력 상품 10개만 변경하세요, 65개 모두를 변경하지 마세요. 제목에는 '무엇인지 + 누구에게 + 핵심 속성'을 포함시키세요 —— 현지 사용자가 검색하는 키워드가 아닌, 중국어 직역이 아닙니다.",
    "第 4 天 · 调翻译本地化官出稿": "4일차 · 번역 로컬라이제이션 확인",
    "补主推商品的 SEO 描述": "주력 상품의 SEO 설명 추가하기",
    "每个 80~120 字，写清楚谁会买、解决什么问题、有什么细节。这段话会直接出现在搜索结果里，比广告文案还重要。": "각각 80~120자로, 누가 구매할 것인지, 어떤 문제를 해결하는지, 어떤 세부 사항이 있는지 명확히 작성하세요. 이 문장은 검색 결과에 직접 표시되며, 광고 카피보다 더 중요합니다.",
    "第 5 天 · 调 SEO 优化师出稿": "5일차 · SEO 최적화 전문가와 협의",
    "全站体检一遍": "전체 사이트 점검하기",
    "缺主图、缺描述、零库存、断链全部列出来，能当场修的就修掉。": "메인 이미지 부족, 설명 부족, 재고 없음, 링크 중단 등 모든 문제를 나열하고 즉시 수정 가능한 부분은 바로 수정하세요.",
    "第 6 天 · 调店铺巡检官": "6일차 · 가게 점검 담당자와 협의",
    "方案里的预期指标都标了推算依据，": "계획안의 예상 지표들은 모두 추정 근거가 표시되어 있습니다,",
    "我们不承诺效果": "우리는 효과를 보장하지 않습니다",
    "。0 基础的站，30 天内 0 单是正常的——这句话写在方案里，不是藏在条款里。": ".0 기반의 사이트는 30일 내에 0 주문이 정상적입니다——이 문구는 계획안에 작성되어 있으며, 조항에 숨겨져 있지 않습니다.",
    "内容产能": "콘텐츠 생산력",
    "一件商品，铺到 9 个渠道": "하나의 상품을 9개 채널에 배포",
    "不是把同一段话复制九遍。Pinterest 要图钉描述，TikTok 要口播脚本，X 要短句，Google 商家要本地化措辞，站内博客要 800 字长文——这些是同一条卖点的九种写法。": "동일한 문장을 9번 복사하는 것이 아닙니다. Pinterest는 핀 설명을, TikTok은 스크립트를, X는 짧은 문장을, Google My Business는 지역화된 표현을, 사이트 내 블로그는 800자 긴 글을 필요로 합니다——이는 동일한 판매 포인트의 9가지 작성 방식입니다.",
    "手冲咖啡滤杯 · 陶瓷": "수제 커피 필터 · 세라믹",
    "¥168 · 库存 42 · 已本地化": "¥168 · 재고 42 · 이미 현지화됨",
    "选一件主推商品": "주력 상품 선택",
    "图钉描述": "핀 설명",
    "配图短文": "이미지와 함께 간단한 텍스트",
    "帖子": "게시물",
    "短句": "짧은 문장",
    "口播脚本": "스크립트",
    "私域话术": "프라이빗 메시지",
    "频道稿": "채널 원고",
    "本地文案": "현지화된 텍스트",
    "站内博客": "사이트 내 블로그",
    "800 字长文": "800자 긴 글",
    "品牌名和固定标签带进每一篇": "브랜드 이름과 고정 태그를 모든 게시물에 포함",
    "设一次，之后每一条都自动带上，不用每次重新交代语气。": "한 번 설정하면, 이후 모든 게시물에 자동으로 포함되며, 매번 다시 언급할 필요가 없습니다.",
    "今天建议发哪个渠道": "오늘 어떤 채널을 추천합니까",
    "投递箱顶部直接给当天的排期，不用自己记 30 天日历。": "투고함 상단에 당일 일정이 바로 표시되어 30일 달력을 기억할 필요가 없습니다.",
    "博客可以一键发成站内文章": "블로그를 한 번의 클릭으로 사이트 내 게시글로 발행할 수 있습니다.",
    "发布后进文章列表，被 sitemap 收录，成为长期的自然流量入口。": "발행 후 게시글 목록에 들어가 sitemap에 포함되어 장기적인 유입 경로가 됩니다.",
    "说实话：文案是生成好的，发帖要你自己发。": "솔직히 말하면: 카피는 생성되지만, 포스팅은 직접 해야 합니다.",
    "平台不碰你的社媒账号，也不会拿你的账号去群发——所以不需要把 FB / IG 授权给我们。需要自动发的只有站内博客和营销邮件，这两条走的是你自己的系统。": "플랫폼은 소셜 미디어 계정에 접근하지 않으며, 계정을 이용해 대량 발송하지 않습니다. 따라서 FB/IG 권한을 제공할 필요가 없습니다. 자동 발송이 필요한 것은 사이트 내 블로그와 마케팅 이메일뿐이며, 이 두 가지는 당신의 시스템을 통해 이루어집니다.",
    "这一页最重要的一段": "이 페이지에서 가장 중요한 문장",
    "自动营销：开了开关，它自己发": "자동 마케팅: 스위치를 켜면 알아서 발송됩니다",
    "拉新是靠内容和渠道，一单一单攒的。但已经买过的人，不用再花钱去拉——他们就在你的订单里。自动营销干的就是这件不花广告费的事：按规则挑人、按场景写信、按额度慢慢发。": "신규 고객은 콘텐츠와 채널을 통해 하나씩 모아갑니다. 하지만 이미 구매한 사람들은 추가 비용을 들여 모을 필요가 없습니다. 그들은 이미 주문 목록에 있습니다. 자동 마케팅은 광고비 없이 이런 일을 처리합니다: 규칙에 따라 사람을 선택하고, 상황에 맞게 메시지를 작성하고, 적절한 양만큼 서서히 발송합니다.",
    "自动": "자동",
    "新品通知": "신상품 알림",
    "近": "최근",
    "180 天": "180 일",
    "买过的人，告诉他们刚上架的新品。上新了没人知道，等于没上。": "구매한 사람들에게 새로 출시된 제품을 알려줍니다. 신상품 출시를 알리지 않으면 출시한 것과 같습니다.",
    "圈人依据：已付款订单 + 最近购买时间": "대상 선정 기준: 결제 완료된 주문 + 최근 구매 시간",
    "弃购召回": "장바구니 포기 회수",
    "加了购物车": "장바구니에 추가",
    "2 小时": "2 시간",
    "还没下单，提醒回来结账；超过 7 天就不再发了——再久就没意义。": "아직 주문하지 않았다면, 결제하러 돌아오도록 알립니다. 7일 이상 지나면 더 이상 발송하지 않습니다. - 그 이상은 의미가 없습니다.",
    "圈人依据：加车时间，2 小时 ~ 7 天之间": "대상 선정 기준: 장바구니 추가 시간, 2시간 ~ 7일 사이",
    "老客唤醒": "기존 고객 재참여",
    "最后一单已经超过": "마지막 주문이 이미",
    "45 天": "45 일",
    "，请他们回来看看。老客回购的成本，比拉新低得多。": "이상 지났습니다. 기존 고객을 다시 초대해보세요. 신규 고객 유치 비용보다 훨씬 저렴합니다.",
    "圈人依据：最后一单时间超过 45 天": "그룹 선택 근거: 마지막 주문일이 45일 이상 지난 경우",
    "手动": "수동",
    "促销群发": "프로모션 대량 발송",
    "所有下过单的顾客，按最近购买时间倒序。做活动时用，不适合天天发。": "모든 주문한 고객, 최근 구매일 순으로 정렬. 이벤트 시 사용, 매일 보내는 것은 적합하지 않음.",
    "圈人依据：全部已付款买家": "그룹 선택 근거: 모든 결제 완료된 구매자",
    "怕打扰？三个上限替你守住": "방해가 걱정되나요? 세 가지 상한선으로 관리하세요",
    "宁可少发一封，也别被退订": "하나 덜 보내더라도, 해지되지 않도록 하세요",
    "营销邮件发烂了比不发更糟——域名信誉一掉，连发货通知都进垃圾箱。所以这套系统的默认值偏保守，而且是": "과도한 마케팅 메일은 보낼지 않아도 더 나쁩니다 - 도메인 평판이 떨어지면, 심지어 배송 알림까지 스팸함으로 갈 수 있습니다. 그래서 이 시스템의 기본값은 보수적으로 설정되어 있으며,",
    "你自己能改的": "당신이 변경할 수 있습니다",
    "每天最多发多少封，自己定（默认 200）": "하루에 최대 몇 개의 메일을 보낼지 결정하세요 (기본값 200)",
    "同一个人最少间隔多少天（默认 15 天）": "같은 사람에게 최소 몇 일 간격으로 보낼지 (기본값 15일)",
    "同一条序列 7 天内不重复跑": "같은 시퀀스 7일 내 재발송 안 함",
    "退订的、最近刚发过的，自动排除": "해지한, 최근에 이미 보낸 사람은 자동 제외",
    "只圈付过款的人，不碰注册未下单的": "결제만 한 사람들만 포함, 등록 후 주문하지 않은 사람 제외",
    "自动营销": "자동 마케팅",
    "每天最多发": "하루에 최대 발송 수",
    "封": "봉쇄",
    "同一人最少间隔": "최소 간격(일)",
    "天": "일",
    "自动跑哪些序列": "자동 실행 시퀀스",
    "累计送达": "누적 전달",
    "队列待发": "대기열 대기 중",
    "退订率": "구독 해지율",
    "定时任务每 10 分钟推一批。走你自己配的发信账号，退订链接自动带上。": "타이머 작업은 10분마다 한 번씩 배치를 처리합니다. 직접 설정한 발송 계정을 사용하며, 자동으로 구독 취소 링크가 포함됩니다.",
    "自动营销不消耗 AI 积分": "자동 마케팅은 AI 포인트를 소모하지 않습니다",
    "自动跑的是内置模板，只有你点「AI 写一版」时才计费。所以就算每天发满，也不会偷偷烧额度。": "자동 실행은 내장 템플릿을 사용하며, 'AI로 작성'을 클릭할 때만 요금이 부과됩니다. 따라서 매일 최대한 발송해도 비용이 추가로 발생하지 않습니다.",
    "看订阅怎么算": "구독 방법 알아보기",
    "别什么都做": "모든 것을 동시에 하지 마세요",
    "先做哪个，先别做哪个": "먼저 무엇을, 먼저 무엇을 하지 말아야 하는지",
    "新店最容易犯的错，是五个平台一起开、每周都发、每条都没人看。系统会按你的店况直接排出优先级——包括明确告诉你「这个月先别做」。": "신규 상점이 가장 많이 범하는 오류는 모든 플랫폼을 동시에 시작하고, 주마다 보내지만 아무도 보지 않는 것입니다. 시스템은 상점 상태에 따라 우선순위를 정해줍니다 - 특정 달에는 아직 진행하지 않아도 되는 항목까지 명확히 알려줍니다.",
    "渠道": "채널",
    "优先级": "우선순위",
    "为什么": "이유",
    "什么时候开始": "언제 시작",
    "站点地图 / Merchant Feed": "사이트 맵 / Merchant Feed",
    "主力": "주력",
    "零授权、零成本，一次配好长期有效": "제로 권한, 제로 비용, 한 번 설정하면 장기적으로 유효",
    "立刻": "즉시",
    "站内 SEO（商品页）": "사이트 내 SEO (상품 페이지)",
    "有复利，越早做越好": "복리 효과, 빠를수록 좋음",
    "第 1 周": "1주차",
    "商品主图就是内容，零授权、可长期带访问": "상품 메인 이미지가 콘텐츠, 제로 권한, 장기 방문 유도 가능",
    "第 2 周": "2주차",
    "营销邮件（EDM）": "마케팅 이메일 (EDM)",
    "唯一能全自动的渠道，但要有买家才有收件人": "완전 자동화 가능한 유일한 채널, 하지만 구매자가 있어야 수신자가 있음",
    "辅助": "보조",
    "见效慢，但长尾关键词能一直带流量": "효과가 느리지만, 장기 키워드는 지속적인 트래픽 유도 가능",
    "第 3 周": "3주차",
    "暂不做": "현재는 미실시",
    "要账号授权，新号容易限流，性价比低于 Pinterest": "계정 권한 필요, 신규 계정은 제한적, Pinterest보다 비용 대비 효과 낮음",
    "后面再评估": "나중에 재평가",
    "要拍视频、API 需审核，这 30 天不划算": "비디오 촬영, API 심사 필요, 30일 동안 비효율적",
    "付费广告": "유료 광고",
    "不建议": "권장하지 않음",
    "页面还没准备好，投了也转化不了": "페이지 준비되지 않아, 투자해도 전환 안 됨",
    "先不花这个钱": "현재는 비용 투입 안 함",
    "这张表是按「有没有主图、描述铺没铺满、有没有买家」实时算的。你的店况不同，排出来的顺序也不同。": "이 표는 실시간으로 '메인 이미지 유무, 설명 완성도, 구매자 유무'에 따라 계산됩니다. 가게 상황에 따라 순서가 달라집니다.",
    "花名册": "명단",
    "前面讲的是「拉流量」这一条线。剩下的日常——采货、翻译、盯单、对账——也都有人在管。按位订阅，也可以买组合包。": "앞서 언급한 것은 '트래픽 유입'입니다. 나머지 일상적인 업무 - 재고 확보, 번역, 주문 관리, 대조 - 모두 전담 인력이 있습니다. 포지션별로 구독하거나 패키지를 구매할 수 있습니다.",
    "商品组": "상품 그룹",
    "5 位": "5 명",
    "把外面看到的东西，变成你店里能卖的东西。": "외부에서 본 것을 가게에서 판매 가능한 상품으로 변환합니다.",
    "商品采集官": "상품 수집 담당자",
    "从货源链接批量抓标题、属性、SKU 与图片，直接进已选商品，不用一条条复制。": "공급처 링크에서 제목, 속성, SKU 및 이미지를 일괄적으로 가져와 선택된 상품에 직접 추가합니다. 하나씩 복사할 필요가 없습니다.",
    "已接入": "연동됨",
    "标题、属性、详情按目标市场语言本地化，不是逐字直译，保持当地习惯用词。": "제목, 속성, 상세 정보는 목표 시장 언어로 현지화되며, 단순 직역이 아닌 현지 습관 표현을 유지합니다.",
    "按目标市场搜索习惯写标题、关键词、描述，写完直接入库。可以批量跑。": "목표 시장의 검색 습관에 맞춰 제목, 키워드, 설명을 작성하고, 작성 후 바로 저장소에 넣습니다. 일괄 처리 가능합니다.",
    "主图上的外文一键换成本地语言，基础处理一起做，不用开设计软件。": "메인 이미지의 외국어를 한 번 클릭으로 현지 언어로 변경하며, 기본 처리도 함께 진행하여 디자인 소프트웨어를 열 필요가 없습니다.",
    "按采购价、运费、平台佣金与竞品价位算建议售价，避免拍脑袋定价。": "구매 가격, 운송비, 플랫폼 수수료, 경쟁 제품 가격 등을 고려해 권장 판매 가격을 계산하여 무작위 가격 설정을 피합니다.",
    "接入中": "연동 중",
    "订单组": "주문 그룹",
    "4 位": "4 명",
    "有人下单以后，别让人等、别让件丢。": "주문이 들어온 후에는 고객을 기다리게 하거나 물건을 잃어버리지 않도록 합니다.",
    "盯住待支付、待采购、待发货各环节，异常订单主动挑出来提醒处理。": "대기 중인 결제, 구매, 발송 단계를 모니터링하고, 이상 주문은 자동으로 분류하여 처리를 알립니다.",
    "物流追踪官": "물류 추적 담당자",
    "批量跟进运单状态，卡在中转、清关超时、派送失败的件单独列出。": "운송 상태를 일괄적으로 추적하며, 중간 지점에서 멈춘, 통관 시간 초과, 배송 실패한 항목은 따로 나열합니다.",
    "客服应答官": "고객응대 담당자",
    "按本店真实发货时效、支付方式与物流商，写一套买家常见问题话术，复制到你的客服渠道就能用。": "실제 출고 시간, 결제 방법, 물류 업체에 따라 작성한 자주 묻는 질문 답변을 고객 서비스 채널에 복사하여 사용할 수 있습니다.",
    "评论运营官": "리뷰 운영 담당자",
    "汇总商品评价，差评归因、话术建议，好评提炼成卖点。": "상품 평가를 정리하고, 부정적인 리뷰의 원인 분석 및 대응 방안 제시, 긍정적인 리뷰는 판매 포인트로 활용합니다.",
    "增长组": "성장팀",
    "负责「有人来」。前面三段讲的就是这一组。": "'누군가 방문하게 만드는' 역할을 합니다. 앞에서 설명한 세 가지 역할이 이 팀에 포함됩니다.",
    "推广总控": "프로모션 총괄",
    "先体检找出真正卡住的地方，再给一份 30 天每天做什么的方案，点一下就调其他员工出稿。": "먼저 진단을 통해 문제점을 파악한 후, 30일 동안 매일 해야 할 일들을 제안하며, 클릭 한 번으로 다른 직원에게 작업을 요청할 수 있습니다.",
    "社媒内容官": "소셜미디어 콘텐츠 담당자",
    "把一件商品改写成 9 个渠道的成品，从 Pinterest 图钉到 TikTok 口播脚本。": "하나의 상품을 9개의 채널용 콘텐츠로 재구성합니다. Pinterest 핀부터 TikTok 스크립트까지 모두 가능합니다.",
    "客户维系官": "고객 유지 담당자",
    "按人群圈选买家：新品通知、弃购召回、老客唤醒、促销群发，营销邮件自动分批触达。": "타겟 그룹별로 구매자를 선택: 신상품 알림, 장바구니 유기 회수, 기존 고객 활성화, 프로모션 메일 발송 등 자동으로 배치합니다.",
    "选品侦察兵": "상품 선정 스카우터",
    "顺着你现在卖的品提相邻品类，用货源真实行情验证，每周给一份能落地的清单。": "현재 판매 중인 상품과 관련된 카테고리를 제안하고, 실제 공급 상황을 확인하여 주간 실행 가능한 리스트를 제공합니다.",
    "促销策划官": "프로모션 기획 담당자",
    "按节令和积压库存给活动方案，方案确认后可以直接建券。": "시즌과 재고 상태에 따른 프로모션 계획을 제공하며, 계획이 확정되면 바로 쿠폰을 생성할 수 있습니다.",
    "经营组": "경영팀",
    "每天有人替你看数、对账、挑问题。": "매일 누군가가 데이터를 모니터링, 대조, 문제점 발견을 도와줍니다.",
    "数据播报员": "데이터 브리핑 담당자",
    "每天把访客、订单、转化、客单价整理成一段人话播报，不用自己拉表。": "방문자, 주문, 전환율, 평균 거래액 등을 매일 사람이 읽을 수 있는 형태로 요약하여 보고합니다. 직접 표를 만들 필요 없이 간편하게 정보를 얻을 수 있습니다.",
    "财务对账官": "재무 대조 관리자",
    "订单收入和提成支出逐笔核对，找出漏记、重复扣款与异常提成。": "주문 수익과 커미션 지출을 일일이 확인하여 누락, 중복 차감 및 이상한 커미션을 찾아냅니다.",
    "店铺巡检官": "가게 점검 관리자",
    "定期体检店铺：缺主图、缺描述、零库存、断链，一次性列出待修清单。": "정기적으로 가게를 점검: 메인 이미지 부족, 설명 부족, 재고 없음, 링크 끊김 등을 한 번에 수정 목록으로 제공합니다.",
    "合规审查官": "준법 검토 관리자",
    "商品文案与图片过一遍违禁词、侵权与平台规则，降低下架封店风险。": "상품 문안과 이미지를 금지어, 저작권 침해, 플랫폼 규칙에 따라 검토하여 상품 하OnInitiation 및 가게 폐쇄 위험을 줄입니다.",
    "标「接入中」的几位，平台侧能力已经就绪、店主端页面还在接。我们不在官网上把它们写成「马上能用」。": "「연동 중」 표시된 항목들은 플랫폼 측의 기능은 준비되었으나, 가게 주인 페이지 연동이 진행 중입니다. 공식 웹사이트에서는 이들을 「즉시 사용 가능」이라고 표시하지 않습니다.",
    "怎么买": "구매 방법",
    "按位买，或者一次买一组": "개별 구매 또는 패키지로 구매",
    "每一位员工可以单独订阅，也可以买组合包——组合包覆盖多位员工，折算下来单价更低。开通后到期时间按订阅算，快到期会提醒，不会突然停掉。": "각 직원은 개별 구독이 가능하며, 여러 직원을 포함하는 패키지도 구매할 수 있습니다. 패키지는 단위당 가격이 더 낮습니다. 구독 후 만료 시점까지 서비스가 제공되며, 만료 전 알림이 가며 갑작스럽게 중단되지 않습니다.",
    "先用哪几位就开哪几位，不必一次全开": "필요한 직원부터 먼저 구독",
    "组合包覆盖的员工在服务市场里写清楚，不会含糊": "패키지에 포함된 직원은 서비스 마켓에서 명확히 표시되어 있으며, 모호하지 않습니다.",
    "到期前提醒；过期后是「续费」，不用重新找入口": "만료 전 알림; 만료 후는 「연장」이며, 다시 입구를 찾을 필요 없습니다.",
    "看订阅和佣金怎么算": "구독 및 커미션 계산 방법 확인",
    "增长组合包": "성장 패키지",
    "覆盖 5 位员工": "5명의 직원을 커버",
    "比单买省": "개별 구매보다 저렴",
    "去服务市场": "서비스 마켓으로 이동",
    "接上你自己的 AI": "자신의 AI 연결",
    "豆包、ChatGPT、Claude 也能读这间店": "두바오, ChatGPT, Claude도 이 가게를 읽을 수 있습니다.",
    "平台提供数据接口：AI 能查商品、价格、库存和推广方案，也能把写好的文案存回投递箱。": "플랫폼이 데이터 인터페이스를 제공: AI가 상품, 가격, 재고, 프로모션 방안을 확인하고 작성한 카피를 투고함에 저장할 수 있습니다.",
    "不用把账号密码交给任何插件": "어떤 플러그인에게도 계정과 비밀번호를 제공하지 마세요",
    "，也不用授权社媒账号。": "소셜 미디어 계정 권한도 부여하지 마세요.",
    "读：商品、价格、库存、体检结果、30 天方案": "읽기: 상품, 가격, 재고, 건강 검진 결과, 30일 계획",
    "写：把文案按渠道存回投递箱": "쓰기: 채널별로 작성한 카피를 투고함에 저장",
    "不发：发帖这一步始终由你决定": "발행: 포스팅 여부는 항상 당신의 결정입니다",
    "先开哪位？": "누구부터 시작하시겠습니까?",
    "如果只开一位，开": "만약 한 명만 선택하신다면,",
    "——它会体检、会排 30 天、还会叫其他员工干活。等订单多起来，再加客户维系官做自动营销。": "——상점 건강 검진, 30일 일정 설정, 다른 직원들에게 작업 지시까지 합니다. 주문량이 늘어나면 고객 관계 담당자를 추가하여 자동 마케팅을 수행하세요.",
    "看要花多少钱": "비용을 확인해보세요",
    "先让 AI 员工体检一遍你的店": "AI 직원에게 상점을 건강 검진해보세요",
    "免费开店就能跑体检。先看堵点在哪，再决定花不花钱。": "무료로 상점을 개설하고 건강 검진을 진행하세요. 먼저 문제점을 파악한 후 비용을 결정하세요.",
    "免费开店": "무료로 상점 개설",
    "看全部功能": "모든 기능 보기",
    "卖家案例": "판매자 사례",
    "他们也在做同一件事，": "다른 사람들도 같은 일을 하고 있습니다,",
    "只是起点不一样": "단지 출발점이 다릅니다",
    "有人在义乌档口，有人在深圳写字楼，有人在德国的小公寓。": "어떤 이는 의우 시장에서, 어떤 이는 선전 오피스 빌딩에서, 또 다른 이는 독일의 작은 아파트에서 시작했습니다.",
    "难处不一样，解法是同一套。": "어려움은 다르지만 해결책은 같습니다.",
    "我也开一间试试": "저도 한 번 해보겠습니다",
    "先看他们怎么做的": "먼저 그들이 어떻게 했는지 보세요",
    "这几位都不算「大神」。": "이 몇 명은 모두 '프로'라고 할 수 없습니다.",
    "他们的共同点是先开了店，": "그들의 공통점은 먼저 가게를 열었다는 것입니다.",
    "而不是先把一切都想明白。": "모든 것을 완벽하게 계획한 다음에 시작한 것이 아닙니다.",
    "个不同起点的卖家": "개의 다른 출발점에서 시작한 판매자들",
    "天，最慢的一个开出第一单": "일, 가장 느린 사람은 첫 주문을 받기까지 걸린 시간",
    "个语言站点，最多的一个": "개 언어 사이트, 가장 많은 사람의 경우",
    "月订单，最高的一个": "월 주문, 가장 높은 경우",
    "六个故事": "여섯 개의 이야기",
    "从左到右，是三种「卖出去」的路": "왼쪽부터 오른쪽으로, 세 가지 '판매' 방법",
    "前三个在中国，后三个在海外。": "처음 세 개는 중국, 마지막 세 개는 해외입니다.",
    "陈": "진",
    "陈女士": "진 씨",
    "义乌 · 饰品档口": "의우 · 액세서리 상점",
    "「档口一天来不了几个老外，但网上的老外一天能来几百个。」": "'상점에는 하루에 외국인이 몇 명도 안 오지만, 인터넷에서는 하루에 수백 명의 외국인이 방문합니다.'",
    "原来只做批发，客户是本地贸易商。用模板做了英文和西班牙语两个站，把档口最常卖的 60 款拍了图上架，价格自己定。": "원래는 도매만 했고, 고객은 현지 무역상이었습니다. 템플릿을 사용해 영어와 스페인어 사이트 2개를 만들고, 상점에서 가장 많이 팔리는 60가지 제품을 사진 찍어 올렸으며, 가격은 직접 정했습니다.",
    "月订单": "월 주문",
    "语言站点": "언어 사이트",
    "9 天": "9 일",
    "开出第一单": "첫 주문",
    "林": "림",
    "林先生": "림 씨",
    "深圳 · 3C 配件": "선전 · 3C 액세서리",
    "「在平台卖，客户是平台的。在自己的站卖，客户才是我的。」": "「플랫폼에서 팔면, 고객은 플랫폼의 것입니다. 제 사이트에서 팔면, 고객은 제 것입니다.」",
    "原来在第三方平台做了三年，佣金加广告费吃掉三成。把爆款挪到独立站，用同一批货，客单价反而高了——因为能卖套装。": "원래는 3년 동안 제3자 플랫폼에서 판매했는데, 수수료와 광고비로 30%가 소모되었습니다. 베스트셀러를 독립 사이트로 옮기니 같은 상품으로도 평균 구매 금액이 더 높아졌습니다 — 세트로 판매할 수 있기 때문입니다.",
    "客单价": "평균 구매 금액",
    "渠道成本": "채널 비용",
    "王": "왕",
    "王小姐": "왕 씨",
    "广州 · 女装": "광주 · 여성 의류",
    "「我不碰国际物流。货发到国内仓，后面的事不归我管。」": "「국제 물류는 하지 않습니다. 상품을 국내 창고에 보내면 그 이후는 저의 책임이 아닙니다.」",
    "用代购模式起步：客户在她店里看到的是美元价，下单后平台买手去采购、合箱、出国际单。她只负责选款和在国内发货。": "대행 구매 모델로 시작: 고객이 그녀의 가게에서 보는 가격은 달러로 표시되며, 주문 후 플랫폼의 바이어가 구매, 합포장, 국제 배송을 처리합니다. 그녀는 단순히 제품 선택과 국내 발송만 담당합니다.",
    "压货成本": "재고 비용",
    "人小团队": "소규모 팀",
    "12 天": "12일",
    "回本周期": "투자 회수 기간",
    "德国 · 户外装备": "독일 · 아웃도어 장비",
    "「我不会中文，也没去过中国。但我能找到货源。」": "「중국어를 할 줄 모르고 중국에도 가본 적 없습니다. 하지만 공급처를 찾을 수 있습니다.」",
    "在德国做户外小众品类。通过平台直接对接国内工厂，一件代发，不压库存。页面用德语和英语，AI 员工处理夜间的英文询盘。": "독일에서 아웃도어 특화 카테고리를 운영하며, 플랫폼을 통해 국내 공장과 직접 연결하여 한 건씩 발송하고 재고를 보유하지 않습니다. 웹사이트는 독일어와 영어로 운영되며, AI 직원이 밤 시간대의 영어 문의를 처리합니다.",
    "6–9 天": "6–9일",
    "到货时效": "배송 예상 시간",
    "库存占用": "재고 점유",
    "美国 · 手工材料": "미국 · 수제 재료",
    "「利润不在货上，在搭配上。中国供应链让我敢试新组合。」": "「이윤은 제품이 아니라 조합에서 나옵니다. 중국 공급망 덕분에 새로운 조합을 시도할 수 있습니다.」",
    "卖手工材料包，按主题搭配。因为能小批量补货，她敢每周上一个新主题，卖不动就换，不用清库存。": "수제 재료 세트를 주제별로 판매합니다. 소량으로 재고를 보충할 수 있으므로, 매주 새로운 주제를 출시하고 잘 안 팔리면 교체하여 재고를 정리할 필요가 없습니다.",
    "每周": "매주",
    "上新频率": "신상품 출시 빈도",
    "复购率": "재구매율",
    "1 人": "1 명",
    "团队规模": "팀 규모",
    "法国 · 家居饰品": "프랑스 · 홈 악세사리",
    "「我不懂投放。AI 给了我一整个月要发什么。」": "「광고 투자를 잘 몰랐어요. AI가 한 달 동안 게시할 내용을 모두 제공해줬습니다.」",
    "靠 Instagram 起量。用 AI 营销生成 30 天内容和投放计划，先小预算试，哪个帖子有反应就加钱。": "Instagram을 통해 성장했습니다. AI 마케팅 도구를 사용해 30일간의 콘텐츠와 광고 계획을 생성하고, 작은 예산으로 먼저 테스트한 후 반응이 좋은 게시물에는 더 많은 예산을 투입합니다.",
    "渠道同时发": "다양한 채널 동시 게시",
    "帖子点击率": "게시물 클릭률",
    "14 天": "14 일",
    "首单": "첫 주문",
    "拆一个给你看": "하나 열어보여드릴게요",
    "陈女士的头 90 天，做对了三件事": "진 여사의 첫 90일, 세 가지 올바른 일을 했습니다",
    "她没投过广告，也没请运营。三件很朴素的事，按顺序做完，单量就起来了。": "그녀는 광고를 하지 않았으며 운영 인력을 고용하지도 않았습니다. 세 가지 단순한 일을 순서대로 완료했더니 주문량이 늘었습니다.",
    "先只上 60 款，不贪多": "일단 60개만 출시, 너무 많지 않게",
    "档口卖得最好的款，实拍图上架。款式少，页面反而干净，客户挑得快。": "가게에서 가장 잘 팔리는 제품, 실제 사진으로 업로드. 종류가 적어도 페이지가 깔끔하고 고객이 빠르게 선택할 수 있습니다.",
    "只开两个语言，做透": "두 언어만 열고, 철저히 관리",
    "英文和西班牙语。没有一上来开 20 种，先把这两个市场的标题和描述改顺。": "영어와 스페인어. 20개 언어를 한 번에 열지 않고, 이 두 시장의 제목과 설명을 먼저 자연스럽게 수정합니다.",
    "把运费写清楚": "배송비 명확히 표기",
    "多少钱、几天到、能不能退，写在商品页顶上。询盘少了一半，转化高了一截。": "얼마인지, 며칠 걸리는지, 반품 가능한지 상품 페이지 상단에 기재. 문의가 절반으로 줄고, 전환율이 크게 올랐습니다.",
    "第 90 天": "90일째",
    "月订单稳定在 480 上下，开始备第二个语言站": "월 주문량이 480개 정도로 안정화되면서 두 번째 언어 사이트 준비 시작",
    "稳定期": "안정기",
    "第 32 天": "32일째",
    "改了运费说明，商品页跳出率下降，开始有复购": "배송비 설명 수정 후, 상품 페이지 이탈률 감소, 재구매 시작",
    "优化期": "최적화 기간",
    "第 9 天": "9일째",
    "第一单来自西班牙，两件饰品，客单 $34": "첫 주문은 스페인에서, 액세서리 2개, 평균 구매금액 $34",
    "第 1 天": "1일째",
    "选了模板，填店铺名，上传 60 款商品": "템플릿 선택, 가게 이름 입력, 60개 상품 업로드",
    "开店": "가게 오픈",
    "关于这些案例：": "이 사례들에 대해:",
    "人物姓名与店铺信息已做脱敏，数据为区间示意，用于说明做法而非承诺结果。每个人的品类、资金和执行力不同，结果会有差异。": "사람 이름과 가게 정보는 익명 처리되었으며, 데이터는 범위를 나타내며 결과를 보장하는 것이 아니라 방법을 설명하기 위한 것입니다. 각자의 카테고리, 자금, 실행력이 다르므로 결과는 다릅니다.",
    "这几个人你都不认识": "이 사람들은 모두 모르는 사람들입니다",
    "但他们踩的坑，你大概率会踩。重点不是看他们赚了多少，而是": "하지만 그들이 겪은 어려움은 당신도 대부분 겪을 가능성이 높습니다. 중요한 것은 그들이 얼마나 벌었는지가 아니라,",
    "看他们在哪个环节换了做法。": "어떤 부분에서 방법을 바꿨는지를 보는 것입니다.",
    "你的起点，可能比他们还好一点": "당신의 시작점은 아마 그들보다 조금 더 좋을 수 있습니다.",
    "先开一间免费的，把第一个款上架。剩下的边做边改。": "먼저 무료로 가게를 열고 첫 제품을 등록하세요. 나머지는 하면서 수정하면 됩니다.",
    "我该走哪条路": "어떤 길을 선택해야 하나요",
    "平台功能": "플랫폼 기능",
    "开店要用的东西，这一页全有": "가게를 여는데 필요한 모든 것이 이 페이지에 있습니다",
    "建站、翻译、上架、发货、收款、拉客户——": "사이트 구축, 번역, 상품 등록, 배송, 결제, 고객 유치 -",
    "15 个模块都在一个后台": "15개 모듈이 하나의 백오피스에 모두 있습니다",
    "，不用再去外面拼七八个工具，也不用为了一个功能换一次服务商。": "외부 도구를 여러 개 조합하거나 특정 기능을 위해 서비스 제공사를 변경할 필요가 없습니다.",
    "免费开店，10 分钟看到你的店": "무료로 가게를 열고 10분 만에 가게를 확인하세요",
    "先看有哪些模块": "먼저 어떤 모듈이 있는지 확인해보세요",
    "15 个内置模块": "15개 내장 모듈",
    "20 种语言": "20개 언어",
    "佣金 3% 起": "수수료 3%부터",
    "第一次开店最怕的是“还差一样东西”。我把常用的都摆在这一页了，": "처음으로 가게를 열 때 가장 두려운 것은 '하나 더 필요하다'는 것입니다. 자주 사용하는 것들을 이 페이지에 모두 배치했으니,",
    "从上往下看就行": "위에서 아래로 보면 됩니다",
    "内置模块，一个后台": "내장 모듈, 하나의 백오피스",
    "种语言，覆盖全球买家": "다양한 언어, 전 세계 구매자 대상",
    "获客渠道可自动投放": "고객 유치 채널 자동 투방",
    "交易佣金阶梯": "거래 수수료 단계",
    "模块总览": "모듈 개요",
    "八个方向，撑起一间店": "여덟 방향, 하나의 가게를 지탱합니다",
    "每个方向下面都有几个具体功能，往下翻能看到怎么用。": "각 방향 아래에는 몇 가지 구체적인 기능이 있으며, 아래로 스크롤하면 어떻게 사용하는지 볼 수 있습니다.",
    "建站与装修": "사이트 구축 및 디자인",
    "选模板、拖组件，改完立刻生效。": "템플릿 선택, 컴포넌트 드래그 앤 드롭, 수정 후 즉시 적용됩니다.",
    "6 套主题": "6개 테마",
    "手机端自动适配": "모바일 자동 최적화",
    "20 种语言一次配好，买家进来就是他的母语。": "20개 언어 한 번에 설정, 구매자가 들어오면 그의 모국어로 표시됩니다.",
    "自动翻译": "자동 번역",
    "可人工改": "수동 수정 가능",
    "商品与供应链": "상품 및 공급망",
    "粘个链接就能上架，卖出去再采购。": "링크 붙여넣기만으로 상품 등록, 판매 후 구매 가능합니다.",
    "1688 / 淘宝采集": "1688 / 타오바오 수집",
    "库存同步": "재고 동기화",
    "客服、标题、描述，都能交给它。": "고객 지원, 제목, 설명 모두 위임 가능합니다.",
    "24 小时在线": "24시간 온라인",
    "多语言回复": "다국어 응답",
    "AI 营销": "AI 마케팅",
    "诊断店铺，给 30 天计划，自动发帖。": "가게 진단, 30일 계획 제공, 자동 게시글 작성",
    "5 个渠道": "5개의 채널",
    "内容日历": "콘텐츠 달력",
    "代购与集运": "대구매 및 집하",
    "客户付外币，平台代买代发。": "고객이 외화로 결제하고, 플랫폼이 대신 구매와 발송을 처리합니다.",
    "外币收款": "외화 수령",
    "合箱省运费": "합포장으로 운송비 절약",
    "订单与物流": "주문 및 물류",
    "批量打面单，轨迹一处看完。": "배치로 배송 라벨 출력, 한 곳에서 추적 가능",
    "云途 / 燕文 / 4PX": "YunExpress / Yanwen / 4PX",
    "异常提醒": "예외 알림",
    "收款与结算": "수금 및 정산",
    "PayPal、Stripe、支付宝接上即用。": "PayPal, Stripe, Alipay를 연결하면 바로 사용 가능합니다.",
    "T+7 结算": "T+7 정산",
    "多币种提现": "다양한 통화로 인출",
    "01 · 建站": "01 · 사이트 구축",
    "不用会代码，也能把店弄得像样": "코딩 능력 없이도 멋진 가게 만들기",
    "选一套模板，改文字和图片，手机上就是成品。想调结构就拖组件——左边挑、中间摆，改完点保存，前台立刻变。": "템플릿 선택, 텍스트와 이미지 수정, 모바일에서 바로 완성. 구조 조정은 컴포넌트 드래그-왼쪽에서 선택, 가운데에 배치, 변경 후 저장, 즉시 반영됩니다.",
    "首页、商品页、文章页都能可视化编辑": "홈페이지, 상품 페이지, 게시글 페이지 모두 시각적 편집 가능",
    "手机和桌面两套排版分开调，不用互相将就": "모바일과 데스크톱 별도 레이아웃 설정, 서로 타협 필요 없음",
    "改坏了能撤回上一版，不怕点错": "잘못 수정해도 이전 버전으로 되돌릴 수 있어 실수 걱정 없음",
    "编辑 · 首页": "편집 · 홈",
    "组件": "컴포넌트",
    "标题": "제목",
    "商品列表": "상품 목록",
    "图片": "이미지",
    "优惠券": "쿠폰",
    "视频": "비디오",
    "评价": "리뷰",
    "主视觉 banner": "메인 비주얼 배너",
    "拖动": "드래그",
    "四列商品": "4열 상품",
    "选中": "선택됨",
    "买家评价": "구매자 리뷰",
    "02 · 多语言": "02 · 다국어",
    "20 种语言，一次上完": "20개 언어, 한 번에 업로드",
    "后台的语言列表和店铺前台是同一套，开一个语言，商品标题、描述、政策页都会自动翻。翻得不顺手的句子，可以自己改，改完只影响这一句。": "백오피스의 언어 목록과 가게 프론트는 동일하며, 언어를 하나 활성화하면 상품 제목, 설명, 정책 페이지가 자동으로 번역됩니다. 자연스럽지 않은 문장은 직접 수정할 수 있으며, 수정한 부분만 영향을 미칩니다.",
    "英、日、韩、德、法、西、葡、意、俄、阿……共 20 种": "영어, 일본어, 한국어, 독일어, 프랑스어, 스페인어, 포르투갈어, 이탈리아어, 러시아어, 아랍어……총 20개",
    "机翻打底 + 人工修正，术语不会被翻歪": "기계 번역을 기반으로 하되, 인공 수정을 통해 용어가 잘못 번역되지 않음",
    "每种语言有独立的标题和描述，搜索结果不打架": "각 언어별로 독립적인 제목과 설명을 가지며, 검색 결과가 충돌하지 않음",
    "中文": "중문",
    "繁體中文": "번체중문",
    "日本語": "일본어",
    "店里开的每个语言都在这个列表里，": "가게에서 활성화한 모든 언어가 이 목록에 있습니다.",
    "两边一一对应": "양쪽이 일치합니다",
    "，不会出现后台开了前台没有的情况。": ". 백오피스에서 설정한 언어가 프론트엔드에 없는 경우는 없습니다.",
    "03 · 商品": "03 · 상품",
    "选品不用来回切十个网站": "다양한 사이트를 왔다 갔다 하지 않아도 됩니다",
    "从 1688、淘宝粘个链接，商品就采到自己店里，价格、规格、图片一起过来。卖出去再去采购，不用先压一批货在仓库。": "1688이나 타오바오에서 링크를 복사하면, 상품을 자신의 가게로 가져올 수 있으며, 가격, 사양, 이미지가 함께 들어옵니다. 판매 후 구매하므로 창고에 미리 재고를 보유할 필요가 없습니다.",
    "采集后自动换成店铺币种，加价规则自己定": "수집 후 자동으로 가게 통화로 변환되며, 마진 규칙은 자신이 정합니다",
    "库存和价格变动会同步，减少超卖": "재고와 가격 변경사항이 동기화되어 초과 판매를 줄입니다",
    "支持一件代发，也可以批量导出到自己的仓": "대리 발송을 지원하며, 대량으로 자신의 창고로 내보낼 수도 있습니다",
    "商品": "상품",
    "采购价": "구매 가격",
    "店铺售价": "가게 판매 가격",
    "纯棉圆领 T 恤": "순면 라운드 넥 티셔츠",
    "帆布托特包": "캔버스 토트백",
    "无线蓝牙耳机": "무선 블루투스 이어폰",
    "极简石英手表": "미니멀 퀀츠 시계",
    "显示的是": "표시되는 것은",
    "你的进价和你的售价": "당신의 구입 가격과 판매 가격입니다",
    "，中间差多少，一眼看得清。": "，차이가 얼마나 나는지 한눈에 알 수 있습니다.",
    "04 · AI 员工": "04 · AI 직원",
    "半夜的询盘，也有人回": "심야의 문의도 답변 가능",
    "客户问发货要几天、尺码怎么选、能不能退——AI 员工按你定的规则答，答不了的转人工。写标题、翻描述、改商品图，也能一起交给它。": "발송 소요 시간, 사이즈 선택 방법, 반품 가능 여부 등 — AI 직원은 당신이 정한 규칙에 따라 답변하고, 해결할 수 없는 사항은 인공으로 전환합니다. 제목 작성, 설명 번역, 상품 이미지 수정까지 모두 맡길 수 있습니다.",
    "24 小时在线，时差不用你熬夜补": "24시간 온라인, 시차 때문에 야근할 필요 없음",
    "用你的语气和退换规则，不乱承诺": "당신의 말투와 교환/반품 규정을 따름, 무리한 약속 안 함",
    "中英日韩等语言来回切，客户说什么它听什么": "중국어, 영어, 일본어, 한국어 등 다양한 언어 지원, 고객이 무엇이든 말하면 알아들음",
    "买家 · 02:14": "구매자 · 02:14",
    "AI 员工 · 02:14": "AI 직원 · 02:14",
    "已自动回复 · 用时 3 秒": "자동 응답 완료 · 3초 소요",
    "买家 · 02:15": "구매자 · 02:15",
    "转人工 · 02:15": "인공 전환 · 02:15",
    "退换属于承诺类问题，已转给你，附上了订单号。": "교환/반품은 약속 관련 문제로, 주문번호와 함께 당신에게 전달되었습니다.",
    "05 · AI 营销": "05 · AI 마케팅",
    "不会投广告，也能让客户找上门": "광고를 몰라도 고객이 찾아옵니다",
    "接上豆包这类 AI，先诊断你的店哪里不对劲，再给一份 30 天能照着做的内容和投放计划。Facebook、Instagram、TikTok 的帖子可以自动生成、定时发。": "두바오 같은 AI를 연결하면, 먼저 가게의 문제점을 진단한 후 30일 동안 실행 가능한 콘텐츠 및 배포 계획을 제공합니다. Facebook, Instagram, TikTok 게시물은 자동 생성 및 예약 발행 가능합니다.",
    "店铺诊断：标题、图片、价格、转化，逐项说问题": "가게 진단: 제목, 이미지, 가격, 전환율, 각 항목별 문제점 지적",
    "30 天内容日历，哪天发什么直接排好": "30일 콘텐츠 달력, 어떤 날에 무엇을 게시할지 미리 설정",
    "一件商品铺到 9 个渠道，博客和邮件能自动发": "하나의 상품을 9개 채널에 배포, 블로그와 이메일 자동 발송",
    "AI 给的是初稿。": "AI는 초안을 제공합니다.",
    "涉及价格和承诺的内容，建议人工过一眼再发": "가격과 약속 관련 내용은 발송 전에 반드시 확인하세요",
    "，这一步我们不会替你做主。": "이 단계에서는 결정을 대신하지 않습니다.",
    "看 18 位 AI 员工的分工": "18명의 AI 직원들의 역할 분배를 확인하세요",
    "诊断你的店": "상점 진단하기",
    "抓取首页和 20 个商品页，找出转化流失的位置。": "홈페이지와 20개 상품 페이지를 분석하여 전환율이 떨어지는 부분을 찾아냅니다.",
    "给出 30 天计划": "30일 계획 제시",
    "每天发什么、配什么图、投多少预算，写成清单。": "매일 어떤 콘텐츠를, 어떤 이미지를, 얼마나 예산을 투입할지 체크리스트로 작성합니다.",
    "九个渠道一次铺完": "9개 채널 한 번에 배포",
    "Pinterest、IG、FB、X、TikTok、WhatsApp、Telegram、Google 商家、站内博客。": "Pinterest, IG, FB, X, TikTok, WhatsApp, Telegram, Google My Business, 인하우스 블로그.",
    "每周回收数据": "주간 데이터 수집",
    "哪些帖子带来点击，下一周把预算挪过去。": "클릭을 유도한 게시물은 다음 주 예산을 재분배합니다.",
    "06 · 代购 / BuyLink": "06 · 대구 / BuyLink",
    "客户付外币，你只发国内快递": "고객은 외화로 결제하고, 당신은 국내 택배만 보내세요",
    "客户在你店里看到的是外币价，点「代购下单」跳到平台，链接已经预填好。平台买手替你采购、合箱、出国际单。你负责把货送到国内仓，剩下的跨境段平台接走。": "고객이 당신의 가게에서 보는 가격은 외화입니다. '대구 주문'을 클릭하면 플랫폼으로 이동하며, 링크는 미리 입력되어 있습니다. 플랫폼 구매자가 제품을 대신 구매, 합치고 국제 배송을 진행합니다. 당신은 국내 창고로 상품을 보내면 됩니다. 나머지 국제 배송은 플랫폼이 담당합니다.",
    "收外币、付人民币，中间不用自己换汇": "외화 수령, 위안화 지급, 환전 필요 없음",
    "多件合箱，运费比一件一件发便宜": "여러 개의 상품을 하나의 박스에 넣어 배송비 절약",
    "国际段轨迹可查，客户催单时有话说": "국제 배송 추적 가능, 고객 문의 시 답변 가능",
    "看跨境物流怎么走": "국제 물류 경로 확인",
    "客户在你的店下单": "고객이 당신의 가게에서 주문",
    "看到的是你的价格、你的币种、你的品牌。": "당신의 가격, 통화, 브랜드를 볼 수 있습니다.",
    "点「代购下单」": "대리구매 주문하기",
    "跳到平台，商品链接和规格已预填，客户只需确认。": "플랫폼으로 이동하면, 상품 링크와 사양이 미리 입력되어 있어 고객은 확인만 하면 됩니다.",
    "平台采购并合箱": "플랫폼에서 구매 및 합포장",
    "买手收货、验货、去掉多余包装，几单并一箱。": "바이어가 수령, 검수, 불필요한 포장 제거 후 여러 주문을 한 박스에 합칩니다.",
    "出国际单，轨迹回传": "국제 배송, 추적 정보 전송",
    "单号自动回到你的订单里，客户也能看到。": "운송장 번호가 자동으로 주문에 업데이트되며, 고객도 볼 수 있습니다.",
    "后台日常": "일상적인 백오피스 관리",
    "订单、客户、权限，一个地方管完": "주문, 고객, 권한을 한 곳에서 관리할 수 있습니다.",
    "店里跑起来以后，每天真正要看的就这三块。": "가게 운영이 시작되면, 매일 체크해야 하는 것은 이 세 가지입니다.",
    "订单看板": "주문 대시보드",
    "今天几单、待发货几单、哪单卡在海关，打开就看见。": "오늘의 주문 수, 발송 대기 중인 주문, 통관 중인 주문을 한눈에 확인할 수 있습니다.",
    "批量打面单，一次几十张": "배치로 운송장 출력, 한 번에 수십 장",
    "异常件单独列出来": "이상 주문은 따로 표시",
    "客户资产": "고객 자산",
    "邮箱、订单、复购记录都在你的后台，不是平台的。": "이메일, 주문, 재구매 기록이 모두 당신의 백오피스에 저장됩니다. 플랫폼이 아닌 당신의 것입니다.",
    "一键导出 CSV": "한 번 클릭으로 CSV 내보내기",
    "按购买次数分组": "구매 횟수별 그룹화",
    "权限与协作": "권한 및 협업",
    "谁能看什么，按角色分好，不用共享一个账号。": "역할별로 누가 무엇을 볼 수 있는지 설정하여 하나의 계정을 공유할 필요가 없습니다.",
    "客服 / 运营 / 老板三档": "고객 서비스 / 운영 / 사장님 세 단계",
    "操作日志可追溯": "작업 로그 추적 가능",
    "这一页东西多，不用全看完": "이 페이지의 내용이 많지만 모두 읽지 않아도 됩니다",
    "你只要记住一句：": "기억해야 할 문장은 하나입니다:",
    "开店要用的六件事，这里都有对应的人": "가게를 열기 위한 여섯 가지 사항, 여기에 모두 대응하는 사람이 있습니다",
    "。建站、翻译、上架、发货、收款、拉客户——缺哪一块，直接跳到那一块看。": "사이트 구축, 번역, 상품 등록, 배송, 결제, 고객 유치 - 필요한 부분이 있다면 바로 그 부분으로 이동하세요.",
    "先看要花多少钱": "얼마가 필요한지 먼저 확인하세요",
    "看完了，直接开一间试试": "보기 끝났다면, 지금 바로 방을 열어보세요",
    "免费开店，不绑卡、不签合同。店铺先跑起来，觉得有用再谈套餐。": "무료로 가게를 열고, 카드를 등록하거나 계약을 체결할 필요가 없습니다. 먼저 가게를 운영해보고 유용하다고 생각되면 패키지를 선택하세요.",
    "看价格": "가격 보기",
    "给中国卖家": "중국 판매자에게",
    "你只管选品和定价，": "상품 선택과 가격 설정만 신경 쓰세요,",
    "其余我们办": "나머지는 우리가 처리합니다",
    "建站、翻译、运费、打面单、答客户——": "사이트 구축, 번역, 운송비, 배송 라벨 생성, 고객 응대——",
    "中间这些麻烦事，平台替你做了。": "플랫폼이 이런 번거로운 작업들을 대신 처리해드립니다.",
    "先看看别人在卖什么": "다른 사람들이 무엇을 파는지 먼저 확인해보세요",
    "佣金低至 3% · 模板和翻译按套餐含 · 店铺和客户数据都归你": "수수료 3%부터 · 템플릿과 번역은 패키지에 포함 · 가게와 고객 데이터는 모두 당신의 것",
    "Taoify 商家工作台 · 数据看板界面": "Taoify 판매자 워크스페이스 · 데이터 대시보드",
    "已上线 20 种语言站点": "20개 언어 사이트 출시",
    "日本語 · Deutsch · Español …": "일본어 · Deutsch · Español …",
    "下面这六件事，你大概率会遇到其中三四件。": "아래 6가지 사항 중 3~4개는 아마도 경험하게 될 것입니다.",
    "遇到了再解决": "문제는 나중에 해결하세요",
    "，不用现在全想明白。": "지금 다 이해할 필요 없어요.",
    "开店前后，绕不开的六个问题": "가게 오픈 전후에 피할 수 없는 여섯 가지 문제",
    "每一件都有现成的解法": "모든 것에 대한 해결책이 이미 준비되어 있습니다",
    "上面是你会问的问题，中间是我们怎么接，下面是你最后得到什么。": "위에는 질문, 중간에는 답변, 아래에는 결과입니다.",
    "没有技术团队，建站要外包？": "기술 팀이 없어서 외주로 사이트를 만들어야 하나요?",
    "选一个模板，填店铺名和邮箱，十分钟就开了。想改哪里点哪里，不用发需求等排期。": "템플릿을 선택하고 가게 이름과 이메일을 입력하면 10분 만에 오픈할 수 있어요. 변경하고 싶은 부분은 클릭해서 바로 수정 가능합니다. 요구사항을 보내고 대기할 필요가 없습니다.",
    "10 分钟上线，改版不用排队": "10분 만에 출시, 개선 작업은 대기 없이 가능",
    "不会外语，商品描述怎么写？": "외국어를 몰라서 상품 설명을 어떻게 써야 하나요?",
    "20 种语言自动翻，翻得不顺的句子可以自己改。术语不会被翻歪，尺码表也是对的。": "20개 언어로 자동 번역되며, 자연스럽지 않은 문장은 직접 수정할 수 있습니다. 용어는 정확하게 번역되고, 사이즈 차트도 올바르게 표시됩니다.",
    "日本客户看日文，德国客户看德文": "일본 고객은 일본어, 독일 고객은 독일어로 볼 수 있습니다",
    "运费到底收多少，才不亏？": "얼마의 배송비를 받아야 손해 보지 않을까요?",
    "按重量和地区设好模板，客户下单时系统自动算。偏远地区单独加价，不用你手算。": "무게와 지역별로 템플릿을 설정하면, 주문 시 시스템이 자동으로 계산합니다. 원거리 지역은 별도로 추가 비용을 부과하여 수작업 없이 처리 가능합니다.",
    "不再出现「运费比货贵」": "'배송비가 상품보다 비싸다'는 문제가 더 이상 발생하지 않습니다",
    "客户想刷卡，我只收过微信？": "고객이 카드 결제를 원하는데, 저는 지금까지 위챗페이만 받았어요",
    "PayPal、Stripe、支付宝接上即用，外币直接进你的账户，平台不代收货款。": "PayPal, Stripe, Alipay를 연결하면 바로 사용 가능하며, 외화는 직접 계좌로 입금됩니다. 플랫폼에서 대신 결제를 받지 않습니다.",
    "结账页多三种付法，少一次流失": "결제 페이지에 세 가지 추가 결제 방법으로 고객 유실 줄이기",
    "国际快递怎么发，单号怎么回传？": "국제 택배는 어떻게 보내고, 추적 번호는 어떻게 전달하나요?",
    "云途、燕文、4PX 实时比价，选一条就出单。面单批量打完，轨迹自动回到订单里。": "YunExpress, Yanwen, 4PX 실시간 견적 비교 후 선택하면 즉시 발송 가능합니다. 배송 라벨을 일괄 출력하고, 추적 정보는 자동으로 주문에 업데이트됩니다.",
    "一张面单贴完，客户自己查轨迹": "배송 라벨 한 장 붙이면 고객이 직접 배송 상태를 확인할 수 있습니다",
    "客户半夜问东问西，谁来回？": "고객이 밤에 질문을 하면, 누가 대답하나요?",
    "AI 员工按你定的规则答，答不了的转给你。时差不用熬，第二天看记录就行。": "AI 직원이 정해진 규칙에 따라 답변하고, 해결할 수 없는 것은 당신에게 전달합니다. 시차를 고려하지 않아도 되며, 다음 날 기록을 확인하면 됩니다.",
    "询盘不隔夜，退换不乱承诺": "문의는 당일 처리, 환불은 무리한 약속 없이 처리",
    "全链路": "전체 프로세스",
    "你的活到「交给快递」为止": "당신의 작업은 '택배에 맡기기'까지",
    "后面这一段，是大多数人卡住的地方。我们把它接走。": "다음 단계는 대부분의 사람들이 어려워하는 부분입니다. 저희가 책임집니다.",
    "你的货": "당신의 상품",
    "工厂或仓库里": "공장이나 창고에서",
    "现成的那批货": "현재 준비된 상품",
    "上架": "상품 등록",
    "一键铺货": "한 번 클릭으로 상품 등록",
    "20 语种自动翻译": "20개 언어 자동 번역",
    "收款": "결제 수령",
    "外币进账": "외화 입금",
    "不经过平台": "플랫폼을 거치지 않음",
    "国内仓": "국내 창고",
    "你发到仓": "당신이 창고로 보내기",
    "验货合箱": "상품 검수 및 합포장",
    "出境派送": "해외 배송",
    "报关、干线": "통관, 주요 운송",
    "末端签收": "배송완료",
    "紫色：平台负责": "보라색: 플랫폼이 책임집니다",
    "灰色：你负责": "회색: 당신이 책임집니다",
    "看物流怎么走": "물류 경로 확인",
    "获客": "고객 유치",
    "店开好了，客户从哪来": "가게는 열었는데, 고객은 어디서 오나요",
    "这是第二道坎。Taoify 接上豆包这类 AI，先诊断你的店哪里不对劲，再给一份 30 天能照着做的计划，然后自动发到五个渠道。": "두 번째 관문입니다. Taoify는 두바오 같은 AI와 연결하여 가게의 문제점을 진단하고, 30일 동안 따를 수 있는 계획을 제공한 후, 자동으로 5개 채널에 발송합니다.",
    "Facebook、Instagram、TikTok 等 5 个渠道自动发": "Facebook, Instagram, TikTok 등 5개 채널에 자동 발송",
    "每周回收数据，把预算挪到有反应的那条": "매주 데이터 수집, 반응이 좋은 채널로 예산 재분배",
    "看 AI 营销怎么用": "AI 마케팅 활용 방법 확인",
    "多平台内容分发": "다중 플랫폼 콘텐츠 배포",
    "更轻的起步方式": "더 가벼운 시작 방법",
    "不想压货？先走代购": "재고 부담 없이? 먼저 대구매부터 시작해보세요",
    "客户付外币，你只发国内快递。采购、集运、国际段都由平台办。": "고객이 외화로 결제, 당신은 국내 택배만 보내세요. 구매, 집하, 국제 운송은 모두 플랫폼에서 처리합니다.",
    "第一档 · 起步用这个": "첫 번째 단계 · 시작용",
    "代购模式": "대구매 모델",
    "不用备货、不用垫钱。客户下单后平台去买，你连货都不用碰。": "재고 준비 없이, 돈도 미리 들이지 않아도 됩니다. 고객이 주문하면 플랫폼이 구매하고, 물건을 직접 다루지 않아도 됩니다.",
    "零压货，卖什么买什么": "재고 없이, 팔면 사세요",
    "外币收款由平台处理": "외화 수령은 플랫폼에서 처리",
    "适合刚起步、试品类": "처음 시작하거나 카테고리 시험 중인 경우에 적합",
    "跑通之后": "성공적으로 실행한 후",
    "第二档 · 放量用这个": "두 번째 단계 · 확장에 사용",
    "模式": "모드",
    "店铺直接收外币，采购、集运、出国际单都由平台办。你只负责选品和发国内快递。": "가게에서 직접 외화를 받고, 구매, 집하, 국제 배송은 플랫폼이 처리합니다. 당신은 상품 선택과 국내 택배 발송만 책임집니다.",
    "利润归你，价格自己定": "수익은 당신의 것이며, 가격은 자신이 정합니다",
    "多件合箱，运费更省": "여러 개의 상품을 한 박스에 합치면 운임이 더 저렴해집니다",
    "适合已有稳定货源": "안정적인 공급처가 있는 경우 적합",
    "客户那一端看到的是这样": "고객이 보는 화면은 다음과 같습니다",
    "在你的店铺看到商品，价格是你定的": "당신의 가게에서 상품을 보고, 가격은 당신이 정한 가격으로 표시됩니다",
    "点「代购下单」，跳到代购平台，链接已预填": "`대행 주문`을 클릭하면 대행 플랫폼으로 이동하며, 링크는 미리 입력되어 있습니다",
    "平台买手回你的店下普通国内订单": "플랫폼의 구매자가 당신의 가게로 일반적인 국내 주문을 넣습니다",
    "你发国内快递到平台仓，国际段平台负责": "당신은 국내 택배로 플랫폼 창고로 보내고, 국제 배송은 플랫폼이 책임집니다",
    "跑通了想自己赚利润，再切成 BuyLink 模式：店铺直接收外币，采购、集运、出国际单都由平台办。": "성공적으로 실행한 후 수익을 얻고 싶다면 BuyLink 모드로 전환: 가게에서 직접 외화를 받고, 구매, 집하, 국제 배송은 플랫폼이 처리합니다.",
    "三条路": "세 가지 방법",
    "自己搭、找外包、用 Taoify": "자신이 구축하기, 아웃소싱 찾기, Taoify 사용",
    "不比参数，比的是「多久能开卖」和「出问题谁管」。": "비교하는 것은 `얼마나 빨리 판매할 수 있는지`와 `문제 발생 시 누가 관리하는지`입니다.",
    "对比项": "비교 항목",
    "自己搭": "자신이 구축하기",
    "找外包": "아웃소싱 찾기",
    "上线时间": "런칭 시간",
    "1–2 个月": "1-2 개월",
    "2–4 周，改一次再等一周": "2-4 주, 수정 후 1주일 더 기다림",
    "当天": "당일",
    "前期投入": "초기 투자",
    "服务器、插件、维护，几千起": "서버, 플러그인, 유지보수, 수천원부터 시작",
    "几万起": "수만원부터 시작",
    "佣金 3%–6%，按月成交额阶梯": "수수료 3%-6%, 월 거래액 단계별 적용",
    "改一次样式": "스타일 한 번 수정",
    "找人重做": "새로 만들기",
    "再付一次钱": "다시 돈 지불",
    "自己点两下，或跟 AI 说一句": "직접 두 번 클릭하거나 AI에게 말하기",
    "多语言": "다국어 지원",
    "装插件，翻译另买": "플러그인 설치, 별도 구매 필요",
    "加钱，通常只做一两种": "추가 비용, 일반적으로 1-2개 언어만 제작",
    "20 种语言内置，自动切换": "내장 20개 언어, 자동 전환",
    "自己申请，被拒就卡住": "직접 신청, 거절 시 중단",
    "自己申请": "직접 신청",
    "PayPal、Stripe、支付宝接上即用": "PayPal, Stripe, Alipay 연결하여 사용 가능",
    "国际物流": "국제 물류",
    "自己找货代、自己算价": "직접 화물 대행사 찾기, 가격 직접 계산",
    "不在服务范围": "서비스 범위 외",
    "云途、燕文、4PX 已接，自动比价出单": "운투, 연문, 4PX 접수, 자동 견적 및 발주",
    "自己摸索": "스스로 탐색",
    "AI 诊断 + 30 天方案 + 五渠道": "AI 진단 + 30일 계획 + 다섯 채널",
    "客户归属": "고객 소속",
    "你的": "당신의",
    "你的，邮箱和订单数据都在你后台": "당신의, 이메일과 주문 데이터는 모두 당신의 백오피스에 있습니다",
    "对比基于常见方案的平均情况，不代表任何具体服务商。": "일반적인 솔루션의 평균 상황을 기준으로 비교하며, 특정 서비스 제공자를 대표하지 않습니다.",
    "怎么开始": "시작 방법",
    "三步，今天就能走完第一步": "세 단계, 오늘 첫 번째 단계를 완료할 수 있습니다",
    "填店铺名和邮箱，选一个模板。不用绑卡，不签合同。": "가게 이름과 이메일 입력, 템플릿 선택. 카드 결제나 계약 없음.",
    "约 10 分钟": "약 10분",
    "粘 1688 或淘宝链接，或用 Excel 批量导入。价格自己定。": "1688 또는 타오바오 링크 붙이기, 또는 Excel로 일괄 가져오기. 가격은 직접 설정.",
    "约 1 小时": "약 1시간",
    "出第一单": "첫 주문 생성",
    "把链接发到你已有的群或朋友圈，或者让 AI 帮你发到海外渠道。": "기존 그룹이나 친구들에게 링크 공유, 또는 AI에게 해외 채널로 보내도록 요청.",
    "看你自己": "당신의 선택",
    "不用一次全准备好": "한 번에 모든 준비 필요 없음",
    "很多人以为要先把货备齐、把公司注册好、把英文练好。其实": "많은 사람들이 먼저 재고를 준비하고, 회사를 등록하고, 영어를 잘해야 한다고 생각합니다. 사실은 그렇지 않으며",
    "先上十个商品试一个月": "먼저 10개 상품으로 한 달 동안 시도해보세요",
    "，你会发现问题根本不在这些地方。": "문제의 근본은 여기에 있지 않다는 것을 알게 될 거예요.",
    "先开一间，比想清楚更重要": "먼저 시작하는 것이 더 중요해요.",
    "免费的，不绑卡。跑通一单再决定要不要花钱。": "무료로 이용 가능하며 카드 등록이 필요 없습니다. 한 번 주문을 완료한 후 돈을 지불할지 결정하세요.",
    "给海外卖家": "해외 판매자를 위한",
    "在中国的货架上选品": "중국의 상품 선정",
    "在你自己的店里卖": "자신의 가게에서 판매",
    "不用飞中国、不用懂中文、不用先压一批货。": "중국으로 가지 않아도, 중국어를 몰라도, 미리 재고를 확보하지 않아도 됩니다.",
    "你选好商品，": "상품을 선택하면,",
    "采购、检查、打包、发货我们来做": "구매, 검수, 포장, 배송은 우리가 책임집니다.",
    "免费开店，先挑 3 件商品试试": "무료로 가게를 열고 3개의 상품부터 시작해 보세요.",
    "先看看店长什么样": "가게의 모습을 먼저 확인해 보세요.",
    "一件代发 · 不压库存 · 佣金低至 3%": "하나씩 발주 · 재고 없음 · 수수료 최저 3%",
    "订单": "주문",
    "物流": "물류",
    "设置": "설정",
    "待处理": "처리 대기 중",
    "运输中": "배송 중",
    "已签收": "수령 완료",
    "物流全程可查": "전체 물류 과정 확인 가능",
    "燕文 · 4PX · 集运合箱": "Yanwen · 4PX · 합동 운송",
    "中国的货架上有什么、怎么运到你手上，": "중국의 선반에 무엇이 있는지, 어떻게 당신에게 배송되는지,",
    "往下翻都能看到": "아래로 스크롤하면 모두 볼 수 있습니다",
    "。先看你在第一步卡在哪。": ". 먼저 첫 단계에서 어디서 막혔는지 확인하세요.",
    "从选品到客户收到货": "상품 선택부터 고객이 상품을 받는까지",
    "这几步，我们替你做了": "이 몇 단계를 우리가 대신 해드립니다",
    "想卖中国货，不知道找谁拿货？": "중국 상품을 판매하고 싶지만, 어디서 구할지 모르겠나요?",
    "打开商品库，按品类、价格、销量筛。每件商品都有实拍图和规格，看中的直接加进你的店。": "상품 라이브러리를 열고, 카테고리, 가격, 판매량으로 필터링하세요. 각 상품에는 실제 사진과 사양이 있으며, 마음에 드는 상품은 바로 가게에 추가할 수 있습니다.",
    "不用自己跑工厂、不用加中间商": "직접 공장에 가지 않아도 되며, 중간 유통업자를 거치지 않아도 됩니다",
    "不会中文，怎么跟供应商谈？": "중국어를 모르면, 어떻게 공급업체와 협상하나요?",
    "不用谈。下单、检查、安排发货都由平台完成，你只跟平台说你的语言。": "협상할 필요 없습니다. 주문, 검수, 발송은 플랫폼에서 처리하며, 당신은 플랫폼과 당신의 언어로만 소통하면 됩니다.",
    "全程不需要一句中文": "전 과정에서 중국어가 필요 없습니다",
    "怕压一批货卖不掉？": "대량 구매 후 재고가 남아 팔리지 않을까 걱정되나요?",
    "一件代发。客户在你的店下单，我们才去采购和发货，你手上不压库存，也不占资金。": "드롭시핑. 고객이 당신의 가게에서 주문하면, 그때 우리는 구매와 발송을 진행합니다. 재고를 보유하지 않고, 자금을 차지하지 않습니다.",
    "零库存起步，卖不动不亏钱": "재고 없이 시작, 판매가 안 되더라도 손해 없음",
    "怕收到的货跟图片不一样？": "받은 상품이 사진과 다를까 봐 걱정되나요?",
    "商品由平台审核后进入商品库，出库前检查。坏损、错发按平台规则处理，不用你自己去跟工厂扯。": "플랫폼에서 검토한 후 상품 라이브러리에 들어갑니다. 출고 전 다시 검사합니다. 파손이나 잘못된 발송은 플랫폼 규칙에 따라 처리되며, 직접 공장과 협의할 필요가 없습니다.",
    "出了问题有人负责": "문제 발생 시 책임자 있음",
    "客户等不及，一直催单？": "고객이 기다릴 수 없어 계속 주문 상태를 묻나요?",
    "国际专线直发，全程可查。客户在你的店里就能看到货走到哪了，不用来问你。": "국제 전용선으로 직접 발송, 전체 과정 추적 가능. 고객은 당신의 가게에서 상품의 위치를 확인할 수 있으므로, 따로 문의하지 않아도 됩니다.",
    "物流进度客户自己看": "물류 진행 상황 고객 스스로 확인",
    "收款要等多久，平台抽多少？": "결제금액을 받는 데 얼마나 걸리고, 플랫폼 수수료는 얼마인가요?",
    "客户用他们习惯的方式付款。平台不从你的销售里抽成，卖多少你收多少。": "고객은 그들이 익숙한 방식으로 결제합니다. 플랫폼은 판매에서 수수료를 부과하지 않으므로, 판매한 금액 전부를 받게 됩니다.",
    "佣金按阶梯，最高也只 6%": "수수료는 단계별로 적용되며, 최대 6%입니다.",
    "这一段叫「第一公里」": "이 부분을 '첫 마일'이라고 합니다.",
    "把货送出中国，是别人的问题": "상품을 중국 밖으로 보내는 것은 다른 사람의 문제입니다.",
    "把货从工厂弄到你手上，才是你的问题": "공장에서 당신에게 상품을 보내는 것이 당신의 문제입니다.",
    "紫色是我们替你办的，灰色是你只需要做的那一步。": "보라색은 우리가 대신 처리하는 부분이고, 회색은 당신이 해야 하는 단계입니다.",
    "中国工厂": "중국 공장",
    "按你的选品采购": "선택하신 제품에 따라 구매",
    "先验资质再下单": "자격 확인 후 주문",
    "平台仓": "플랫폼 창고",
    "入库验货、称重、拍照": "입고 검사, 무게 측정, 사진 촬영",
    "不合格直接退回": "불합격 시 바로 반품",
    "国际段": "국제 구간",
    "燕文 / 4PX 专线": "Yanwen / 4PX 전용선",
    "或集运合箱": "또는 합동 운송",
    "你的店": "당신의 가게",
    "价格你定": "가격은 당신이 정합니다",
    "品牌是你的": "브랜드는 당신의 것입니다",
    "你的客户": "당신의 고객",
    "下单、付款、收货": "주문, 결제, 수령",
    "数据留在你后台": "데이터는 당신의 백엔드에 남아 있습니다",
    "紫色：我们替你办": "보라색: 저희가 대신 처리해드립니다",
    "灰色：你只需要做这一步": "회색: 이 단계만 진행하시면 됩니다",
    "两档做法": "두 가지 방법",
    "先轻后重：先代发跑通，再备货放大": "먼저 가볍게 시작: 드롭시핑으로 테스트한 후 재고 확보",
    "同一个店，两种节奏。不用一上来就把钱压进去。": "같은 가게, 두 가지 속도. 처음부터 많은 돈을 투자할 필요 없습니다.",
    "一件代发": "드롭시핑",
    "轻": "가볍게",
    "客户在你的店下单，我们采购、验货、出国际单，一直送到他手上。你只需要把商品挂上去。": "고객이 당신의 가게에서 주문하면, 저희가 구매, 검수, 국제 배송까지 책임집니다. 상품만 등록하시면 됩니다.",
    "零库存、零资金占用，卖不动就换品": "재고 없음, 자금 점유 없음, 판매가 잘 안 되면 다른 상품으로 변경 가능",
    "单件成本高一点，但不用赌": "단일 제품 비용은 조금 높지만, 큰 위험 없음",
    "适合新店、新品、没试过的品类": "신규 가게, 신상품, 시도해보지 않은 카테고리에 적합",
    "适合：": "적합한 경우:",
    "还没验证过的品": "아직 검증되지 않은 상품",
    "备货到本地": "현지로 재고 보관",
    "重": "무겁게",
    "卖得动的品批量采购，走集运合箱或海外仓，单件成本和到货时间都压下来。": "판매가 잘되는 상품은 대량으로 구매하여 집하 운송 또는 해외 창고를 이용, 단일 제품 비용과 배송 시간을 줄입니다.",
    "单件成本更低，利润更厚": "단일 제품 비용이 더 낮아, 이익이 더 큼",
    "到货更快，客户体验和复购更好": "배송이 더 빠르고, 고객 경험과 재구매율이 좋아짐",
    "需要一点备货资金和仓位": "일부 재고 자금과 창고 공간이 필요합니다",
    "已经卖稳的爆款": "이미 잘 팔리는 베스트셀러",
    "不懂中文也能管店": "중국어를 몰라도 가게 관리 가능",
    "18 位 AI 员工，替你处理日常": "18명의 AI 직원, 일상 업무 처리",
    "商品、订单、增长、经营四组，按需订阅，不需要一次全开。": "상품, 주문, 성장, 운영 4개 그룹, 필요에 따라 구독, 모두 활성화할 필요 없음.",
    "你不用雇人，也不用学会中文后台": "직원 고용하거나 중국어 백오피스 배울 필요 없음",
    "——它们用你市场的语言干活。": "- 고객의 시장 언어로 작업합니다.",
    "商品文案官": "상품 카피라이터",
    "用目标市场的语言写标题和描述，不是机翻": "목표 시장 언어로 제목과 설명 작성, 기계 번역 아님",
    "AI 客服": "AI 고객 지원",
    "7×24，用客户的语言回复，常见问题直接解决": "7×24, 고객 언어로 답변, 일반적인 문제 직접 해결",
    "选品助手": "상품 선택 도우미",
    "看哪些品在你的市场真的卖得动": "당신의 시장에서 실제로 잘 판매되는 상품 확인",
    "经营日报": "운영 일일 보고서",
    "今天发生了什么，明天该做什么": "오늘 무엇이 있었는지, 내일 무엇을 해야 하는지",
    "三步，不用先付钱": "세 단계, 먼저 돈 지불하지 않아도 됨",
    "第一步": "첫 번째 단계",
    "注册开店": "가게 등록",
    "几分钟注册，不需要信用卡。店名和域名随时能改。": "몇 분 만에 등록, 신용카드 필요 없음. 가게 이름과 도메인은 언제든 변경 가능.",
    "约 5 分钟": "약 5분",
    "第二步": "두 번째 단계",
    "挑商品": "상품 선택",
    "从中国商品库挑，或者导入你自己的货源。看中就一键铺到店里。": "중국 상품 목록에서 선택하거나, 직접 공급원을 추가하세요. 마음에 드는 상품은 한 번 클릭으로 가게에 추가할 수 있습니다.",
    "当天能挑完": "당일 완료 가능",
    "第三步": "세 번째 단계",
    "开卖": "판매 시작",
    "客户下单，我们发货。物流他自己能查，售后有人接。": "고객이 주문하면 저희가 배송합니다. 고객은 물류를 직접 확인할 수 있으며, 사후 서비스도 제공됩니다.",
    "0 库存": "0 재고",
    "你在中国，想把货卖出去？": "중국에서 판매하고 싶으신가요?",
    "看这一页 →": "이 페이지를 확인하세요 →",
    "第一公里是最容易低估的一段": "첫 번째 킬로미터는 가장 쉽게 간과되는 구간입니다",
    "工厂到仓、仓到口岸、口岸到干线——": "공장에서 창고, 창고에서 통관, 통관에서 본선까지—",
    "这三段任何一段卡住，后面全乱": "이 세 구간 중 하나라도 문제가 생기면 전체가 혼란스러워집니다",
    "。先把这一段跑顺，再谈增长。": ". 먼저 이 구간을 원활하게 운영한 후 성장을 고려하세요.",
    "你挑货、定价、卖货，货从中国直接到客户手上。": "상품을 선택하고 가격을 책정하여 판매하세요. 상품은 중국에서 직접 고객에게 배송됩니다.",
    "不需要仓库，不需要员工，也不需要会说中文。": "창고나 직원, 중국어 실력이 필요 없습니다.",
    "帮助中心": "도움말 센터",
    "有问题，先在这里找": "먼저 여기서 찾아보세요",
    "常见问题按分类整理好了，搜不到就直接问 AI 客服，它会带着你的问题接着答。": "자주 묻는 질문은 카테고리별로 정리되어 있습니다. 검색이 안 되면 AI 고객센터에 직접 물어보세요, 계속 답변해드립니다.",
    "搜索：怎么改价格、退款怎么处理、忘记密码…": "검색: 가격 변경 방법, 환불 처리, 비밀번호 잊음…",
    "搜索": "검색",
    "常搜：": "자주 찾는 항목:",
    "懒得翻？直接问 AI 客服": "찾기 귀찮으세요? AI 고객센터에 바로 물어보세요",
    "开店、选品、物流、结算都能问，答不上会转人工。": "가게 오픈, 상품 선택, 물류, 결제 등 무엇이든 물어볼 수 있습니다. 답변이 어려우면 실시간 상담으로 연결됩니다.",
    "开始提问": "질문 시작하기",
    "搜不到就直接问 AI 客服，": "검색이 안 되면 AI 고객센터에 직접 물어보세요,",
    "别自己在那儿猜。": "혼자서 추측하지 마세요.",
    "猜错一步，后面要多改三处。": "한 번 잘못 추측하면 나중에 세 군데를 수정해야 합니다.",
    "条": "건",
    "常见问题": "자주 묻는 질문",
    "大家问得最多的这些": "가장 많이 묻는 질문들",
    "当前筛选：": "현재 필터:",
    "清空筛选": "필터 초기화",
    "这条没解决，问 AI 客服": "이 해결책이 도움이 안 되셨나요? AI 고객센터에 문의하세요",
    "没有找到这一条。": "해당 항목을 찾을 수 없습니다.",
    "把这个问给 AI 客服": "AI 고객센터에게 이 질문을 보내주세요",
    "没搜到，已经把「": "검색 결과가 없어요, 이미 「",
    "」发给 AI 客服了，在右下角继续聊。": "」를 AI 고객센터에게 보냈습니다. 오른쪽 아래에서 대화를 계속해보세요.",
    "还没解决": "아직 해결되지 않았습니다",
    "三条路，总有一条能通": "세 가지 길 중 하나는 반드시 통합니다",
    "AI 客服随时在线，工单最慢 4 小时回，邮件适合附合同和证件。": "AI 고객센터는 항상 온라인입니다. 티켓은 최대 4시간 내 응답, 이메일은 계약서와 증명서 첨부에 적합합니다.",
    "开店、选品、物流、结算的常见问题，它当场答；答不上会转人工。": "가게 오픈, 상품 선택, 물류, 결제 관련 자주 묻는 질문은 즉시 답변해드립니다; 답변이 어려우면 실시간 상담으로 연결됩니다.",
    "打开对话": "대화 시작하기",
    "提工单": "티켓 제기",
    "描述清楚问题、附上订单号或截图，一般 4 小时内有人接。": "문제를 자세히 설명하고 주문 번호나 스크린샷을 첨부하면 일반적으로 4시간 내로 답변이 옵니다.",
    "登录后提工单": "로그인 후 티켓 제출",
    "发邮件": "이메일 보내기",
    "适合需要附合同、发票、证件的情况，附件不会丢。": "계약서, 영수증, 증명서 등을 첨부해야 하는 경우에 적합합니다. 첨부파일은 분실되지 않습니다.",
    "写邮件": "이메일 작성",
    "开放接口": "오픈 API",
    "有自己的系统？接进来就行": "자체 시스템이 있나요? 연결하면 됩니다.",
    "商品、库存、订单、物流轨迹都开放了 REST 接口和 Webhook。用 ERP 管货的，可以只同步库存；用自己后台管订单的，可以只拉订单。": "상품, 재고, 주문, 배송 추적 모두 REST API와 Webhook을 지원합니다. ERP로 재고를 관리하는 경우 재고만 동기화할 수 있고, 자체 백엔드로 주문을 관리하는 경우 주문만 가져올 수 있습니다.",
    "REST API，Token 鉴权，支持分页与增量拉取": "REST API, Token 인증, 페이징 및 증분 가져오기 지원",
    "Webhook 推送下单、付款、发货、退款事件": "Webhook으로 주문, 결제, 출고, 환불 이벤트 전송",
    "沙箱环境，不影响正式店铺数据": "샌드박스 환경, 실제 가게 데이터에는 영향 없습니다.",
    "向 AI 客服要接口文档": "AI 고객센터에게 API 문서 요청",
    "接口按": "API는",
    "店铺维度隔离，": "가게 단위로 격리되어 있으며,",
    "一个 Token 只能读自己店的数据。": "하나의 Token은 해당 가게의 데이터만 읽을 수 있습니다.",
    "正常": "정상",
    "店铺前台访问": "가게 프론트 엔드 접근",
    "后台与订单接口": "백엔드 및 주문 API",
    "面单与轨迹回传": "배송 라벨 및 추적 정보 전송",
    "AI 能力": "AI 기능",
    "最近一次异常：10-21 02:10–02:26，物流轨迹回传延迟，已恢复。": "최근 오류: 10-21 02:10–02:26, 배송 추적 지연, 복구 완료.",
    "查看历史": "이전 기록 보기",
    "还是没解决？直接问 AI 客服": "아직 해결되지 않았나요? AI 고객센터에 직접 문의하세요",
    "把店铺编号和截图一起发过去，通常当天就有回复。": "가게 번호와 스크린샷을 함께 보내주시면, 보통 당일에 답변이 옵니다.",
    "还没开店？先开一间再来问": "아직 가게를 열지 않았나요? 먼저 가게를 열고 문의해 주세요",
    "大部分问题，开完店自己就明白了。免费的，不绑卡。": "대부분의 문제는 가게를 연 후에 자연스럽게 이해할 수 있습니다. 무료이며 카드 결제가 필요 없습니다.",
    "看功能": "기능 보기",
    "改价格": "가격 변경",
    "退款": "환불",
    "绑定域名": "도메인 연결",
    "忘记密码": "비밀번호 찾기",
    "物流不更新": "물류 업데이트 없음",
    "不管你在供应链的哪一端": "공급망의 어느 위치에 있든",
    "中国货，卖全球": "중국 제품, 전 세계로 판매",
    "零代码开店 · 多语言商城 · 一键铺货 · 全球收付款": "코드 없이 가게 오픈 · 다국어 쇼핑몰 · 한 번 클릭으로 상품 등록 · 전 세계 결제 수령",
    "建站、翻译、收款、发货、获客，中间这几件麻烦事我们全包了。": "웹사이트 구축, 번역, 결제, 배송, 고객 유치, 이 모든 복잡한 과정을 저희가 책임집니다.",
    "如果你在中国": "만약 중국에 계시다면",
    "我在中国": "저는 중국에 있습니다",
    "要把货卖出去": "상품을 판매하려면",
    "不用会建站、不用懂外语、不用自己发国际快递": "웹사이트 만들기, 외국어, 국제 택배 보내기 등 별도의 지식이 필요 없습니다",
    "如果你在海外": "만약 해외에 계시다면",
    "我在海外": "저는 해외에 있습니다",
    "要卖中国好货": "중국의 좋은 제품을 판매하려면",
    "直连中国供应链，一件代发、不用压货、不用懂中文": "중국 공급망과 직접 연결, 단일 제품 대리 발송, 재고 필요 없음, 중국어 지식 필요 없음",
    "看看能卖什么": "무엇을 판매할 수 있는지 확인해보세요",
    "对号入座": "자신에게 맞는 옵션 선택하기",
    "你在哪一端？两条路都能走通": "당신은 공급망의 어느 위치에 있나요? 두 가지 방법 모두 가능합니다",
    "两端缺的东西正好相反：一头缺把货送出去，一头缺把货弄到手。": "양쪽 끝에서 부족한 것이 정반대입니다: 한 쪽은 상품을 보내내는 것이, 다른 한 쪽은 상품을 확보하는 것이 필요합니다.",
    "两条路都在下面，": "두 가지 방법이 아래에 있습니다,",
    "选你站在的那一端": "당신이 선호하는 쪽을 선택하세요.",
    "往下读就行。选错了也不打紧，开店后随时能改。": "아래로 읽어보세요. 잘못 선택해도 걱정하지 마세요, 가게 오픈 후에도 언제든 변경할 수 있습니다.",
    "中国卖家": "중국 판매자",
    "有工厂或货源，想跳过中间商直接卖给老外": "공장이나 상품 공급원이 있어 중간 유통업자를 건너뛰고 외국인에게 직접 판매하고 싶은 경우",
    "在平台卖了很多年，怕一条规则下来店就没了": "플랫폼에서 오랜 기간 판매해왔지만, 새로운 규칙으로 인해 가게가 사라질까 봐 두려운 경우",
    "主要做国内生意，想有个自己的店，不再把利润分给平台": "주로 국내 사업을 하고 있으며, 플랫폼에 이익을 나누지 않고 자신의 가게를 운영하고 싶은 경우",
    "看中国卖家怎么开始": "중국 판매자가 어떻게 시작하는지 보기",
    "海外卖家": "해외 판매자",
    "在当地已经有客源，想加点中国货但不想先压一批库存": "현지에서 이미 고객이 있지만, 중국 제품을 추가하려고 하면서 재고를 미리 확보하고 싶지 않은 경우",
    "想创业，找不到靠谱的工厂，也不会做网站": "신뢰할 수 있는 공장을 찾지 못하거나 웹사이트 제작이 어려워 창업을 고민하는 경우",
    "已经在做代购或微商，想把手上这些客户搬到一个正式的网站": "대행 구매나 소셜커머스를 이미 하고 있으며, 이러한 고객들을 공식 웹사이트로 옮기고 싶은 경우",
    "看海外卖家怎么开始": "해외 판매자가 어떻게 시작하는지 보기",
    "全链路闭环": "전체 체인 클로즈드 루프",
    "从工厂到客户手上": "공장에서 고객 손에까지",
    "中间这几件麻烦事，我们全包": "이러한 복잡한 과정들은 모두 우리가 처리합니다.",
    "不用再对接七八个系统，一个后台从头管到尾。": "여덟 개의 시스템과 연동할 필요 없이, 하나의 백엔드로 모든 것을 관리하세요.",
    "快速建站": "빠른 사이트 구축",
    "10 分钟，零代码": "10분, 코드 없음",
    "拥有专业品牌独立站": "전문적인 브랜드 독립 사이트를 갖추세요.",
    "海量铺货": "대량 상품 등록",
    "1688 / 淘宝一键采集": "1688 / 타오바오 한 번 클릭 수집",
    "AI 翻译，批量上架": "AI 번역, 대량 업로드",
    "便捷收款": "간편 결제",
    "支持全球主流支付": "글로벌 주요 결제 수단 지원",
    "资金安全直达": "자금 안전 보장",
    "智能物流": "스마트 물류",
    "多仓发货，合箱出库": "다중 창고 출고, 합치기 출고",
    "实时跟踪，全球送达": "실시간 추적, 전 세계 배송",
    "持续运营": "지속적인 운영",
    "数据分析，SEO 优化": "데이터 분석, SEO 최적화",
    "会员管理，长期复购": "회원 관리, 장기 재구매 유도",
    "平台特色": "플랫폼 특징",
    "别的工具卖你一个网站": "다른 도구는 웹사이트 하나만 제공합니다",
    "我们给你一整个团队": "우리는 팀 전체를 제공합니다",
    "建站只是起点。真正难的是三件事：": "웹사이트 구축은 시작일 뿐. 진짜 어려운 건 세 가지입니다:",
    "没人干活、没人看见、货发不出去。": "일할 사람이 없고, 아무도 보지 않고, 상품을 보내지 못하는 것.",
    "18 位员工": "18명의 직원",
    "你睡觉的时候，有人还在改标题、回差评、盯物流": "당신이 자고 있을 때, 누군가는 제목 수정, 부정 리뷰 답변, 물류 확인을 하고 있습니다",
    "每天巡检全店：缺图、缺描述、踩违规词，直接改掉": "매일 매장 전체 점검: 이미지 부족, 설명 부족, 위반 단어, 즉시 수정",
    "按成本、运费和佣金算真实毛利，不靠感觉定价": "실제로 원가, 운송비, 수수료를 기반으로 마진을 계산하여 감으로써 가격을 책정하지 마세요",
    "差评回复、社媒文案、客服话术、对账报告，点一下出稿": "부정적인 리뷰 답변, 소셜 미디어 글, 고객 서비스 대본, 정산 보고서는 한 번 클릭하면 작성됩니다",
    "看看这 18 位员工都干什么": "이 18명의 직원들이 무엇을 하는지 확인해보세요",
    "5 大渠道": "5개의 주요 채널",
    "店建好了没人来 —— 这比建站难十倍": "사이트는 만들었지만 방문자가 없어요 — 이건 사이트 구축보다 10배 어려워요",
    "先诊断再开方：标题还是中文，就先修标题，不急着发内容": "먼저 진단하고 처방하세요: 제목이 아직 중국어라면, 먼저 제목부터 수정하세요. 콘텐츠 게시에 서두르지 마세요",
    "30 天方案拆成每天 2–3 件事，做完打勾": "30일간의 계획을 하루 2-3개의 작업으로 나누고, 완료할 때마다 체크하세요",
    "Google、Meta、TikTok、Snapchat、Microsoft 一站接入，像素有没有生效能自己验": "Google, Meta, TikTok, Snapchat, Microsoft를 한 곳에서 연결하고, 픽셀이 효과적으로 작동하는지 직접 확인하세요",
    "看 30 天推广方案长什么样": "30일간의 프로모션 계획이 어떻게 구성되는지 확인해보세요",
    "零门槛": "누구나 쉽게 시작할 수 있어요",
    "今天就能把淘宝、1688 的货，挂到自己站上卖": "오늘 바로 TaoBao, 1688의 상품을 자신의 사이트에 올려 판매할 수 있어요",
    "一条链接变一个商品页，图、价、规格自动填": "하나의 링크가 하나의 상품 페이지로 변환되며, 이미지, 가격, 사양은 자동으로 채워집니다",
    "买家点「代购下单」跳代购平台，商品链接已经填好": "구매자가 '대행 구매'를 클릭하면 대행 플랫폼으로 이동하며, 상품 링크는 이미 입력되어 있습니다",
    "你只发国内快递，跨境支付和国际物流都不用碰": "국내 택배만 보내면 됩니다. 해외 결제와 국제 물류는 신경 쓰지 않아도 됩니다",
    "看懂这个模式": "이 모델을 이해해보세요",
    "生意做大了，整条链路攥在自己手里": "사업 규모가 커지면 전체 공급망을 자신 손에 쥘 수 있어요",
    "售价里含代购服务费，按比例或按固定金额收": "판매 가격에는 대행 서비스 비용이 포함되며, 비율이나 고정 금액으로 받습니다",
    "入库称重、多个包裹合箱出库，比单件直发省": "입고 시 무게 측정, 여러 패키지를 합쳐 출고하면 단일 항목 직접 발송보다 경제적입니다",
    "燕文、4PX 自动取号出单，轨迹自动回填给买家": "Yanwen, 4PX에서 자동으로 추적번호 발급 및 배송 정보를 구매자에게 자동으로 업데이트합니다",
    "对比它和 BuyLink 的区别": "그것과 BuyLink의 차이점을 비교해보세요",
    "这四件事，建站工具一件都做不了 —— 因为它们需要": "이 네 가지 일은 웹사이트 빌더가 할 수 없습니다 — 왜냐하면 이들은",
    "货源、仓库、承运商和真实数据，": "상품 소스, 창고, 운송업체, 실제 데이터가 필요하기 때문입니다.",
    "不是几段代码。": "코드 몇 줄로 해결할 수 있는 것이 아닙니다.",
    "AI 营销 · 获客": "AI 마케팅 · 고객 유치",
    "流量不是等来的，是一步一步算出来的": "트래픽은 기다려서 오는 것이 아니라 계산해서 얻는 것입니다.",
    "四步，每一步都能看到做完之后的变化。": "네 단계, 각 단계에서 변화를 확인할 수 있습니다.",
    "先说真话": "먼저 진실을 말합시다",
    "商品标题还是中文？站是日语站、描述只有 1/65？先修地基，不急着发内容。": "상품 제목이 여전히 중국어인가요? 사이트는 일본어로, 설명은 1/65만 있나요? 먼저 기초부터 다집시다.",
    "30 天方案": "30일 플랜",
    "按你的品类、市场、库存，拆成每天 2–3 件能做完的小事。": "당신의 카테고리, 시장, 재고에 따라 하루에 2-3개의 작은 작업으로 나눕니다.",
    "AI 出稿": "AI 글쓰기",
    "社媒短文、短视频脚本、营销邮件、活动方案，点一下就有。": "소셜 미디어 게시글, 짧은 동영상 대본, 마케팅 이메일, 프로모션 계획, 한 번 클릭으로 생성됩니다.",
    "第四步": "네 번째 단계",
    "投放追效果": "광고 효과 추적",
    "五渠道接入，商品 feed 自动生成，像素没生效能自己查出来。": "다섯 개의 채널 연결, 상품 피드 자동 생성, 픽셀이 작동하지 않는 경우 직접 확인 가능합니다.",
    "你的 AI 助手可以直接读你的店": "당신의 AI 도우미는 당신의 가게를 직접 읽을 수 있습니다",
    "豆包 · ChatGPT · Claude 接上就能取商品、取方案、存稿件，不用把账号密码交给任何插件": "두바오 · ChatGPT · Claude와 연결하여 상품, 계획, 원고를 가져오고 저장할 수 있으며, 어떤 플러그인에도 계정 비밀번호를 제공할 필요가 없습니다.",
    "看怎么接": "연결 방법 보기",
    "这四步不用一次做完": "이 네 단계를 한 번에 완료할 필요는 없습니다",
    "大部分人卡在第一步：连自己店里有多少条商品描述还是中文都不知道。先把这一步做完，后面三步才有意义。": "대부분의 사람들은 첫 번째 단계에서 막힙니다: 자신의 가게에 얼마나 많은 상품 설명이 중국어로 되어 있는지조차 모릅니다. 먼저 이 단계를 완료한 후, 다음 세 단계가 의미가 있게 됩니다.",
    "想省事就让 AI 先扫一遍，": "AI가 먼저 스캔하도록 하면 편리합니다,",
    "它会把该改的地方列出来。": "수정이 필요한 부분을 일목요연하게 정리해드립니다.",
    "能拿产品事实说清楚的，就不吹数字": "제품의 사실을 바탕으로 설명하며, 숫자를 과장하지 않습니다",
    "种店铺语言": "상점 언어",
    "位 AI 员工": "명 AI 직원",
    "大投放渠道": "대 주요 배포 채널",
    "全部为你现在就能打开后台看到的数字，不是宣传口径。": "현재 백오피스에서 확인할 수 있는 실제 데이터이며, 홍보용이 아닙니다.",
    "准备好把这门生意做起来了吗": "이 사업을 시작할 준비가 되셨나요?",
    "零代码 · 订阅制 · 10 分钟拥有自己的品牌独立站": "코드 없음 · 구독형 · 10분 만에 브랜드 전용 사이트 소유",
    "立即免费开通": "지금 무료로 시작하기",
    "不需要信用卡 · 随时可以关掉": "신용카드 필요 없음 · 언제든 종료 가능",
    "跨境物流": "국경 간 물류",
    "从你手里到客户手里，": "당신의 손에서 고객의 손까지,",
    "中间这一段我们接": "중간 과정은 우리가 책임집니다",
    "头程揽收、报关出境、干线运输、末端派送——": "수취, 통관, 주요 운송, 최종 배송 —",
    "四条线路按货物和时效选": "물건과 시간에 따라 4개의 경로 중 선택",
    "。面单在后台打，轨迹在后台看，出事有人管。": "배송 라벨은 백오피스에서 출력하고, 추적은 백오피스에서 확인하며, 문제가 발생하면 관리합니다.",
    "免费开店，先算一单运费": "무료로 가게 오픈, 우선 한 건의 운임비 계산",
    "看三条线路": "3개의 경로 보기",
    "美线专线 6–9 天": "미국 전용 라인 6–9일",
    "220+ 国家可达": "220+ 국가 도달 가능",
    "全程轨迹可查": "전 과정 추적 가능",
    "以前要加三个货代微信、问四次价格。": "이전에는 세 개의 화물 대행사와 친구맺고, 네 번 가격을 물어봐야 했습니다.",
    "现在一个后台里比价下单": "지금은 한 백오피스에서 가격 비교 후 주문",
    "，单号自动回到订单里。": "트래킹 넘버가 자동으로 주문에 업데이트됩니다.",
    "美线专线参考时效（天）": "미국 라인 참고 소요 시간(일)",
    "可送达国家与地区": "배송 가능한 국가 및 지역",
    "国内揽收仓，就近交货": "국내 수취 창고, 가장 가까운 곳에서 출하",
    "主力承运商实时比价": "주요 운송업체 실시간 가격 비교",
    "以上为常见线路的参考区间，具体时效与价格以系统按重量、目的地、品类算出的报价为准。": "위는 일반적인 라인의 참고 구간이며, 실제 소요 시간과 가격은 시스템이 무게, 목적지, 품목에 따라 계산한 견적으로 결정됩니다.",
    "三条线路": "세 가지 라인",
    "货不一样，走法也不一样": "화물 종류에 따라 방법도 다릅니다",
    "轻小件走小包，多件合一起走集运，卖得快的备到海外仓。三条路可以同时用。": "경량 소포는 소포로, 여러 개를 합쳐서는 집하 운송, 잘 팔리는 것은 해외 창고에 보관. 세 가지 방법을 동시에 사용할 수 있습니다.",
    "直发小包": "직접 발송 소포",
    "一单一发，不用备货。适合刚起步、单量不大、品类还摸不准的时候。": "각 주문마다 별도 발송, 재고 필요 없음. 시작 단계나 주문량이 적고, 품목이 아직 확실하지 않은 경우에 적합합니다.",
    "按克计费，200g 起": "그램 단위 요금, 200g부터",
    "美国 6–9 天 / 欧洲 7–12 天": "미국 6–9 일 / 유럽 7–12 일",
    "带全程跟踪号": "전 과정 추적 번호 제공",
    "适合：单价 $10–60 的轻小件": "적합: $10–60의 경량 소포",
    "集运合箱": "집하 운송",
    "同一个客户买了几件，先到国内仓，去掉外包装合成一箱再发。运费按一箱算，不是按四箱算。": "동일 고객이 여러 개를 구매하면, 국내 창고로 먼저 도착한 후 외부 포장재를 제거하고 한 상자로 합쳐 발송합니다. 운임은 1개 상자 기준으로 계산되며, 4개 상자 기준이 아닙니다.",
    "多件合并，省首重": "여러 개의 주문을 합쳐 첫 무게 절약",
    "免费仓储 30 天": "무료 보관 30일",
    "可代贴标、代加固": "라벨 부착 및 추가 포장 대행 가능",
    "适合：多件订单、批发小单": "적합: 여러 개의 주문, 소량 도매",
    "海外仓备货": "해외 창고 재고 보유",
    "卖得动的款提前备到当地仓，客户下单当天就发。退换也能就地处理。": "인기 있는 제품은 사전에 현지 창고에 보관하여 고객이 주문하는 날 바로 발송할 수 있습니다. 교환 및 반품도 현지에서 처리 가능합니다.",
    "本地派送 2–4 天": "현지 배송 2-4일",
    "支持本地退换地址": "현지 교환/반품 주소 지원",
    "库存和店铺同步": "재고와 가게 동기화",
    "适合：月销 100 单以上的爆款": "적합: 월 100건 이상 판매되는 히트 상품",
    "一件包裹要过五道手": "하나의 패키지가 5단계를 거침",
    "哪一段由谁负责，写清楚了，出问题才知道找谁。": "각 단계별 책임자가 명확하게 표시되어 있어 문제가 발생했을 때 누구에게 연락해야 하는지 알 수 있습니다.",
    "你打包": "당신이 포장",
    "后台打面单": "백오피스에서 송장 출력",
    "贴好交给快递": "택배에 붙이고 전달",
    "收货、验货": "수령 및 검수",
    "合箱、称重": "합치고 무게 측정",
    "报关出境": "통관",
    "资料代填": "서류 작성 대행",
    "清单预申报": "리스트 사전 신고",
    "干线": "간선",
    "空运为主": "주로 항공 운송",
    "按线路排舱": "노선별 선적 배치",
    "末端派送": "최종 배송",
    "当地邮政或快递": "현지 우정 또는 택배",
    "签收信息回传": "수령 정보 전송",
    "报价参考": "가격 참고",
    "什么货、走哪条、多少钱": "무엇을, 어디로, 얼마에",
    "下表按 200g 包裹估算，方便你先算一笔账。": "아래 표는 200g 패키지를 기준으로 추정되어 미리 계산할 수 있습니다.",
    "目的地": "목적지",
    "线路": "노선",
    "参考时效": "참고 소요 시간",
    "200g 参考运费": "200g 참조 요금",
    "可跟踪": "추적 가능",
    "美国": "미국",
    "经济小包": "경제형 소포",
    "8–12 个工作日": "8-12 영업일",
    "¥26 起": "¥26 부터",
    "全程": "전 구간",
    "标准专线": "표준 특송",
    "6–9 个工作日": "6–9 영업일",
    "¥34 起": "¥34부터",
    "英国 / 德国": "영국 / 독일",
    "欧洲专线": "유럽 특송",
    "7–12 个工作日": "7–12 영업일",
    "¥31 起": "¥31부터",
    "日本 / 韩国": "일본 / 한국",
    "东亚专线": "동아시아 특송",
    "3–5 个工作日": "3–5 영업일",
    "¥22 起": "¥22부터",
    "澳大利亚": "호주",
    "澳洲专线": "호주 특송",
    "7–10 个工作日": "7–10 영업일",
    "¥30 起": "¥30부터",
    "中东 / 南美": "중동 / 남미",
    "偏远专线": "원거리 특송",
    "12–20 个工作日": "12–20 영업일",
    "¥45 起": "¥45부터",
    "仅关键节点": "주요 노드만",
    "表内为示意价格，不含燃油与偏远附加费。实际下单时系统按重量、体积重、品类实时报价。": "표시된 가격은 참고용이며, 연료 및 원거리 추가 요금은 포함되지 않습니다. 실제 주문 시 시스템이 무게, 부피, 카테고리에 따라 실시간으로 견적합니다.",
    "轨迹": "트래킹",
    "客户问「我的包裹到哪了」，你不用去翻聊天记录": "고객이 '내 소포 어디에 있나요?'라고 물어볼 때, 대화 기록을 찾아보지 않아도 됩니다",
    "每单都有时间轴，从揽收到签收一条线拉下来。客户在你店里就能自己查，不用来问你。真出问题，系统会比客户先告诉你。": "각 주문마다 시간 축이 있으며, 수령에서 서명까지 한 줄로 표시됩니다. 고객이 직접 매장에서 확인할 수 있으므로 당신에게 물어볼 필요가 없습니다. 문제가 발생하면 시스템이 고객보다 먼저 알려줍니다.",
    "轨迹节点自动回传，中英文对照": "트래킹 노드는 자동으로 전송되며, 영한 대조 제공",
    "超时未更新、清关滞留、派送失败会自动标红": "업데이트 지연, 통관 지연, 배송 실패 시 자동으로 빨간색으로 표시",
    "异常件单独一列，处理完再归位": "이상 사항은 별도의 열로, 처리 후 다시 정렬",
    "Berlin, DE · 由收件人本人签收": "Berlin, DE · 수취인 본인 수령",
    "派送中": "배송 중",
    "Out for delivery · DHL 本地派送": "Out for delivery · DHL 현지 배송",
    "清关完成": "통관 완료",
    "法兰克福口岸放行": "프랑크푸르트 항만 통과",
    "干线运输中": "간선 운송 중",
    "深圳 → 法兰克福，航班已起飞": "Shenzhen → 프랑크푸르트, 비행기 이륙",
    "已入库合箱": "입고 및 합치기 완료",
    "深圳仓 · 2 件合并，减重 0.3kg": "Shenzhen 창고 · 2개 합치기, 0.3kg 감소",
    "出问题怎么办": "문제가 발생하면 어떻게 하나요",
    "丢件、破损、退回来，都有说法": "분실, 파손, 반품 등 모두 처리 가능",
    "跨境最怕的不是出事，是出了事没人认。": "국경 간 거래에서 가장 두려운 것은 문제가 발생하는 것이 아니라, 문제가 발생했을 때 책임을 지는 사람이 없는 것입니다.",
    "丢件赔付": "분실 보상",
    "承运商确认丢失后按申报价值赔付，上限写在报价单里，不用来回扯。": "운송업체가 분실을 확인한 후 신고된 가치에 따라 배상하며, 상한선은 견적서에 명시되어 있습니다.",
    "退换地址": "반품 주소",
    "美国、德国、英国有本地退货地址，客户寄回不用付国际邮费。": "미국, 독일, 영국에는 현지 반품 주소가 있어 고객이 국제 운임을 지불하지 않아도 됩니다.",
    "专人跟进": "전담 담당자 배정",
    "单票超过 15 天没更新，平台会主动开一张工单跟进，不用你催。": "15일 이상 업데이트되지 않은 경우 플랫폼에서 자동으로 티켓을 생성하여 처리합니다. 당신이 채근할 필요가 없습니다.",
    "时效表里的数字是常态，不是承诺": "시간표의 숫자는 일반적인 상황이며 약속이 아닙니다",
    "真卡住了，": "정말로 문제가 발생하면,",
    "先看轨迹再问人": "먼저 추적 정보를 확인하고 사람에게 물어보세요",
    "。九成问题看单号就能定位：清关延误、地址不详、派送失败，轨迹上写得比客服说的清楚。": ". 90%의 문제는 송장 번호로 위치를 파악할 수 있습니다: 통관 지연, 주소 불명확, 배송 실패, 추적 정보가 고객 지원보다 더 명확하게 기록되어 있습니다.",
    "先算一单，再决定走哪条线": "먼저 한 건을 계산한 후 어떤 루트를 선택할지 결정하세요",
    "开店后输入重量和目的地，三条线路的价格和时效会一起列出来。": "매장을 오픈한 후 무게와 목적지를 입력하면 세 가지 루트의 가격과 시간이 함께 나열됩니다.",
    "免费开店试算": "무료로 매장을 열고 시뮬레이션해보세요",
    "看收款怎么走": "결제 방법을 확인하세요",
    "客户怎么付得方便，": "고객이 편하게 결제할 수 있도록,",
    "你就怎么收": "그대로 받으세요",
    "欧美人习惯刷卡、德国人爱用 PayPal、东南亚用本地钱包、中东还在转账——": "유럽과 미국인들은 카드 결제를, 독일인들은 PayPal을, 동남아시아는 현지 지갑을, 중동은 여전히 송금을 선호합니다—",
    "多种收单方式接上就能用": "다양한 결제 방식을 연결하여 사용할 수 있으며,",
    "，后台统一看账。": "백오피스에서 일괄적으로 관리할 수 있습니다.",
    "免费开店，绑定收款": "매장을 무료로 개설하고 결제 수단을 연결하세요",
    "看费率": "수수료 확인",
    "不用自己申请商户号": "상호번호 신청 필요 없음",
    "T+7 自动结算": "T+7 자동 정산",
    "最常被问的是「钱什么时候到我账上」。": "가장 많이 묻는 질문은 '언제 돈이 입금되나요'입니다.",
    "答案写在结算规则里": "정산 규칙에 답이 써 있습니다",
    "，不用发邮件问。": ". 이메일로 물어보지 않아도 됩니다.",
    "种收单方式可选": "선택 가능한 수금 방법",
    "妥投后 7 天可提现": "배송 완료 후 7일 만에 인출 가능",
    "支持提现的币种": "지원되는 통화 종류",
    "T+7 是留出的退款与拒付窗口。已妥投且过了窗口的订单，余额可随时提现。": "T+7은 환불 및 거부 처리를 위한 기간입니다. 배송이 완료되고 해당 기간이 지난 주문의 경우 잔액을 언제든 인출할 수 있습니다.",
    "收单": "수금",
    "客户看到的付款方式，越多越容易成交": "고객이 보는 결제 방법, 많을수록 거래 성사율 높아짐",
    "结账页上少一个支付选项，就可能少一单。常用的这几种，默认都开着。": "결제 페이지에서 하나의 결제 옵션이 부족하면 거래가 줄 수 있습니다. 일반적으로 많이 사용하는 몇 가지는 기본으로 활성화되어 있습니다.",
    "欧美客户最认的一种，有买家保护，争议处理流程成熟。": "유럽과 미국 고객들이 가장 신뢰하는 방식, 구매자 보호와 성숙한 분쟁 처리 절차 제공",
    "覆盖 200+ 国家": "200+ 국가 지원",
    "支持信用卡无账号付款": "신용카드 무계좌 결제 지원",
    "信用卡 / 借记卡": "신용카드 / 체크카드",
    "通过 Stripe 收 Visa、Mastercard、Amex，3D 验证默认开启。": "Stripe를 통해 Visa, Mastercard, Amex 수금, 3D 인증 기본 활성화",
    "支持自动扣款与订阅": "자동 결제 및 구독 지원",
    "拒付率低于纯 PayPal 通道": "순수 PayPal 채널보다 거절률 낮음",
    "本地钱包": "현지 지갑",
    "德国的 Klarna、荷兰的 iDEAL、巴西的 Pix，按市场自动出现。": "독일의 Klarna, 네덜란드의 iDEAL, 브라질의 Pix, 시장에 따라 자동으로 나타납니다.",
    "按客户所在地展示": "고객 위치에 따라 표시",
    "不用单独签约": "별도 계약 필요 없음",
    "收款账户是你自己的": "수취 계좌는 당신의 것입니다",
    "。平台不代收货款，钱从客户直接进你的 PayPal / Stripe 账户，我们不碰这笔钱。": ". 플랫폼은 대신 수취하지 않으며, 돈은 고객에서 직접 PayPal / Stripe 계정으로 들어옵니다, 우리는 이 돈을 건드리지 않습니다.",
    "资金流向": "자금 흐름",
    "一笔钱从客户到你的账上，走四步": "고객에서 당신의 계좌로 돈이 이동하는 4단계",
    "客户付款": "고객 결제",
    "结账页选方式": "결제 페이지에서 방법 선택",
    "按当地币种支付": "현지 통화로 지불",
    "进入你的账户": "당신의 계좌로 입금",
    "订单妥投": "주문 완료",
    "轨迹显示签收": "추적 기록에 서명 확인 표시",
    "开始算 T+7": "T+7 시작",
    "提现到账": "출금 입금",
    "提人民币或外币": "위안화 또는 외화 출금",
    "1–3 个工作日": "1-3 영업일",
    "费率": "수수료",
    "每一笔扣多少，写在明面上": "각 거래에서 얼마나 차감되는지 명확히 표시",
    "通道费由收单机构收，平台不在这上面加价。": "통로 수수료는 수취 기관에서 받으며, 플랫폼은 여기에 가격을 추가하지 않습니다.",
    "收单方式": "결제 수단",
    "参考费率": "참고 수수료",
    "到账时间": "입금 시간",
    "提现费": "출금 수수료",
    "争议处理": "분쟁 처리",
    "约 4.4% + $0.30": "약 4.4% + $0.30",
    "即时到 PayPal 余额": "즉시 PayPal 잔액으로",
    "按提现通道": "출금 경로에 따라",
    "买家保护，180 天": "구매자 보호, 180일",
    "信用卡（Stripe）": "신용카드 (Stripe)",
    "约 2.9% + $0.30": "약 2.9% + $0.30",
    "T+2 到 Stripe 余额": "T+2 Stripe 잔액으로",
    "拒付 15–30 天内申诉": "15-30일 내에 거부 청구",
    "支付宝 / Alipay+": "알리페이 / Alipay+",
    "约 1.2%": "약 1.2%",
    "免": "무료",
    "平台介入": "플랫폼 개입",
    "约 1.5%–2.5%": "약 1.5%-2.5%",
    "按当地规则": "현지 규칙에 따름",
    "Taoify 平台服务费": "Taoify 플랫폼 서비스 수수료",
    "费率为行业常见区间，实际以你与收单机构签约时的条款为准；不同国家、不同卡种会有差异。": "요금은 업계에서 일반적인 범위이며, 실제 요금은 수취 기관과의 계약 조건을 따릅니다. 국가와 카드 종류에 따라 다를 수 있습니다.",
    "风控": "리스크 관리",
    "最怕的不是没单，是收了钱又被退回去": "가장 무서운 것은 주문이 없어서가 아니라, 받은 돈이 다시 환불되는 것입니다.",
    "高风险订单在付款时就会被拦下来——地址和卡不一致、短时间多笔、代理 IP。与其事后申诉，不如事前不接。": "높은 리스크 주문은 결제 시 차단됩니다 - 주소와 카드 불일치, 짧은 시간 내 여러 건, 프록시 IP. 사후 항소보다는 사전에 거절하는 것이 좋습니다.",
    "高风险订单自动标记，可选择暂缓发货": "높은 리스크 주문은 자동으로 표시되어 출하를 연기할 수 있습니다",
    "每笔拒付的申诉材料模板，照着填就行": "각 거부된 거래의 항소 서류 템플릿을 따라 작성하면 됩니다",
    "拒付率接近警戒线时提前提醒，避免被封号": "거부율이 경고선에 가까워지면 미리 알림하여 계정이 정지되는 것을 방지합니다",
    "金额": "금액",
    "风险": "위험도",
    "建议": "제안",
    "低": "낮음",
    "正常发货": "정상 출하",
    "中": "중간",
    "核对地址": "주소 확인",
    "高": "높음",
    "暂缓 · 卡地不符": "연기 · 카드와 주소 불일치",
    "高风险订单不会自动取消，": "높은 리스크 주문은 자동으로 취소되지 않습니다,",
    "决定权还在你": "결정은 당신에게 달려있습니다,",
    "，系统只负责提醒。": "시스템은 단순히 알림만 제공합니다.",
    "提现": "출금",
    "赚的钱，随时能拿出来": "벌어들인 돈, 언제든 가져갈 수 있어",
    "提到银行卡": "은행 계좌로 출금",
    "人民币直接进国内储蓄卡，1–3 个工作日到账，单笔最低 100 元。": "위안화는 직접 국내 저축 카드로 입금되며, 1-3 영업일 내에 입금되며, 최소 100원부터 가능합니다.",
    "留在外币账户": "외화 계정에 보관",
    "美元、欧元、英镑可以留着付广告费、付供应商，不用来回换汇。": "달러, 유로, 파운드는 광고비나 공급업체 지불에 사용할 수 있으므로 환전할 필요가 없습니다.",
    "对账单": "거래 내역서",
    "每笔收入、退款、拒付都有流水，按月导出，报税和记账直接用。": "매출, 환불, 거부된 결제 등 모든 거래 내역이 월별로 제공되어 세금 신고와 회계에 바로 사용할 수 있습니다.",
    "费率这块最容易看漏一句": "요율 부분에서 가장 빠트리기 쉬운 문장이 있습니다",
    "。钱从客户那里直接进你的账户，平台不代收，也就不存在压款、跑路、限额提不出来这些事。": ". 고객으로부터 직접 귀하의 계정으로 입금되기 때문에 플랫폼이 대신 받지 않아, 자금 유예, 도주, 인출 제한 등의 문제가 발생하지 않습니다.",
    "先把收款接上，再谈卖什么": "먼저 결제 수단을 설정하고, 무엇을 판매할지 결정하세요",
    "开店后绑定 PayPal 或 Stripe，当天就能收第一笔钱。": "PayPal이나 Stripe를 매장과 연동하면 당일 첫 거래를 시작할 수 있습니다.",
    "价格": "가격",
    "订阅按店铺收费": "구독료는 매장당 부과",
    "佣金按成交额往下走": "수수료는 거래액에 따라 차등 적용",
    "套餐是固定的工具费，佣金只在你出单时收。": "패키지는 고정된 도구 비용이며, 수수료는 주문이 있을 때만 부과됩니다.",
    "卖得越多，费率越低": "판매량이 많을수록 요율이 낮아집니다",
    "成交额越大费率越低，自动算，不用谈。": "거래액이 클수록 수수료율이 낮아집니다. 자동 계산, 별도 협의 필요 없음.",
    "免费试用": "무료 체험",
    "逐项对比": "항목별 비교",
    "试用不绑卡": "체험 시 카드 등록 필요 없음",
    "月 / 季 / 年随时换": "월/분기/년도 언제든 변경",
    "佣金封顶": "수수료 상한선",
    "先领 {days} 天试用，跑通一单再选档。": "{days} 일간 무료 체험을 먼저 받아보세요, 한 건의 거래를 성사시킨 후에 요금제를 선택하세요.",
    "佣金只有成交才收": "성사된 거래에서만 수수료가 부과됩니다",
    "，没出单一分不收。": ", 판매가 이루어지지 않으면 수수료는 없습니다.",
    "订阅套餐": "구독 패키지",
    "四档，按你开到第几家店来选": "여러분이 몇 번째 가게를 열었는지에 따라 4단계로 구분",
    "价格以美元计，月付 / 季付 / 年付三档同权，只是单价不同。": "가격은 달러로 표시되며, 월간/분기/연간 결제 모두 동일한 권한을 제공합니다. 단가만 다릅니다.",
    "多数人选这个": "대부분의 사람들이 이걸 선택합니다",
    "/ 月": "/ 월",
    "每店限领一次，不绑卡": "매 가게당 한 번만 받을 수 있으며, 카드 등록 없음",
    "季付": "분기 결제",
    "年付": "연간 결제",
    "领试用": "체험 신청",
    "选这个": "이것 선택",
    "价格取自平台计费中心，调整后本页同步。季付按 3 个月、年付按 12 个月计价，中途换档按剩余天数折算。": "가격은 플랫폼 요금 센터에서 가져오며, 조정 후 이 페이지에 동기화됩니다. 분기별 결제는 3개월, 연간 결제는 12개월 기준으로 계산되며, 중간 변경 시 남은 일수에 따라 환산됩니다.",
    "交易佣金": "거래 수수료",
    "成交额越大，抽成越低": "거래액이 클수록 수수료율이 낮아집니다",
    "按店铺自然月成交额（折算美元）命中档位，整月按该档比例计提。没成交就没有佣金。": "매장의 자연 월 거래액(달러로 환산)에 따라 단계가 결정되며, 해당 단계의 비율로 한 달 전체를 계산합니다. 거래가 없으면 수수료가 없습니다.",
    "只对已完成且未退款的订单计提，退款自动冲回。": "완료되고 환불되지 않은 주문에 대해서만 적용되며, 환불 시 자동으로 차감됩니다.",
    "佣金与套餐档位无关，选哪档都是同一套阶梯。": "수수료는 패키지 단계와 무관하며, 어떤 단계를 선택하든 동일한 단계별 체계입니다.",
    "账单每月 1 号出，后台可下载明细，逐单可查。": "매월 1일에 청구서가 발행되며, 백오피스에서 명세서를 다운로드하여 각 항목을 확인할 수 있습니다.",
    "差在哪，一条条看": "차이점을 하나씩 확인해보세요",
    "额度": "한도",
    "月付价格": "월 단위 가격",
    "免费": "무료",
    "季付价格": "분기별 가격",
    "年付价格": "연간 가격",
    "可开店数": "가능한 매장 수",
    "可上架商品": "상품 등록 가능 수",
    "文本翻译": "텍스트 번역",
    "次": "회",
    "图片翻译": "이미지 번역",
    "AI 模板": "AI 템플릿",
    "套": "세트",
    "阶梯，与档位无关": "계단식, 단계와 관련 없음",
    "额度按月计，用完可等次月重置，或升档补足；未用完不结转到下月。": "월별로 할당되며, 사용량이 남아도 다음 달로 이월되지 않습니다. 더 많은 용량이 필요하다면 다음 달을 기다리거나, 등급을 올려서 추가할 수 있습니다.",
    "付钱之前，先把这些问清楚": "결제하기 전에 확인해야 할 사항들",
    "佣金到底怎么算？": "수수료는 어떻게 계산됩니까?",
    "按店铺当月成交额（折算美元）落在哪一档，整月就按那一档的比例计提，档位和费率见上面的阶梯表。退款订单会把对应佣金冲回，不多收。": "매장의 월별 거래액(달러로 환산)이 어느 단계에 해당하는지에 따라 그 달의 수수료율이 결정됩니다. 단계와 수수료율은 위의 단계표를 참조하세요. 환불 주문의 경우 해당 수수료가 차감됩니다, 추가로 부과되지 않습니다.",
    "佣金是按订单金额还是按利润收？": "수수료는 주문 금액으로 계산되나, 혹은 이익으로 계산되나요?",
    "按订单实际成交金额（不含运费和税），不是按你的利润。所以亏钱卖的单也会产生佣金——定价时把这一项算进成本，后台的毛利计算器已经默认扣掉了。": "실제 거래된 주문 금액(운송비와 세금 제외)을 기준으로 수수료가 부과됩니다. 따라서 손해를 보고 판매한 주문에도 수수료가 발생합니다—가격 설정 시 이를 고려하고, 백오피스의 총 이익 계산기는 이미 이를 기본적으로 차감하고 있습니다.",
    "试用结束后会怎样？": "체험 기간 종료 후 어떻게 되나요?",
    "试用期不绑卡、不自动扣费。到期后店铺进入只读状态：商品和订单都还在，但不能接新单，选一档套餐付费后立即恢复。每个店铺只能领一次试用。": "무료 체험 기간 동안 카드 정보 입력 없이 자동 결제도 이루어지지 않습니다. 기간 종료 후 매장은 읽기 전용 상태가 됩니다: 상품과 주문 내역은 유지되지만, 새로운 주문을 받을 수 없습니다. 패키지를 선택하여 결제하면 즉시 정상화됩니다. 각 매장은 한 번만 무료 체험을 이용할 수 있습니다.",
    "可以随时换档或退款吗？": "등급 변경이나 환불은 가능한가요?",
    "可以。升档立即生效，按剩余天数折算差价；降档在下个账期生效，不会立刻断掉额度。月付随时取消，年付 7 天内未使用可全额退。": "네, 가능합니다. 등급 상향은 즉시 적용되며, 남은 일수에 따라 가격 차이가 조정됩니다. 하향은 다음 결제 주기에 적용되며, 즉시 할당량이 중단되는 것은 아닙니다. 월 단위 결제는 언제든 취소 가능하며, 연 단위 결제는 7일 이내 미사용 시 전액 환불 가능합니다.",
    "换套餐，店铺数据会丢吗？": "패키지 변경 시 매장 데이터가 사라질까요?",
    "不会。商品、订单、客户、模板都会保留。降档后超出新额度的部分变成只读，不会删除；再升回来立刻恢复。": "아니요. 상품, 주문, 고객, 템플릿 모두 유지됩니다. 하향 시 새 한도를 초과하는 부분은 읽기 전용으로 변환되지만 삭제되지 않으며, 다시 상향하면 즉시 복원됩니다.",
    "多开店铺怎么算？": "여러 매장을 운영할 때 어떻게 계산되나요?",
    "按套餐给的开店数算，档位越高能开的店越多。每家店独立域名、独立语言、独立客户数据，佣金也按店分别计算档位。": "패키지에 따라 제공되는 매장 개수가 다릅니다. 단계가 높을수록 더 많은 매장을 열 수 있습니다. 각 매장은 독립적인 도메인, 언어, 고객 데이터를 가지며, 수수료도 각 매장별로 단계별로 계산됩니다.",
    "先别挑最贵的": "가장 비싼 것을 골라야 하는 건 아닙니다.",
    "大部分人是": "대부분의 사람들은",
    "先领 {days} 天试用，再选单店版跑一个月": "{days} 일간 무료 체험을 먼저 받아보세요, 그 다음 단일 매장 버전으로 한 달 동안 운영해보세요",
    "，等单量稳定了才升档。升档按天折算，不用重新付一整月。": "거래량이 안정화되면 단계를 올릴 수 있습니다. 단계 상승은 일수에 따라 비례하여 적용되며, 다시 한 달 전체를 지불할 필요는 없습니다.",
    "先试 {days} 天，跑通一单再说": "{days} 일간 무료 체험부터 시작해 보세요, 한 건의 거래를 성사시킨 후에 결정하세요",
    "不绑卡、不自动续费。试用到期店铺只读，数据不会丢。": "카드 등록 없이, 자동 갱신도 없습니다. 체험 기간 종료 후에도 가게는 읽기 전용으로 변경되며 데이터는 유지됩니다.",
    "领 {days} 天试用": "{days} 일간 무료 체험을 받아보세요",
    "还有问题": "더 궁금한 점이 있나요",
    "以上": "이상",
    "月成交额 ＜": "월 거래액 ＜",
    "给想把中国货卖到全世界的人，一个能真正跑通生意的地方。": "중국 제품을 전 세계에 판매하려는 사람들에게 실제로 비즈니스를 운영할 수 있는 플랫폼을 제공합니다.",
    "在线客服": "온라인 고객 서비스",
    "产品": "제품",
    "全部功能": "모든 기능",
    "模板市场": "템플릿 마켓",
    "卖家": "판매자",
    "我在中国 · 把货卖出去": "저는 중국에서 · 상품을 판매합니다",
    "我在海外 · 卖中国好货": "저는 해외에서 · 중국의 좋은 상품을 판매합니다",
    "资源": "리소스",
    "开店教程": "가게 개설 가이드",
    "服务状态": "서비스 상태",
    "联系我们": "연락처",
    "公司": "회사",
    "关于 Taoify": "Taoify 소개",
    "加入我们": "함께 하세요",
    "隐私政策": "개인정보 보호정책",
    "服务条款": "서비스 약관",
    "退款政策": "환불 정책",
    "保留所有权利。": "모든 권리를 보유합니다.",
    "等 20 种语言": "20개 언어",
    "主导航": "주요 네비게이션",
    "语言": "언어",
    "20 种语言 · 买家看自己的母语": "20개 언어 · 구매자는 자신의 모국어로 확인",
    "登录": "로그인",
    "模板中心": "템플릿 센터",
    "用户": "사용자",
    "小店管理": "작은 상점 관리",
    "退出登录": "로그아웃",
    "菜单": "메뉴",
    "欢迎回来": "다시 오신 것을 환영합니다",
    "登录您的账户，继续您的建站之旅": "계정에 로그인하여 웹사이트 구축 여정을 계속하세요",
    "电子邮件": "이메일",
    "示例@mail.com": "예: @mail.com",
    "登录密码": "로그인 비밀번호",
    "还没有账号": "아직 계정이 없으신가요",
    "注册": "회원가입",
    "专业主题网站模板": "전문 테마 웹사이트 템플릿",
    "我忘记登录密码了，怎么重置": "로그인 비밀번호를 잊어버렸어요, 어떻게 재설정할까요?",
    "请输入电子邮件": "이메일을 입력해주세요",
    "请输入登陆密码": "로그인 비밀번호를 입력해주세요",
    "选择店铺类型": "가게 유형 선택",
    "开通即拥有 AI 运营团队，7×24 小时自动管理你的跨境商店": "가입하면 7×24시간 AI 운영팀이 자동으로 크로스보더 상점을 관리합니다",
    "在线商店": "온라인 스토어",
    "不单是建立了一个网站，而是建立了一个完整的、自动履单免维护，并且可无限扩展升级的事业": "단순히 웹사이트를 만드는 것이 아니라, 완전하고 자동 이행 및 유지 보수가 필요 없는 무제한 확장 가능한 사업을 구축합니다",
    "AI 员工代运营": "AI 직원 대운영",
    "开通店铺即配备 AI 运营团队，自动上架商品、回复客户、处理订单，无需招人管理": "상점 개설 시 AI 운영팀이 상품 업로드, 고객 응대, 주문 처리 등을 자동으로 수행하여 인력 관리가 필요 없습니다",
    "AI 跨境获客": "AI 크로스보더 고객 획득",
    "AI 自动生成多语言商品文案与营销素材，智能投放引流，帮你获取全球客户": "AI가 다국어 상품 설명과 마케팅 자료를 자동 생성하고 지능적으로 배포하여 전 세계 고객을 유치합니다",
    "AI 智能客服": "AI 스마트 고객 지원",
    "AI 客服 7×24 小时多语言应答，自动处理售前售后，转化率显著提升": "AI 고객 지원이 7×24시간 다국어 응답을 통해 사전 및 사후 판매를 자동 처리하여 전환율을 크게 향상시킵니다",
    "离开": "나가기",
    "下一步": "다음",
    "店铺模板": "상점 템플릿",
    "上百种精选电商主题模板一键应用，卡片式操作，无需设计能力，快速拥有一个能提现您品牌调性、安全、稳定的在线商店": "수백 가지의 선별된 전자상거래 테마 템플릿을 즉시 적용할 수 있으며, 카드식 조작으로 디자인 능력 없이도 브랜드 성격, 안전성, 안정성을 갖춘 온라인 스토어를 빠르게 만들 수 있습니다",
    "请选择您想要的模板~": "원하는 템플릿을 선택하세요~",
    "全部": "전체",
    "搜索模板名称": "템플릿 이름 검색",
    "最低价": "최저가",
    "最高价": "최고가",
    "筛选": "필터링",
    "重置": "초기화",
    "个模板": "개의 템플릿",
    "选择模板": "템플릿 선택",
    "取消选择": "선택 취소",
    "需付费使用": "유료 사용 필요",
    "可在模板市场购买": "템플릿 마켓에서 구매 가능",
    "预览": "미리보기",
    "后退": "뒤로 가기",
    "完善店铺信息": "상점 정보 완성",
    "填写店铺名称与域名，完成注册即可开店": "상점 이름과 도메인을 입력하고, 등록을 완료하여 상점을 개설하세요",
    "店铺信息": "상점 정보",
    "店铺名称": "상점 이름",
    "创建一个简单好记的店铺名称": "간단하고 기억하기 쉬운 상점 이름 생성",
    "填写您的店铺名称": "상점 이름 입력",
    "店铺域名": "상점 도메인",
    "设置简洁前缀，方便用户检索商店": "사용자 검색을 용이하게 하는 간결한 접두어 설정",
    "字母或数字": "문자 또는 숫자",
    "个人信息": "개인 정보",
    "填写您的电子邮箱": "이메일 주소 입력",
    "店铺密码": "상점 비밀번호",
    "填写您的店铺密码": "상점 비밀번호 입력",
    "邮箱验证码": "이메일 인증 코드",
    "请输入邮箱验证码": "이메일 인증 코드 입력",
    "电话号码": "전화번호",
    "区号": "지역 번호",
    "搜索国家": "국가 검색",
    "填写您的电话号码": "전화번호 입력",
    "我已阅读并同意以下法律文件：": "다음 법적 문서를 읽고 동의합니다:",
    "消费协议": "소비 계약",
    "用户使用协议": "사용자 이용 약관",
    "请先阅读并勾选同意上述法律文件，才能开通店铺": "먼저 위 법적 문서를 읽고 동의 체크해야 상점을 개설할 수 있습니다",
    "创建": "생성",
    "开通": "개설",
    "法律文件": "법적 문서",
    "我已阅读并同意": "읽고 동의함",
    "商城站": "쇼핑몰 사이트",
    "代购站": "대행 구매 사이트",
    "创建一个电子商务网站，帮您在线采购中国商品，系统化订单管理，促进销售并管理您的日常工作。": "전자상거래 웹사이트를 만들어 중국 제품을 온라인으로 구매하고, 체계적인 주문 관리를 통해 판매를 촉진하고 일상 업무를 관리하세요.",
    "请填写有效的域名": "유효한 도메인을 입력해주세요",
    "请填写正确的邮箱": "올바른 이메일을 입력해주세요",
    "请填写有效的电话号码": "유효한 전화번호를 입력해주세요",
    "点击发送验证码": "인증번호 보내기",
    "不支持大写字母，请使用小写字母": "대문자는 지원하지 않습니다. 소문자를 사용해주세요",
    "商店地址要求：4-50个字符，由小写字母、数字和连接符（-）组成，不能以数字或连接符开头或结尾，且不能包含大写字母或空格。": "가게 주소 요구사항: 4-50자, 소문자, 숫자, 하이픈(-)으로 구성되며, 숫자나 하이픈으로 시작하거나 끝나지 않아야 하며, 대문자나 공백은 포함할 수 없습니다.",
    "电话号码需为7-15位数字": "전화번호는 7-15자리의 숫자여야 합니다",
    "电话号码格式正确": "전화번호 형식이 올바릅니다",
    "请填写店铺名称": "가게 이름을 입력해주세요",
    "请填写有效的电子邮箱": "유효한 이메일을 입력해주세요",
    "请填写店铺密码": "가게 비밀번호를 입력해주세요",
    "请填写邮箱验证码": "이메일 인증번호를 입력해주세요",
    "请选择区号": "지역 번호를 선택해주세요",
    "请填写有效的店铺域名": "유효한 가게 도메인을 입력해주세요",
    "请选择店铺模板": "가게 템플릿을 선택해주세요",
    "关于我们": "우리에 대해",
    "让想把中国货卖出去的人，都能自己开一家跨境店": "중국 제품을 판매하고 싶은 사람이라면 누구나 크로스보더 상점을 열 수 있습니다",
    "Taoify 是一套跨境电商 SaaS：开店、装修、商品、订单、物流、收款、AI 客服，都在一个后台里管完。": "Taoify는 크로스보더 전자상거래 SaaS입니다: 상점 개설, 디자인, 상품, 주문, 물류, 결제, AI 고객 지원 모두 하나의 백오피스에서 관리할 수 있습니다.",
    "阶梯佣金，按成交额自动降": "단계별 수수료, 거래액에 따라 자동으로 감소",
    "AI 客服在线接待": "AI 고객 지원이 온라인으로 대응",
    "个后台管完全流程": "하나의 백오피스로 전체 프로세스 관리",
    "我们是谁": "우리는 누구인가요",
    "一支做跨境电商系统出身的团队": "크로스보더 전자상거래 시스템 출신의 팀",
    "不是通用建站工具改出来的，是从代购、集运、清关这些真实环节里长出来的系统。": "일반적인 웹사이트 구축 도구를 수정한 것이 아니라, 배송대행, 통합배송, 통관 등의 실제 과정에서 성장한 시스템입니다.",
    "香港星橋國際貿易有限公司": "홍콩 스타브리지 국제 무역有限公司",
    "跨境行业全链路解决方案软件服务商": "국경을 넘어서 모든 업계의 솔루션 제공 소프트웨어 서비스 회사",
    "公司以互联网信息技术开发与物联网 IOT 服务为核心，为跨境卖家提供从建站到履约的整套工具。": "회사는 인터넷 정보 기술 개발과 IoT 서비스를 핵심으로, 크로스보더 판매자를 위한 웹사이트 구축부터 이행까지의 모든 도구를 제공합니다.",
    "依托自身服务体系与技术团队，我们把店铺系统、商品翻译、跨境物流、收款结算和 AI 客服做成了一条能跑通的链路——卖家不需要自己拼七八个系统。": "자체 서비스 체계와 기술 팀을 바탕으로, 우리는 상점 시스템, 상품 번역, 크로스보더 물류, 결제 정산, AI 고객 지원을 일관된 체계로 만들었습니다. 판매자는 여러 시스템을 조합할 필요가 없습니다.",
    "产品团队长期和一线卖家、物流商、支付机构一起打磨，形成 Taoify 对跨境场景的理解：能落地的功能，比看起来花哨的功能更重要。": "제품 팀은 1차 선 판매자, 물류업체, 결제 기관과 함께 작업하여 Taoify의 크로스보더 환경 이해도를 형성했습니다: 실제로 적용 가능한 기능이 화려해 보이는 기능보다 중요합니다.",
    "店铺与装修": "상점 및 디자인",
    "模板市场 + 可视化装修，装修不用等开发": "템플릿 마켓 + 시각적 디자인, 개발 없이 바로 사용 가능",
    "商品、政策页、店铺界面一起翻，买家看母语": "상품, 정책 페이지, 상점 인터페이스를 함께 번역하여 구매자가 모국어로 볼 수 있도록 합니다",
    "面单、轨迹、异常件在一个后台处理": "송장, 추적, 예외 처리를 하나의 백오피스에서 관리",
    "AI 员工与客服": "AI 직원 및 고객 지원",
    "按你的规则答客户，规则外自动转人工": "고객의 질문에 당신의 규칙대로 답변, 규칙 외의 경우 자동으로 실시간 지원으로 전환",
    "想聊合作、聊方案，直接找人": "협력이나 솔루션에 대해 이야기하고 싶다면 직접 연락하세요",
    "售前问题可以先问 AI 客服，它答不上会转给同事。": "판매 전 문의는 먼저 AI 고객 지원에게 하세요, 답변이 어려운 경우에는 동료에게 연결됩니다.",
    "售前咨询": "판매 전 상담",
    "工作日 9:00–21:00 有人接，急事直接打电话。": "평일 9:00-21:00에 연락 가능, 급한 일은 전화주세요.",
    "合作与入驻": "협력 및 입점",
    "渠道合作、代理、企业采购，发邮件说明来意即可。": "채널 협력, 대리점, 기업 구매 등 관련 사항은 이메일로 문의해 주세요.",
    "开店、选品、物流、结算的问题，随时问。": "가게 개설, 상품 선택, 물류, 정산 등 궁금한 점이 있으면 언제든지 질문해 주세요.",
    "做跨境这件事，我们一直在找懂业务、也愿意把细节做扎实的人。简历发到合作邮箱，标题写清岗位方向。": "크로스보더 비즈니스를 하는 데 필요한 전문 지식과 세부적인 부분을 철저히 처리할 수 있는 인재를 찾고 있습니다. 이력서를 협력 이메일로 보내주시고 제목에 포지션을 명확히 적어주세요.",
    "扫码添加客服": "QR 코드로 고객 서비스 추가",
    "扫码联系我们": "QR 코드로 연락하기",
    "先开一间店，比自己拼系统快": "먼저 한 가게부터 시작해 보세요, 시스템 구축보다 빠릅니다.",
    "免费试用，不绑卡。跑通一单再决定用哪一档。": "무료 체험, 카드 결제 없음. 한 건 완료 후 요금제 선택하세요.",
    "Taoify用户注册协议": "Taoify 사용자 등록 약관",
    "提示：您如需注册或使用 Taoify 平台服务，应当完整阅读并严格遵守《Taoify 用户注册协议》，重点关注免责声明、责任限制、违规处置等内容，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本使用协议约束。": "알림: Taoify 플랫폼 서비스를 등록하거나 사용하려면 《Taoify 사용자 등록 약관》을 전체 읽고 엄격하게 준수해야 합니다. 특히 면책 조항, 책임 제한, 위반 처리 등의 내용에 주목하시기 바랍니다. 본인의 권리, 의무, 사용 규칙 및 위약 책임을 명확히 하십시오. 플랫폼에서 후속적으로 출시되는 모든 새로운 기능, 도구는 본 사용 약관에 의해 구속됩니다.",
    "Taoify有权不定期更新、修改本使用协议里的内容，有权在 Taoify网站上发布更新和修改更新本使用协议。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。": "Taoify는 본 사용 약관의 내용을 주기적으로 업데이트, 수정할 권리를 보유하며, Taoify 웹사이트에서 이러한 업데이트와 수정 사항을 게시할 수 있습니다. 최신 버전은 쇼핑몰 페이지에 통합 게시되므로 정기적으로 약관 업데이트 내용을 확인해 주세요. 약관 수정 내용에 동의하지 않는 경우 즉시 플랫폼의 모든 서비스 사용을 중단해야 합니다.",
    "本协议为《Taoify 服务条款》补充文件，全套文件还包括《Taoify 用户隐私政策》等，其中《Taoify 服务条款》为主协议。本协议约定内容如与《Taoify 服务条款》冲突，以《Taoify 服务条款》为准；针对主协议未予以明确的事项，适用本协议约定。": "본 약관은 《Taoify 서비스 약관》의 보충 문서이며, 전체 세트에는 《Taoify 사용자 개인정보 보호정책》 등이 포함되어 있습니다. 《Taoify 서비스 약관》이 주 약관입니다. 본 약관의 내용이 《Taoify 서비스 약관》과 충돌하는 경우 《Taoify 서비스 약관》이 우선 적용됩니다. 주 약관에서 명확히 규정되지 않은 사항은 본 약관이 적용됩니다.",
    "除本协议明确约定内容以外，双方所有其他权利义务、规则约束均以《Taoify 服务条款》《Taoify 用户使用协议》《Taoify消费协议》等为准。": "본 약관에서 명시적으로 규정되지 않은 모든 기타 권리, 의무, 규칙은 《Taoify 서비스 약관》, 《Taoify 사용자 이용 약관》, 《Taoify 소비 약관》 등에 따릅니다.",
    "完成账户注册，即代表您已充分知晓并自愿接受Taoify 平台所有协议、条款，包括本协议、《Taoify 用户使用协议》《Taoify 服务条款》《Taoify用户隐私政策》《Taoify 消费协议》等。若您不认可Taoify 平台所有协议、条款内容，请立即停止注册。": "계정 등록을 완료하면 Taoify 플랫폼의 모든 약관, 조항, 본 약관, 《Taoify 사용자 이용 약관》, 《Taoify 서비스 약관》, 《Taoify 사용자 개인정보 보호정책》, 《Taoify 소비 약관》 등을 충분히 이해하고 자발적으로 수락한다는 것을 의미합니다. Taoify 플랫폼의 모든 약관, 조항 내용에 동의하지 않는 경우 즉시 등록을 중단하십시오.",
    "定义": "정의",
    "1、本协议通用术语定义均与《Taoify 服务条款》保持一致，不再重复释义，仅针对一件代发、店铺代运营、商品存储作出专项释义。": "1. 본 약관의 일반 용어 정의는 《Taoify 서비스 약관》과 일치하며, 여기서는 다시 설명하지 않으며, 대리 발송, 가맹점 대리 운영, 상품 저장에 대한 특별한 정의만 제공합니다.",
    "2、一件代发服务：指经您书面申请，Taoify平台审批通过，您办理完毕一件代发所需手续（包括但不限于签订协议等）后，Taoify平台为您采购中国境内一个或多个商品并在打包完成后寄送到您的指定收货地址的整个服务流程。": "2. 대리 발송 서비스: 서면 신청 후 Taoify 플랫폼의 승인을 받고, 필요한 절차(계약 체결 등 포함)를 완료한 후, Taoify 플랫폼이 중국 내 하나 이상의 상품을 구매하고 패키징 후 지정된 배송 주소로 보내는 전체 서비스 프로세스를 말합니다.",
    "3、店铺代运营服务：指经您书面申请，Taoify平台审批通过，您办理完毕店铺代运营服务所需手续（包括但不限于签订店铺代运营合同/SOP）后，基于您选择的店铺服务项对您的店铺进行代运营操作的整个过程。": "3. 가맹점 대리 운영 서비스: 서면 신청 후 Taoify 플랫폼의 승인을 받고, 필요한 절차(가맹점 대리 운영 계약/SOP 체결 등 포함)를 완료한 후, 선택한 가맹점 서비스 항목에 따라 가맹점을 대리 운영하는 전체 과정을 말합니다.",
    "4、商品存储服务：指经您书面申请，Taoify平台审批通过，您办理完毕商品存储开通所需手续（包括但不限于您与平台另行签署协议）后，寄送至Taoify仓库的商品提供存储服务。": "4. 상품 저장 서비스: 서면 신청 후 Taoify 플랫폼의 승인을 받고, 필요한 절차(플랫폼과 별도로 체결한 계약 포함)를 완료한 후, Taoify 창고로 보내진 상품에 대한 저장 서비스를 제공합니다.",
    "二、服务内容": "서비스 내용",
    "（一）基础服务": "(1) 기본 서비스",
    "1、建店/关联店铺，支持绑定Shopify/Taoify店铺平台。Taoify为您一键创建独立站店铺，同时Taoify能支持绑定您的独立站店铺并提供选择商品、订单管理、包裹管理和国际物流等全流程电商服务。": "1. 매장 개설/연동, Shopify/Taoify 매장 플랫폼 연동 지원. Taoify는 당신을 위해 독립형 매장을 한 번의 클릭으로 생성하며, 동시에 Taoify는 당신의 독립형 매장과 연동하여 상품 선택, 주문 관리, 패키지 관리, 국제 물류 등 전과정의 전자상거래 서비스를 제공합니다.",
    "2、Taoify为每位用户提供一定的免费次数，您需为超出的次数付费。包括对接的第三方平台，商品搜索/编辑、订单同步到Taoify全球寄送等基础服务。": "2. Taoify는 각 사용자에게 일정한 무료 횟수를 제공하며, 초과된 횟수에 대해서는 요금을 지불해야 합니다. 이에는 연결된 제3자 플랫폼, 상품 검색/편집, 주문 동기화, Taoify 글로벌 배송 등 기본 서비스가 포함됩니다.",
    "3、海量商品搜索、上架，支持中国电商平台(淘宝、天猫、1688)。": "3. 대량의 상품 검색 및 등록, 중국 전자상거래 플랫폼(타오바오, 티몰, 1688) 지원합니다.",
    "（二）增值服务": "(이) 부가 서비스",
    "1、商品采购、仓储打包、国际物流发货过程中发生的商品、包裹等增值服务，包括但不限于到付件代付、修剪线头、商品盘点、商品个性化贴标、EPE泡沫填充物、纸护角卡条、拉伸膜、木架加固等。": "1. 상품 구매, 창고 포장, 국제 물류 발송 과정에서 발생하는 상품 및 패키지 관련 부가 서비스로, 대금 대납, 실 끝자르기, 상품 재고 확인, 상품 개인화 라벨링, EPE 폼 충전재, 종이 보호 모서리, 스트레치 필름, 목재 강화 등이 포함됩니다.",
    "2、店铺运营中增值服务，包括但不限于Taoify为您提供多样化的店铺装修、商品管理、订单管理、店铺搭建托管、产品托管、订单托管、店铺运营托管等。": "2. 가게 운영 중 부가 서비스, Taoify가 제공하는 다양한 가게 인테리어, 상품 관리, 주문 관리, 가게 구축 및 위탁, 제품 위탁, 주문 위탁, 가게 운영 위탁 등 포함但不限于。",
    "3、商品存储。经您书面申请、Taoify 平台审批通过，并另行签署相关协议办妥全部入库手续后，您寄送至 Taoify 仓库的商品方可入库存储。仓储完整收费标准、入库规则、库存管理、催告处置、损毁责任、付费仓储细则等全部权利义务，以双方另行签署的相关协议约定为准。商品自仓库签收当日起享有30天免费存储周期；免费存储到期前3日，平台将通过站内信、绑定邮箱向您发送到期提醒，您可选择将商品出库寄送，或选购付费仓储套餐延长存储期限。若免费存储期限届满后，您未在3日内完成商品出库、亦未办理付费仓储延期，且经平台再次催告后仍未处置滞留商品的，平台有权按照另行签订的协议约定对超期商品统一销毁处理；商品一经销毁无法找回、补发，因逾期未处置产生的全部损失、清运处置费用均由您自行承担，Taoify不承担任何赔偿责任。": "3. 상품 보관. 서면 신청 및 Taoify 플랫폼의 승인을 거친 후, 관련 계약을 체결하고 모든 입고 절차를 완료하면, Taoify 창고로 보내진 상품이 입고되어 보관됩니다. 보관 비용, 입고 규칙, 재고 관리, 처리 알림, 손상 책임, 유료 보관 세부 사항 등 모든 권리와 의무는 양측이 별도로 체결한 계약에 따릅니다. 상품은 창고에서 수령한 날로부터 30일간 무료 보관 기간을 누릴 수 있습니다; 무료 보관 기간 만료 3일 전에, 플랫폼은 사이트 내 메시지와 바인딩된 이메일로 만료 알림을 보내드립니다. 상품을 출고하여 발송하거나, 유료 보관 패키지를 선택하여 보관 기간을 연장할 수 있습니다. 만약 무료 보관 기간이 종료된 후 3일 이내에 상품을 출고하지 않거나, 유료 보관 연장을 처리하지 않고, 플랫폼의 추가 알림에도 불구하고 처리되지 않은 경우, 플랫폼은 별도로 체결한 계약에 따라 초과 상품을 일괄적으로 폐기할 권리를 갖습니다; 상품이 폐기되면 복구나 재발송이 불가능하며, 처리 지연으로 인해 발생하는 모든 손실과 폐기 비용은 고객님의 부담이며, Taoify는 어떠한 배상 책임도 지지 않습니다.",
    "三、注意事项": "삼, 주의사항",
    "1、为了您的账号安全，在使用账号服务时，请您事先自行核实操作规则或谨慎决定是否授权给代运营团队操作。": "1. 계정의 안전을 위해 서비스를 사용할 때는 운영 대행팀에게 권한을 주기 전에 미리 운영 규칙을 확인하거나 신중하게 결정해주세요.",
    "2、您用户账户的使用记录和交易数据等均以我们的系统记录为准，如您对该等数据存有异议的，可及时向我们提出，我们会根据您提供的相关证据积极予以核实。": "2. 귀하의 사용자 계정 이용 기록 및 거래 데이터 등은 모두 당사 시스템 기록을 기준으로 합니다. 해당 데이터에 대해 이의가 있는 경우 신속하게 저희에게 알려주시면, 제공하신 관련 증거를 바탕으로 적극적으로 확인해드리겠습니다.",
    "3、平台可选择以网站公告、电子邮件、站内信等方式向您发送通知。": "3. 플랫폼은 웹사이트 공지, 이메일, 사이트 내 메시지 등의 방법으로 알림을 보내드릴 수 있습니다.",
    "4、为了保护您及他人的合法权益，如您被他人投诉或投诉他人，我们可能会将您的姓名及身份信息和联系方式，企业经营范围和投诉相关内容等提供给第三方，以便及时解决投诉纠纷。": "4. 귀하와 타인의 합법적인 권익을 보호하기 위해, 타인으로부터 불만이 접수되거나 귀하가 타인을 신고하는 경우, 우리는 귀하의 이름, 신원 정보, 연락처, 기업의 영업 범위 및 관련 불만 내용 등을 제3자에게 제공할 수 있습니다. 이를 통해 신속하게 불만 사항을 해결할 수 있습니다.",
    "5、Taoify销售的商品均采购自中华人民共和国，符合中华人民共和国有关商品质量、安全、卫生、环保、标识等标准，可能与您所在国家的标准存在差异或冲突，您须自行辨别并承担相关风险，Taoify平台不承担任何赔偿责任。": "5. Taoify에서 판매하는 상품은 모두 중화인민공화국에서 조달되며, 해당 국가의 품질, 안전, 위생, 환경 보호, 표시 등 관련 기준을 충족합니다. 이는 귀하의 소재지 국가 기준과 다를 수 있으며, 이러한 차이 또는 충돌에 대한 판단과 관련된 위험은 구매자에게 있습니다. Taoify 플랫폼은 어떠한 배상 책임도 지지 않습니다.",
    "6、Taoify销售的商品主要符合中华人民共和国的相关知识产权，但因知识产权的地域性因素影响，可能会侵犯您所在国家的相关知识产权，您须自行辨别并承担相关风险，Taoify平台不承担任何赔偿责任。": "6. Taoify에서 판매하는 상품은 주로 중화인민공화국의 관련 지적재산권을 준수하지만, 지적재산권의 지역성 요인으로 인해 귀하의 국가의 관련 지적재산권을 침해할 수 있습니다. 귀하는 이를 스스로 판단하고 관련 위험을 부담해야 하며, Taoify 플랫폼은 어떠한 배상 책임도 지지 않습니다.",
    "7、如果任何组织或个人认为Taoify网站上的任何内容可能侵犯其知识产权，可以通过在线客服及时通知我们，我们会在收到通知后核实。": "7. Taoify 웹사이트의 내용이 지적 재산권을 침해한다고 생각하는 조직이나 개인은 온라인 고객 서비스를 통해 우리에게 즉시 알려주시기 바랍니다. 알림을 받으면 확인하겠습니다.",
    "四、其他": "기타",
    "1、平台有关条款（包括但不限于本注册协议等）可能会有除中文以外的其他版本。如果不同语言版本的注册协议之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本注册协议条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本注册协议，予以明确排除。": "1. 플랫폼의 관련 조항(본 등록 계약을 포함하되 이에 국한되지 않음)은 중국어 외에도 다른 언어 버전이 있을 수 있습니다. 만약 서로 다른 언어 버전의 등록 계약 간에 차이, 불일치 또는 모호성이 있는 경우, 중국어 텍스트를 기준으로 하며, 다른 언어 버전은 참조용이며 중국어 텍스트의 의미를 반박하거나 변경하는 데 사용될 수 없습니다. 본 등록 계약 조항의 체결, 효력, 해석, 이행 및 분쟁 해결은 중화인민공화국 법률을 준거법으로 하며, 해외 법적 충돌 규칙은 배제됩니다. 《유엔 국제 상품 매매 계약에 관한 협약》은 본 등록 계약에 적용되지 않으며 명시적으로 배제됩니다.",
    "2、因本协议引起或与本协议有关的任何争议，双方应友好协商解决；协商不成的，任何一方均有权向Taoify 平台经营地有管辖权的人民法院提起诉讼。": "2. 본 계약에 기인하거나 관련된 모든 분쟁은 양측이 우호적으로 협의하여 해결해야 합니다; 협의가 이루어지지 않을 경우, 어느 한 측이라도 Taoify 플랫폼 운영 지역의 관할 법원에 소송을 제기할 권리가 있습니다.",
    "3、争议处理期间，除争议事项外，双方应继续履行本协议其他约定。": "3. 분쟁 처리 기간 동안, 분쟁 사항을 제외하고는 양측은 본 계약의 다른 조항을 계속 이행해야 합니다.",
    "4、本协议部分条款被废止、无效或不能执行，并不影响其他条款效力。": "4. 본 계약의 일부 조항이 폐지되거나 무효, 또는 실행 불가능하다고 하더라도, 이는 다른 조항의 효력에 영향을 미치지 않습니다.",
    "商店已经准备就绪": "상점이 준비되었습니다",
    "电子邮箱": "이메일",
    "店铺地址": "상점 주소",
    "请确认基本的商店信息，之后您可以在管理中更改订阅": "기본 상점 정보를 확인해주세요. 이후 관리에서 구독을 변경할 수 있습니다",
    "去修改": "수정하기",
    "进入我的店铺": "내 상점으로 이동",
    "管理后台": "관리자 페이지",
    "查看您的商店业务概述": "상점 비즈니스 개요를 확인하세요",
    "多达": "최대",
    "一键上传到你的商店，销售什么商品由你来决定": "당신의 상점에 한 번 클릭으로 업로드하고, 판매할 상품은 당신이 결정하세요",
    "数10种类付款方式，您的顾客在选择好商品之后，可以选择当地的安全支付方式为您快捷收款": "10여 가지 결제 방법, 고객이 상품을 선택한 후 안전한 현지 결제 방식으로 빠르게 결제 받으세요",
    "灵活的物流渠道选择，把货物安全的交付给您的顾客": "유연한 배송 옵션, 고객에게 상품을 안전하게 배송하세요",
    "简化订单，跟踪付款和查看实时业务，因此您可以更专注于建立您的业务": "주문을 간소화하고, 결제를 추적하며, 실시간 비즈니스를 확인하여 사업에 더 집중하세요",
    "直接在商店里与消费者沟通，提升千倍销量，接触并留住消费者": "상점 내에서 직접 소비자와 소통하여 판매량을 천 배 늘리고, 소비자를 유치하고 유지하세요",
    "点击进入我的店铺": "내 상점으로 이동",
    "激活成功": "활성화 성공",
    "去购物": "쇼핑하러 가기",
    "Taoify消费协议": "Taoify 이용 약관",
    "提示：您如需注册或使用 Taoify平台服务，应当完整阅读并严格遵守《Taoify消费协议》，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本消费协议约束。": "알림: Taoify 플랫폼 서비스를 등록하거나 사용하려면 《Taoify 이용 약관》을 전체 읽고 엄격히 준수해야 합니다. 본인의 권리, 의무, 사용 규칙 및 위약 책임을 명확히 이해하세요. 플랫폼에서 나중에 출시되는 모든 새로운 기능과 도구는 본 이용 약관에 따라 적용됩니다.",
    "Taoify有权不定期更新、修改本消费协议里的内容，有权在 Taoify 网站上发布更新和修改本消费协议。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。": "Taoify는 《Taoify 이용 약관》의 내용을 주기적으로 업데이트하고 수정할 권한이 있으며, Taoify 웹사이트에서 이러한 업데이트와 수정 사항을 게시할 수 있습니다. 최신 버전은 쇼핑몰에서 공개되므로 정기적으로 약관 업데이트 내용을 확인하세요. 약관 수정 내용에 동의하지 않는 경우, 즉시 플랫폼의 모든 서비스 사용을 중단해야 합니다.",
    "本协议为《Taoify服务条款》补充文件，全套文件还包括《Taoify 用户使用协议》《Taoify 用户隐私政策》等，其中《Taoify 服务条款》为主协议。本协议约定内容如与《Taoify 服务条款》冲突，以《Taoify 服务条款》为准；除本协议明确约定内容以外，双方所有其他权利义务、规则约束均以《Taoify 服务条款》《Taoify 用户使用协议》《Taoify 用户隐私政策》等为准。": "본 약관은 《Taoify 서비스 조건》의 보충 문서입니다. 전체 문서에는 《Taoify 사용자 이용 약관》, 《Taoify 개인정보 보호정책》 등이 포함되며, 《Taoify 서비스 조건》이 주 약관입니다. 본 약관의 내용이 《Taoify 서비스 조건》과 충돌하는 경우, 《Taoify 서비스 조건》이 우선합니다. 본 약관에서 명시적으로 규정되지 않은 모든 기타 권리, 의무, 규칙은 《Taoify 서비스 조건》, 《Taoify 사용자 이용 약관》, 《Taoify 개인정보 보호정책》 등에 따릅니다.",
    "您完成账户注册，即代表您已充分知晓并自愿接受Taoify平台所有协议、条款，包括本消费协议、《Taoify 用户使用协议》《Taoify 服务条款》《Taoify用户隐私政策》等。若您不认可Taoify平台所有协议、条款内容，请立即停止注册。": "계정 등록을 완료하면 Taoify 플랫폼의 모든 약관, 조항을 충분히 이해하고 자발적으로 수락하는 것으로 간주합니다. 이는 소비자 약관, 《Taoify 사용자 이용 약관》, 《Taoify 서비스 조건》, 《Taoify 사용자 개인 정보 보호 정책》 등을 포함합니다. Taoify 플랫폼의 모든 약관, 조항에 동의하지 않는 경우 즉시 등록을 중단하십시오.",
    "本协议中所有术语定义，均与《Taoify 服务条款》保持统一，不再重复释义。": "본 협약의 모든 용어 정의는 《Taoify 서비스 약관》과 일치하며, 여기서는 다시 설명하지 않습니다.",
    "一、消费须知": "이용 안내",
    "1、Taoify 将向用户提供 Taoify 官网所展示的电商建站服务、相关的技术支持以及网络支持等服务。用户需按平台公示标准支付对应费用，具体包括但不限于订阅费用、保证金、交易佣金等。": "1. Taoify는 사용자에게 Taoify 공식 웹사이트에서 제공하는 전자상거래 플랫폼 구축 서비스, 관련 기술 지원 및 네트워크 지원 등의 서비스를 제공합니다. 사용자는 플랫폼에서 공시된 기준에 따라 해당 비용을 지불해야 하며, 구독료, 보증금, 거래 수수료 등을 포함하되 이에 국한되지 않습니다.",
    "2、所有服务收费标准都在订购页面予以列明公示，您可自行选择具体服务类型、服务套餐，并按列明的价格支付费用。您可以登录店铺后台，依次点击「后台设置」>「账单」>「账单管理」进行查看付费明细。": "2. 모든 서비스 요금은 주문 페이지에 명시되어 있으며, 특정 서비스 유형과 패키지를 선택하고 명시된 가격으로 비용을 지불할 수 있습니다. 로그인 후 상점 백오피스에서 '백오피스 설정' > '청구서' > '청구서 관리'를 차례로 클릭하여 결제 내역을 확인하실 수 있습니다.",
    "二、服务费用与付费方式": "2. 서비스 비용 및 결제 방법",
    "1、服务费用": "1. 서비스 비용",
    "您可以按照您的需求，根据方案计价选择相应的套餐类型，并根据所选择的套餐类型支付服务费用。": "필요에 따라 다양한 패키지 유형을 선택하고, 선택한 패키지 유형에 따라 서비스 비용을 지불할 수 있습니다.",
    "2、付费方式": "2. 결제 방법",
    "2.1 预付制": "2.1 선불제",
    "2.1.1 店铺订阅费用采用预付模式，系统将在服务到期前5个自然日自动发起续费扣款。续费、扣款失败、退回等完整规则见《Taoify 服务条款》。": "2.1.1 가게 구독료는 선불 방식으로, 서비스 만료 5일 전에 자동으로 갱신 결제가 이루어집니다. 갱신, 결제 실패, 환불 등 전체 규칙은 《Taoify 서비스 약관》을 참조하세요.",
    "2.1.2 保证金采用预付制，用户完成账户注册时，须一次性足额缴纳经营保证金1000元，保证金不得抵扣订阅费、税费。保证金支付、退回等完整规则见《Taoify 服务条款》。": "2.1.2 보증금은 선불제로, 사용자가 계정 등록을 완료할 때 1000원의 운영 보증금을 일시불로 납부해야 합니다. 보증금은 구독료나 세금으로 공제될 수 없습니다. 보증금 지급, 환불 등 전체 규칙은 《Taoify 서비스 약관》을 참조하십시오.",
    "2.1.3 费用支付后，平台提供服务。若因付款异常导致支付中止，您可在商城「后台设置」>「账单」>「账单管理」中查看处理结果，并手工完成支付。": "2.1.3 비용 지불 후, 플랫폼이 서비스를 제공합니다. 결제 이상으로 인해 결제가 중단된 경우, 쇼핑몰의 '관리 설정' > '청구서' > '청구서 관리'에서 처리 결과를 확인하고 수동으로 결제를 완료할 수 있습니다.",
    "2.2 付费": "2.2 결제",
    "2.2.1 佣金": "2.2.1 수수료",
    "2.2.1.1 用户按平台公示标准向平台支付佣金；平台现行阶段暂未计收佣金，具体费率以平台届时公示为准。": "2.2.1.1 사용자는 플랫폼이 공시한 기준에 따라 플랫폼에 수수료를 지불합니다; 현재 단계에서는 플랫폼에서 수수료를 부과하지 않고 있으며, 구체적인 비율은 플랫폼의 공지사항을 따릅니다.",
    "2.2.1.2 Taoify收取的佣金基于订单的付款状态计取，每月销售付款金额以平台后台生成的订单截图为准，若由于后续订单产生退款等，不退还该笔订单的佣金。": "2.2.1.2 Taoify가 부과하는 수수료는 주문의 결제 상태에 따라 결정되며, 매월 판매 결제 금액은 플랫폼 백오피스에서 생성된 주문 스크린샷을 기준으로 합니다. 이후 주문으로 인해 환불이 발생하더라도 해당 주문의 수수료는 반환되지 않습니다.",
    "2.2.1.3 平台于每月月底向用户出具当月付款销售业务的结算报告（包括销售付款金额及相应佣金金额）并交付给用户。用户在收到结算报告后2日内提出异议，若未提出异议视为认可结算报告。用户须于收到结算报告后5日内，单独向平台付清该月佣金。若用户在收到结算报告后2日内提出书面异议的，就无争议佣金须于收到结算报告5日内单独支付。就争议部分双方应自用户提出异议之日起15日内完成对账核对、提供全部业务凭证并确认调整金额；若双方自用户提出异议之日起15日内仍无法就金额达成一致，该期佣金暂按平台原结算报告金额先行支付；后续经核对、调解、诉讼确认差额后，在下一期结算中多退少补。": "2.2.1.3 플랫폼은 매월 말일에 해당 월의 판매 거래 결산 보고서(판매 금액 및 해당 수수료 포함)를 사용자에게 제공합니다. 사용자는 결산 보고서를 받은 후 2일 이내에 이의를 제기해야 하며, 이의가 제기되지 않으면 결산 보고서를 인정한 것으로 간주됩니다. 사용자는 결산 보고서를 받은 후 5일 이내에 해당 월의 수수료를 플랫폼에 지불해야 합니다. 만약 사용자가 2일 이내에 서면으로 이의를 제기한 경우, 분쟁이 없는 수수료는 여전히 5일 이내에 지불해야 합니다. 분쟁 부분에 대해서는 사용자가 이의를 제기한 날로부터 15일 이내에 대조 확인, 모든 거래 증빙 제공, 조정 금액 확인을 완료해야 합니다; 만약 15일 내로 합의에 도달하지 못하면, 해당 기간의 수수료는 플랫폼의 원래 결산 보고서 금액에 따라 우선 지급되며, 이후 대조, 중재, 소송을 통해 차액이 확인된 후 다음 결산에서 조정됩니다.",
    "2.3 其他费用": "2.3 기타 비용",
    "2.3.1 除订阅费用、保证金、佣金外，经用户申请，平台自行内部审核通过后，用户可与Taoify平台另行签约开通后付费模式，签约后用户可以先使用Taoify为您提供的服务，平台再清算您店铺内所产生的费用，并通过线下交易的形式收取。": "2.3.1 구독료, 보증금, 수수료 외에, 사용자의 신청 후 Taoify 플랫폼의 내부 심사 통과 시, 사용자는 Taoify와 별도의 계약을 체결하여 후불 모드를 활성화할 수 있습니다. 계약 체결 후, 사용자는 먼저 Taoify가 제공하는 서비스를 이용한 후, 플랫폼이 가게에서 발생한 비용을 정산하고 오프라인 거래 형태로 수금합니다.",
    "2.3.2 Taoify 后付费的具体流程：用户申请；平台自行内部审核通过；Taoify 在每月结束后通过 Taoify 客服通知您的账单；如您对账单有任何异议的，应于下月15日之前向 Taoify 客服书面提出，未在上述期限提出书面异议的，视为认可该账单及发票。用户须于收到账单后5日内，单独向平台付清。若用户在收到账单后2日内提出书面异议的，就无争议部分须于收到账单5日内单独支付。就争议部分双方应自用户提出异议之日起15日内完成对账核对、提供全部业务凭证并确认调整金额；若双方自用户提出异议之日起15日内仍无法就金额达成一致，该期费用暂按平台原账单金额先行支付；后续经核对、调解、诉讼确认差额后，在下一期结算中多退少补。": "2.3.2 Taoify 후불제의 구체적인 절차: 사용자 신청; 플랫폼 자체 내부 심사 통과; Taoify는 매월 종료 후 Taoify 고객 서비스를 통해 귀하의 청구서를 알립니다; 청구서에 이의가 있는 경우 다음 달 15일까지 Taoify 고객 서비스에 서면으로 제기해야 하며, 위 기간 내에 서면 이의를 제기하지 않은 경우 해당 청구서 및 세금계산서를 인정한 것으로 간주됩니다. 사용자는 청구서 수령 후 5일 이내에 플랫폼에 단독으로 지불해야 합니다. 사용자가 청구서 수령 후 2일 이내에 서면 이의를 제기하는 경우, 분쟁 없는 부분은 청구서 수령 5일 이내에 단독으로 지불해야 합니다. 분쟁 부분에 대해서는 사용자가 이의를 제기한 날로부터 15일 이내에 대조 확인, 모든 거래 증빙 제공, 조정 금액 확인을 완료해야 합니다; 양측이 사용자가 이의를 제기한 날로부터 15일 이내에 금액 합의를 이루지 못하는 경우, 해당 기간의 비용은 플랫폼 원 청구서 금액으로 우선 지불하며; 이후 대조, 중재, 소송을 통해 차액이 확인된 후, 다음 결제 기간에서 보완합니다.",
    "三、费用支付": "비용 지불",
    "1、您必须向平台提供有效可用的支付方式，以避免扣款失败影响店铺使用。建议您绑定多张信用卡并授权使用自动支付。账单支付的技术由第三方专业金融公司提供技术支持。": "1. 플랫폼에 유효하고 사용 가능한 결제 방법을 제공해야 하며, 결제 실패로 인해 가게 이용에 영향을 미치지 않도록 해야 합니다. 여러 장의 신용카드를 등록하고 자동 결제를 허용하는 것을 권장합니다. 청구서 결제 기술은 제3자 전문 금융 회사가 지원합니다.",
    "2、账单生成后，系统将通过您授权的支付方式自动扣款，该扣款流程持续至本服务终止。若您设置默认支付卡，系统将优先从默认卡完成扣费。除另行约定外，所有费用均以美元作为结算及支付币种。": "2. 청구서 생성 후, 시스템은 귀하가 승인한 결제 방법을 통해 자동으로 결제됩니다. 이 결제 프로세스는 본 서비스 종료 시까지 지속됩니다. 기본 결제 카드를 설정하신 경우, 시스템은 기본 카드에서 우선적으로 결제합니다. 별도의 약정이 없는 한, 모든 비용은 미국 달러로 정산 및 결제됩니다.",
    "3、费用将显示在账单上，并通过提供的电子邮件发送至商店所有者。如果您对账单存在疑问，可以与 Taoify 的相关业务部门进行联系。后续将通过电子邮件的形式与您取得联系，账单争议内容将发送至您所提供的店铺财务邮箱。": "3. 비용은 청구서에 표시되며, 제공된 이메일을 통해 상점 소유자에게 발송됩니다. 청구서에 의문이 있는 경우 Taoify 관련 부서와 연락할 수 있습니다. 추후 이메일을 통해 연락하여 청구서 분쟁 내용을 귀하가 제공한 상점 재무 이메일로 보내드립니다.",
    "4、针对 Taoify 自身收取的平台服务费，可联系平台对应业务部门办理，发票将通过邮件发送至您预留的店铺财务邮箱；第三方收取的款项，您应直接对接第三方主体办理，Taoify 可予以必要配合。": "4. Taoify 자체가 부과하는 플랫폼 서비스 요금은 플랫폼 관련 부서에 문의하시면 됩니다. 세금계산서는 귀하가 제공한 상점 재무 이메일로 발송됩니다. 제3자가 부과하는 금액은 직접 해당 제3자와 처리해야 하며, Taoify는 필요한 지원을 제공할 수 있습니다.",
    "5、平台提前30日发出服务费用变更通知后即可调整服务收费标准，平台可通过平台官网公告或您店铺后台管理页面公示的方式送达该通知。": "5. 플랫폼은 서비스 요금 변경 통지를 30일 전에 발송하면 서비스 요금을 조정할 수 있으며, 플랫폼 공식 웹사이트나 귀하의 상점 백오피스 관리 페이지를 통해 해당 통지를 전달할 수 있습니다.",
    "6、平台不就关于服务的任何修改、价格变动、暂停或终止对您或任何第三方承担任何责任。": "6. 플랫폼은 서비스의 어떠한 수정, 가격 변동, 일시 중단 또는 종료로 인해 귀하나 제3자에게 발생하는 책임을 지지 않습니다.",
    "7、若平台无法通过授权银行卡成功扣取订阅费用，将向您所有者发送邮件告知扣款失败，并提示更新支付银行卡。平台每间隔24小时重复发起扣费，总计最多三次扣款尝试（含首次扣款）。第三次扣款仍失败的，平台有权暂停并限制您账户使用权限。您缴清全部未结清款项及下一计费周期订阅费用后，账户方可恢复正常访问权限。": "7. 플랫폼이 승인된 은행 카드를 통해 구독료를 성공적으로 청구할 수 없는 경우, 소유자에게 메일로 청구 실패를 알리고 결제 카드 업데이트를 요청합니다. 플랫폼은 24시간마다 최대 3회(처음 청구 포함) 청구를 시도합니다. 세 번째 청구에도 실패할 경우, 플랫폼은 귀하의 계정 사용 권한을 일시 중지하고 제한할 수 있습니다. 모든 미결제 금액 및 다음 결제 주기 구독료를 납부한 후에야 계정 접근 권한이 정상화됩니다.",
    "8、服务期限届满前您未及时续订阅费用的，服务自动终止；服务关闭满10日用户仍未续订阅费用的，Taoify 平台有权删除网站全部数据，相关损失由用户自行承担。": "8. 서비스 기간 만료 전에 구독료를 적시에 갱신하지 않는 경우, 서비스는 자동으로 종료됩니다. 서비스 종료 후 10일이 지나도록 구독료를 갱신하지 않는 경우, Taoify 플랫폼은 웹사이트의 모든 데이터를 삭제할 권리가 있으며, 관련 손실은 사용자가 부담합니다.",
    "9、Taoify 自行收取的平台服务费不包含各类政府征收的税金、规费及其他收费（本消费协议中统称为\"税费\"）。除平台服务费外，您因订阅、采购 Taoify 产品与服务产生的全部适用税费，均由您自行承担。税费将依据您提供的账单地址适用税率核算，并从您授权支付卡自动扣取。若您具备免税资格，须向平台提交有效免税凭证；部分司法辖区要求提供能够证实免税资质、符合当地法规的官方证明文件，免税政策自材料审核通过之日起生效。若 Taoify 未代为计收相关税费，您必须自行判断自身纳税义务，由您向税务主管机关完成申报缴纳税款。": "9. Taoify가 자체적으로 부과하는 플랫폼 서비스 요금에는 다양한 정부 부과 세금, 수수료, 기타 요금(본 소비 계약서에서 '세금'이라고 통칭)이 포함되지 않습니다. 플랫폼 서비스 요금 외에 Taoify 제품 및 서비스 구독, 구매로 인해 발생하는 모든 적용 세금은 귀하가 부담해야 합니다. 세금은 귀하가 제공한 청구서 주소에 따라 적용되는 세율에 따라 산정되며, 승인된 결제 카드에서 자동으로 청구됩니다. 면세 자격이 있는 경우, 플랫폼에 유효한 면세 증빙을 제출해야 합니다. 일부 사법 관할 지역에서는 면세 자격을 입증하고 현지 법규에 부합하는 공식 증명서를 요구하며, 면세 정책은 자료 검토 통과일부터 적용됩니다. Taoify가 관련 세금을 대신 징수하지 않는 경우, 귀하는 스스로 세무 의무를 판단하고 세무 당국에 신고 및 납세해야 합니다.",
    "10、除 Taoify 代为收取并上缴主管税务机关的税费外，法律法规规定的各类税款扣除、预提代缴义务均由您自行承担，并由您单独向对应税务机关完成缴纳。无论是否存在前述税款扣除或预提要求，Taoify 均有权按照本消费协议约定，从您授权支付卡扣收全部应付费用，但Taoify无主动扣费义务。": "10. Taoify가 대신 징수하고 세무 당국에 납부하는 세금 외에, 법률 및 규정에 따른 모든 세금 공제, 예치금 대납 의무는 귀하가 부담하며, 해당 세무 당국에 단독으로 납부해야 합니다. 이러한 세금 공제 또는 예치금 요구 여부와 관계없이, Taoify는 본 소비 계약서에 따라 승인된 결제 카드에서 모든 지불 가능 금액을 청구할 권리가 있으나, Taoify는 자동으로 청구할 의무는 없습니다.",
    "11、您店铺经营销售行为产生的全部适用税费，均由您自行承担并依法缴纳。": "11. 귀하의 상점 운영 및 판매 활동으로 인해 발생하는 모든 적용 세금은 귀하가 부담하고 법에 따라 납부해야 합니다.",
    "12、平台订阅费用、交易佣金应用费、模板费、罚金等均不支持退款；用户主动注销、中途终止服务、违规封禁账号，已缴纳全部费用不予返还；订单售后退款、退货的，对应订单已扣除佣金不予退还。": "12. 플랫폼 구독료, 거래 수수료, 템플릿 요금, 벌금 등은 환불되지 않습니다. 사용자가 자발적으로 해지하거나, 중도에 서비스를 종료하거나, 위반으로 인해 계정이 차단된 경우, 이미 납부한 모든 비용은 반환되지 않습니다. 주문 후 서비스 환불, 반품의 경우, 해당 주문에서 이미 공제된 수수료는 반환되지 않습니다.",
    "四、罚金政策": "벌금 정책",
    "1、商家应确保及时、准确地处理订单、并将物流单号同步到后台。超时发货的订单采取了严格的处罚措施，具体处罚措施：付款30天内没有上传物流单号，每单额外收取0.5美元罚金。": "1. 판매자는 주문을 적시에 정확하게 처리하고, 배송 트래킹 번호를 백오피스에 동기화해야 합니다. 지연 출고 주문에 대한 엄격한 처벌 조치가 있으며, 구체적인 처벌 조치: 결제 30일 내에 배송 트래킹 번호를 업로드하지 않은 경우, 각 주문당 0.5달러의 추가 벌금이 부과됩니다.",
    "2、对于定制类、预售等可能需要超过30天的类目，须向 Taoify 书面提出申请延长发货申请，审批通过后不予处罚。": "2. 맞춤형, 예약 판매 등 30일 이상 걸릴 수 있는 카테고리는 Taoify에 서면으로 출고 연장을 신청해야 하며, 승인되면 처벌되지 않습니다.",
    "3、Taoify 系统只提供基础建站功能，不提供、不负责买家与用户的资金处理与结算，资金相关的服务由第三方支付机构处理，相应风险由用户承担。": "3. Taoify 시스템은 기본적인 사이트 구축 기능만 제공하며, 구매자와 사용자의 자금 처리 및 정산은 제공하거나 책임지지 않습니다. 자금 관련 서비스는 제3자 결제 기관이 처리하며, 해당 위험은 사용자가 부담합니다.",
    "4、若用户店铺单个自然月超时发货订单满5笔，或同一自然年度内累计超时发货订单满20笔的，用户除按约定向平台支付对应罚金外，平台亦有权依据平台公示协议及规则，暂停店铺经营服务、单方终止双方合作，且用户已向平台缴纳的全部费用不予退还。": "4. 사용자의 상점이 단일 달에 5건 이상, 또는 같은 연도 내에 누적 20건 이상의 지연 출고 주문이 있는 경우, 사용자는 약정대로 플랫폼에 해당 벌금을 지불해야 하며, 플랫폼은 플랫폼 게시 협약 및 규칙에 따라 상점 운영 서비스를 일시 중지하거나, 단방향으로 협력을 종료할 수 있으며, 사용자가 플랫폼에 납부한 모든 비용은 반환되지 않습니다.",
    "五、服务到期或欠款": "서비스 만료 또는 미납",
    "1、服务到期": "1. 서비스 만료",
    "1.1 按时计费": "1.1 시간 기준 요금",
    "1.1.1 免费试用版：服务期限自平台为用户开通试用当日起算，到期未付费自动关闭站点。": "1.1.1 무료 체험판: 서비스 기간은 플랫폼이 사용자에게 체험을 시작한 날부터 계산되며, 기간 종료 시 결제하지 않으면 사이트가 자동으로 닫힙니다.",
    "1.1.2 付费版：服务期自用户支付服务费用付费或套餐支付费用后激活之日起计算，到期时间以店铺后台公示为准。": "1.1.2 유료 버전: 서비스 기간은 사용자가 서비스 비용을 지불하거나 패키지 비용을 지불하여 활성화된 날부터 계산되며, 만료일은 상점 백오피스에 게시된 내용을 따릅니다.",
    "2、按量计费：若您使用的是先付费服务，即先购买服务次数/条数再使用的，在服务项目服务次数/条数在使用过程中消耗至零时，即视为服务到期。": "2. 사용량 기준 요금: 먼저 서비스 횟수/개수를 구매한 후 사용하는 경우, 해당 서비스의 횟수/개수가 0이 되면 서비스가 만료된 것으로 간주됩니다.",
    "第六条 争议解决": "제6조 분쟁 해결",
    "1、平台有关条款（包括但不限于本消费协议等）可能会有除中文以外的其他版本。如果不同语言版本的消费协议之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本消费协议条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本消费协议，予以明确排除。": "1. 플랫폼 관련 조항(본 소비 약관 등 포함)은 중국어 외에도 다른 언어로 제공될 수 있습니다. 서로 다른 언어 버전의 소비 약관 간에 차이, 불일치 또는 모호성이 있는 경우, 중국어 텍스트를 기준으로 하며, 다른 텍스트는 참고용이며 중국어 텍스트의 의미와 충돌하거나 변경할 수 없습니다. 본 소비 약관의 성립, 효력, 해석, 이행 및 분쟁 해결은 중화인민공화국 법률을 준거법으로 하며, 해외 법적 충돌 규칙은 배제됩니다. 《유엔 국제 물품 매매 계약 협약》은 본 소비 약관에 적용되지 않으며 명확히 배제됩니다.",
    "第七条 其他约定": "제7조 기타 약정",
    "1、运营主体：本平台由香港星橋國際貿易有限公司（https://aitaoify.com，以下简称\"Taoify\"或\"平台\"）运营。您可通过邮箱 liutaotao@taocarts.com 或微信号 zzsist666 与平台取得联系。": "1. 운영 주체: 본 플랫폼은 홍콩 스타브리지 국제 무역有限公司（https://aitaoify.com，以下简称\"Taoify\"或\"平台\"）运营。您可通过邮箱 liutaotao@taocarts.com 或微信号 zzsist666 与平台取得联系。",
    "2、未成年人使用：本平台服务面向具有完全民事行为能力的主体。未成年人应在监护人陪同、指导下阅读本协议并在监护人同意后方可注册、使用本平台服务；监护人应就未成年人使用平台的行为承担相应法律责任。": "2. 미성년자의 이용: 본 플랫폼 서비스는 완전한 민사 행위 능력을 가진 주체를 대상으로 합니다. 미성년자는 보호자의 동반과 지도 아래 본 약관을 읽고, 보호자의 동의 후에만 플랫폼 서비스를 등록하고 이용할 수 있으며, 보호자는 미성년자의 플랫폼 이용에 대한 책임을 집니다.",
    "3、知识产权：Taoify平台的商标、标识、页面设计、文案、软件、代码等知识产权均归平台或相关权利人所有，未经书面许可，任何人不得复制、修改、传播或用于商业用途。用户对其自行上传的内容依法享有权利，并保证该内容不侵犯第三方合法权益。": "3. 지식재산권: Taoify 플랫폼의 상표, 로고, 페이지 디자인, 문안, 소프트웨어, 코드 등의 지식재산권은 플랫폼이나 관련 권리 소유자에게 귀속되며, 서면 허가 없이는 누구나 복제, 수정, 전파 또는 상업적 용도로 사용할 수 없습니다. 사용자는 스스로 업로드한 콘텐츠에 대해 법적으로 권리를 가지며, 해당 콘텐츠가 제3자의 합법적인 권리를 침해하지 않음을 보장해야 합니다.",
    "4、通知送达：平台通过您预留的注册邮箱、店铺后台公告、站内消息或短信发出的通知，于发出之日即视为送达。您应保持联系方式有效，因联系方式变更未及时通知平台导致的后果由您自行承担。": "4. 통지 전달: 플랫폼은 사용자가 등록한 이메일, 상점 백오피스 공지, 사이트 내 메시지 또는 문자 메시지를 통해 발송한 통지는 발송일로부터 즉시 전달된 것으로 간주됩니다. 연락처 변경 시 플랫폼에 즉시 알리지 않아 발생하는 결과는 사용자가 책임집니다.",
    "5、完整协议：本协议连同《Taoify 服务条款》《Taoify 用户使用协议》《Taoify 用户隐私政策》构成您与平台之间关于使用本平台服务的完整约定，取代此前双方就同一事项达成的口头或书面约定。": "5. 전체 약관: 본 약관, 《Taoify 서비스 조건》, 《Taoify 사용자 이용 약관》, 《Taoify 사용자 개인정보 보호정책》은 사용자와 플랫폼 간의 플랫폼 서비스 이용에 관한 전체적인 합의를 구성하며, 이전에 같은 사항에 대해 이루어진 구두 또는 서면 합의를 대체합니다.",
    "6、本协议更新日期：2026年1月1日；生效日期：2026年1月1日。": "6. 본 약관 업데이트 날짜: 2026년 1월 1일; 효력 발생일: 2026년 1월 1일.",
    "版权所有": "저작권 소유",
    "Taoify用户隐私政策": "Taoify 사용자 개인정보 보호정책",
    "提示：您如需注册或使用 Taoify平台服务，应当完整阅读并严格遵守《Taoify用户隐私政策》，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本用户隐私政策约束。": "알림: Taoify 플랫폼 서비스를 등록하거나 이용하려면 《Taoify 사용자 개인정보 보호정책》을 완전히 읽고 엄격히 준수해야 하며, 자신의 권리, 의무, 사용 규칙 및 위반 책임을 명확히 이해해야 합니다. 플랫폼에서 추후 출시되는 모든 새로운 기능, 도구는 본 사용자 개인정보 보호정책에 따라 적용됩니다.",
    "Taoify有权不定期更新、修改本用户隐私政策里的内容，有权在 Taoify 网站上发布更新和修改本用户隐私政策。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。": "Taoify는 본 사용자 개인정보 보호정책의 내용을 주기적으로 업데이트, 수정할 권리를 가지며, Taoify 웹사이트에서 이를 발표할 수 있습니다. 최신 버전은 마켓플레이스에 일괄적으로 게시되므로 정기적으로 약관 업데이트 내용을 확인하십시오. 약관 개정 내용에 동의하지 않는 경우, 즉시 플랫폼의 모든 서비스 사용을 중단해야 합니다.",
    "本协议为《Taoify服务条款》补充文件，全套文件还包括《Taoify 用户使用协议》《Taoify消费协议》等，其中《Taoify 服务条款》为主协议。本协议约定内容如与《Taoify 服务条款》冲突，以《Taoify 服务条款》为准；除本协议明确约定内容以外，双方所有其他权利义务、规则约束均以《Taoify 服务条款》《Taoify 用户使用协议》《Taoify消费协议》等为准。": "본 약관은 《Taoify 서비스 조건》의 보충 파일이며, 전체 세트에는 《Taoify 사용자 이용 약관》, 《Taoify 소비 약관》 등이 포함되며, 《Taoify 서비스 조건》이 주요 약관입니다. 본 약관의 내용이 《Taoify 서비스 조건》과 충돌하는 경우, 《Taoify 서비스 조건》을 따릅니다. 본 약관에서 명시적으로 규정되지 않은 모든 다른 권리, 의무, 규칙은 《Taoify 서비스 조건》, 《Taoify 사용자 이용 약관》, 《Taoify 소비 약관》 등을 기준으로 합니다.",
    "您完成账户注册，即代表您已充分知晓并自愿接受Taoify平台所有协议、条款，包括本用户隐私政策、《Taoify 用户使用协议》《Taoify 服务条款》《Taoify消费协议》等。若您不认可Taoify平台所有协议、条款内容，请立即停止注册。": "계정 등록을 완료하면, Taoify 플랫폼의 모든 약관, 조건, 본 사용자 개인정보 보호정책, 《Taoify 사용자 이용 약관》, 《Taoify 서비스 조건》, 《Taoify 소비 약관》 등을 충분히 알고 자발적으로 수락한다는 것을 나타냅니다. Taoify 플랫폼의 모든 약관, 조건 내용에 동의하지 않는 경우, 즉시 등록을 중단하십시오.",
    "一、适用范围": "1. 적용 범위",
    "1、本政策适用于所有注册、访问、使用 Taoify 独立站建站平台的用户（商店所有者、员工账号）；": "1. 본 정책은 Taoify 독립형 사이트 구축 플랫폼에 등록, 방문, 사용하는 모든 사용자(상점 소유자, 직원 계정)에게 적용됩니다.",
    "2、本政策规范两类信息处理：2.1 用户自身注册资质、经营信息；2.2 用户店铺面向境外消费者收集的个人信息；": "2. 본 정책은 두 가지 유형의 정보 처리를 규제합니다: 2.1 사용자의 등록 자격 및 운영 정보; 2.2 사용자 상점이 해외 소비자로부터 수집하는 개인 정보;",
    "3、本政策不适用于其他第三方（如支付、物流、广告服务商），第三方隐私规则由其自身政策约束，与平台无关。": "3. 본 정책은 기타 제3자(결제, 물류, 광고 서비스 제공업체 등)에는 적용되지 않습니다. 제3자의 개인정보 보호 규칙은 해당 기관의 정책에 따라 적용되며, 플랫폼과는 관련이 없습니다.",
    "4、您完成账户注册，将被视为接受、同意、确认：您在自愿下同意向我们披露个人资料；您会遵守本隐私政策的全部条款和限制；您在我们的网站上作登记、资料会被收集；您同意日后我们对隐私政策的任何修改；您同意我们的分公司、附属公司、雇员，就您可能会感兴趣的产品和服务与您联络。": "4. 계정 등록을 완료하면 다음과 같은 사항에 동의한 것으로 간주됩니다: 귀하는 자발적으로 우리에게 개인 정보를 제공합니다; 본 개인정보 보호정책의 모든 조항과 제한 사항을 준수합니다; 당사 웹사이트에서 등록 및 정보가 수집됨에 동의합니다; 향후 개인정보 보호정책의 어떠한 변경에도 동의합니다; 당사의 지사, 계열사, 직원들이 귀하에게 관심 있을 수 있는 제품 및 서비스에 대해 연락할 수 있음에 동의합니다.",
    "二、个人信息的收集": "개인정보 수집",
    "1、收集用户（平台注册用户）信息": "1. 사용자(플랫폼 등록 사용자) 정보 수집",
    "1.1 在您注册我们的服务、获取使用我们的服务或者以其他方式向我们提供信息时，我们会收集您的个人信息。": "1.1 서비스 등록, 이용 또는 기타 방법으로 정보를 제공할 때, 우리는 귀하의 개인 정보를 수집합니다.",
    "1.2 经您同意，我们会收集、管理和监控个人资料。为了向您提供我们的各项服务，您需要提供个人资料，包括但不限于：企业名称、地址、联系电话、邮箱、营业执照、经营资质等，用于账户核验、资质审核、账单通知、售后对接、履约担保。": "1.2 귀하의 동의 하에, 우리는 개인 정보를 수집, 관리, 모니터링합니다. 우리의 다양한 서비스를 제공하기 위해, 귀하는 기업명, 주소, 연락처, 이메일, 사업자등록증, 운영 자격 등 개인 정보를 제공해야 합니다. 이 정보는 계정 확인, 자격 검토, 청구 알림, 사후 지원, 이행 보장 등에 사용됩니다.",
    "1.3 我们收集您访问 Taoify 上的网页的相关数据。我们还会收集有关您访问账号的方式和时间的相关数据，包括您使用的设备和浏览器，网络连接以及您的IP地址、设备型号、登录时间、操作记录等信息，用于账户安全风控、异常登录识别、平台功能优化。": "1.3 Taoify 웹 페이지 방문 시 관련 데이터를 수집합니다. 또한, 귀하가 계정에 접속하는 방식과 시간, 사용하는 기기와 브라우저, 네트워크 연결, IP 주소, 기기 모델, 로그인 시간, 작업 기록 등의 데이터를 수집하여 계정 보안, 비정상적인 로그인 식별, 플랫폼 기능 최적화에 활용합니다.",
    "1.4 我们收集与支付相关信息，包括但不限于支付和处理订单、绑定信用卡等。": "1.4 결제 관련 정보, 예를 들어 주문 결제, 신용카드 바인딩 등을 포함하여 수집합니다.",
    "2、收集用户店铺的终端消费者信息：Taoify 仅作为技术工具存储数据，收集访客姓名、邮箱、电话、收货地址、支付订单、物流信息，用于订单履约、发货售后、订单对账。": "2. 사용자 상점의 최종 소비자 정보 수집: Taoify는 기술 도구로서 데이터를 저장하며, 방문자 이름, 이메일, 전화번호, 배송 주소, 결제 주문, 물류 정보 등을 수집하여 주문 이행, 발송 후 서비스, 주문 대조에 사용합니다.",
    "3、Cookie及非身份信息收集": "3. 쿠키 및 비식별 정보 수집",
    "3.1 我们将通过您的IP地址来收集您的部分非个人化信息，例如您的浏览器性质、操作系统种类、给您提供接入服务的ISP的域名等，以优化在您计算机屏幕上显示的页面。通过收集该信息，我们将进行客流量统计，从而改进网站的管理和服务。": "3.1 IP 주소를 통해 브라우저 성격, 운영 체제 종류, 인터넷 서비스 제공업체(ISP) 도메인 등 일부 비개인화 정보를 수집하여 귀하의 컴퓨터 화면에 표시되는 페이지를 최적화합니다. 이를 통해 트래픽 통계를 수행하고, 웹사이트 관리 및 서비스를 개선합니다.",
    "3.2 Cookies是一种技术，当您访问设有Cookies装置的本网站时，本网站之服务器会自动发送Cookies至您浏览器内，并储存到您的电脑硬盘内，此Cookies便负责记录日后您到访本网站的种种活动、个人资料、浏览习惯、消费习惯、信用记录。": "3.2 쿠키는 기술로, 쿠키 장치가 설치된 본 웹사이트를 방문할 때, 서버가 자동으로 귀하의 브라우저에 쿠키를 보내고, 귀하의 컴퓨터 하드 드라이브에 저장합니다. 이 쿠키는 귀하의 웹사이트 방문 활동, 개인 정보, 브라우징 습관, 소비 습관, 신용 기록 등을 기록합니다.",
    "3.3 运用Cookies技术，本网站能够为您提供更加周到的个性化服务。本网站将会运用Cookies追访您的购物喜好，从而向您提供感兴趣的信息资料或储存密码，以便您造访本网站时不必每次重复输入密码。": "3.3 쿠키 기술을 활용하여, 본 웹사이트는 더 세심한 맞춤형 서비스를 제공할 수 있습니다. 쿠키를 통해 귀하의 쇼핑 취향을 추적하여, 관심 있는 정보 자료를 제공하거나, 암호를 저장하여, 웹사이트 방문 시 매번 암호를 입력하지 않아도 됩니다.",
    "3.4 您可自行在浏览器中关闭、清除 Cookie，关闭后部分平台功能将无法正常使用。": "3.4 브라우저에서 쿠키를 닫거나, 삭제할 수 있으며, 이 경우 일부 플랫폼 기능이 정상적으로 작동하지 않을 수 있습니다.",
    "三、个人信息的用途": "개인정보 활용",
    "通常情况，本网站将采取合理的措施保护您的个人信息，使其避免未经授权的披露。在遵守相关法律的前提下，我们可能会与以下实体（可能包括境内和境外）分享使用您的个人信息。": "일반적으로, 본 웹사이트는 귀하의 개인 정보를 보호하기 위해 합리적인 조치를 취하며, 무단 공개를 방지합니다. 관련 법률을 준수하면서, 우리는 다음 엔티티(국내외 포함)와 귀하의 개인 정보를 공유할 수 있습니다.",
    "1、供应商：包括但不限于为了满足您网站需求的供货商、软件商、结汇收款、仓储物流、活动展会服务、代理商等。这些供应商可能根据需要与您联系，以完成相关产品服务；": "1. 공급업체: 귀하의 웹사이트 요구사항을 충족시키기 위한 공급업체, 소프트웨어 업체, 환전 및 수금, 창고 및 물류, 행사 및 전시회 서비스, 대리점 등. 이러한 공급업체는 필요한 경우 귀하와 연락하여 관련 제품 서비스를 완료할 수 있습니다.",
    "2、金融机构和第三方支付机构：当您预订订单、申请退款、购买保险时，我们会与金融机构或第三方支付机构共享特定的订单信息，当我们认为用于欺诈检测和预防目的实属必要时，我们将进一步和相关金融机构共享其他必要信息，如IP地址等；": "2. 금융 기관 및 제3자 결제 기관: 주문 예약, 환불 신청, 보험 구매 시, 우리는 금융 기관이나 제3자 결제 기관과 특정 주문 정보를 공유합니다. 사기 탐지 및 예방 목적으로 필요하다고 판단될 경우, IP 주소 등 다른 필요한 정보를 추가로 공유할 수 있습니다.",
    "3、业务第三方：我们可能与第三方为您提供产品或者服务，包括快递业务、通讯服务、客户服务、市场推广、广告投放等；": "3. 비즈니스 제3자: 우리는 제품 또는 서비스를 제공하기 위해 택배, 통신, 고객 서비스, 마케팅, 광고 등과 관련된 제3자와 협력할 수 있습니다;",
    "4、我们可能会将来自某项服务的个人信息与来自其他服务的信息结合起来，用于为了给您提供更加个性化的服务使用；": "4. 특정 서비스에서 수집한 개인 정보를 다른 서비스의 정보와 결합하여 더욱 맞춤화된 서비스를 제공할 수 있습니다;",
    "5、经您许可的其他用途。": "5. 귀하의 허가를 받은 다른 용도입니다.",
    "四、个人信息的管理": "사용자 정보 관리",
    "1、客户信息使用限制：作为 Taoify 平台商家，未经您书面明确许可，Taoify 不会主动单独联系您的客户，亦不会利用您店铺客户信息开展营销推广。但是如果我们是从其他渠道获取到您客户的信息，比如客户自己提供给我们，Taoify 可能会联系或向这些客户营销。": "1. 고객 정보 사용 제한: Taoify 플랫폼의 판매자로서, 서면으로 명확히 허용하지 않는 한 Taoify는 귀하의 고객을 개별적으로 연락하거나 귀하의 가게 고객 정보를 마케팅 및 프로모션에 활용하지 않습니다. 그러나 다른 경로를 통해 고객 정보를 얻은 경우, 예를 들어 고객이 직접 제공한 경우에는 Taoify가 해당 고객에게 연락하거나 마케팅할 수 있습니다.",
    "2、信息安全防护措施：Taoify 将落实物理、电子、流程、多维度技术安全防护机制，对平台存储的个人信息采取加密存储、访问权限管控、操作日志留痕等保护手段，防范个人信息泄露、篡改、丢失、非法访问。在我们网站上所搜集的一切资料都由我们所拥有，Taoify 不会向无关第三方共享、出租、出售您及您客户的任何个人信息。": "2. 정보 보안 조치: Taoify는 물리적, 전자적, 절차적, 다차원 기술 보안 방어 메커니즘을 구현하여 플랫폼에 저장된 개인 정보를 보호합니다. 이를 위해 암호화 저장, 접근 권한 관리, 작업 로그 추적 등의 방법을 사용하여 개인 정보의 유출, 변조, 손실, 불법 접근을 방지합니다. 우리 웹사이트에서 수집되는 모든 데이터는 Taoify가 소유하며, Taoify는 관련 없는 제3자와 귀하 및 귀하의 고객의 개인 정보를 공유, 임대, 판매하지 않습니다.",
    "3、网络传输风险提示：互联网传输环境存在固有安全风险，Taoify无法承诺网络传输过程实现绝对无风险。对因未经授权而接触您个人资料所发生的事件平台一概不承担责任，对于产生或导致的任何损失或损害，平台也不负责赔偿。": "3. 네트워크 전송 위험 알림: 인터넷 전송 환경에는 고유한 보안 위험이 있으며, Taoify는 네트워크 전송 과정에서 절대적인 무위험을 보장할 수 없습니다. 무단으로 개인 정보에 접근하는 사건에 대해서는 플랫폼은 책임을 지지 않으며, 발생하거나 초래된 모든 손실이나 피해에 대해서도 배상하지 않습니다.",
    "4、用户自身安全保管义务：您需妥善保管账号、登录密码、员工账号权限、支付相关信息，不得向无关第三方泄露；在公用设备、他人设备登录平台后，务必及时退出登录。因您未妥善保管账号、随意下放员工数据权限、主动泄露信息引发的数据泄漏、财产损失、行政处罚、第三方索赔，全部责任由您自行承担，平台不承担任何责任。": "4. 사용자 본인의 안전한 보관 의무: 계정, 로그인 비밀번호, 직원 계정 권한, 결제 관련 정보를 적절히 보관해야 하며, 관련 없는 제3자에게 누설해서는 안 됩니다. 공용 기기나 타인의 기기에서 플랫폼에 로그인한 후에는 반드시 즉시 로그아웃하십시오. 계정을 적절히 보관하지 않아, 직원 데이터 권한을 함부로 위임하거나, 정보를 스스로 누출하여 발생하는 데이터 유출, 재산 손실, 행정 처벌, 제3자의 청구 등 모든 책임은 사용자가 부담하며, 플랫폼은 어떠한 책임도 지지 않습니다.",
    "5、您对个人信息的自主管理权利：您依法享有个人信息的访问、查阅、更正、补充、限制使用、申请删除等权利。您可在店铺后台「账户设置」中自主编辑更新账户联系邮箱、联系电话、绑定支付卡片等基础信息。您可联系平台客服并提交对应证明材料申请更新营业执照、经营资质、历史备案主体等后台无法直接修改的信息。您可申请平台对非法定留存类个人信息进行删除。若您申请删除业务信息、限制订单/支付/风控所需信息的使用，店铺建站、收款、订单履约、账单推送等基础服务无法正常使用，由此产生的经营损失由您自行承担。": "5. 개인정보의 자주적인 관리 권한: 고객님은 개인정보에 대한 접근, 열람, 수정, 보충, 사용 제한, 삭제 요청 등의 권리를 법적으로 가지십니다. 고객님은 상점 백오피스의 '계정 설정'에서 연락 이메일, 전화번호, 결제 카드 등 기본 정보를 직접 편집하고 업데이트하실 수 있습니다. 영업허가증, 경영 자격, 과거 등록 주체 등 백오피스에서 직접 수정할 수 없는 정보는 플랫폼 고객센터에 연락하여 해당 증빙 자료를 제출하시면 업데이트를 신청하실 수 있습니다. 고객님은 법적 보관 의무가 없는 개인 정보의 삭제를 플랫폼에 요청하실 수 있습니다. 만약 고객님이 사업 정보 삭제, 주문/결제/위험관리에 필요한 정보의 사용 제한을 요청하신다면, 상점 구축, 결제 수령, 주문 이행, 청구서 발송 등 기본 서비스를 정상적으로 이용하실 수 없으며, 이로 인한 경영 손실은 고객님께서 책임지셔야 합니다.",
    "6、配套规则指引：本条未约定的员工数据权限管控、服务注销后信息留存、信息泄露赔付、第三方数据责任等全部事宜，均按照《Taoify 服务条款》《Taoify 用户使用协议》《Taoify 消费协议》执行。": "6. 관련 규정 안내: 본 항목에서 명시되지 않은 직원 데이터 권한 관리, 서비스 해지 후 정보 보유, 정보 유출 배상, 제3자 데이터 책임 등 모든 사항은 《Taoify 서비스 약관》, 《Taoify 사용자 이용 약관》, 《Taoify 구매 약관》에 따라 처리됩니다.",
    "7、信息限制：7.1 平台面向跨境商家，不主动收集未成年人信息，若您店铺收集未成年人信息，由您自行承担合规责任。7.2 用户店铺面向境外消费者收集的境外个人信息，由用户自行满足当地数据出境合规要求，平台仅提供存储技术服务。": "7. 정보 제한: 7.1 플랫폼은 크로스보더 상인을 대상으로 하며, 미성년자의 정보를 적극적으로 수집하지 않습니다. 귀하의 가게에서 미성년자의 정보를 수집하는 경우, 법적 준수 책임은 귀하에게 있습니다. 7.2 사용자의 가게가 해외 소비자로부터 수집하는 해외 개인 정보는 사용자가 해당 지역의 데이터 이전 규정을 준수해야 하며, 플랫폼은 단순히 저장 기술 서비스만 제공합니다.",
    "8、信息储存与留存：服务无论因何种原因终止，您须自行完整留存店铺经营全部资料（包括但不限于订单记录、商品资质、购销合同、品牌授权、物流凭证、客户交易台账、质检报告等）并自行备案存档，我方无义务代为保管、整理、备案任何资料。": "8. 정보 저장 및 보관: 서비스가 어떤 이유로 종료되더라도, 귀하는 상점 운영에 필요한 모든 자료(주문 기록, 상품 자격 증명, 구매 및 판매 계약, 브랜드 인증, 물류 증빙, 고객 거래 대장, 품질 검사 보고서 등)를 완전히 보관하고 자체적으로 기록해야 합니다. 당사는 어떠한 자료도 대신 보관, 정리, 기록할 의무가 없습니다.",
    "五、我们如何共享信息": "다섯째, 우리는 정보를 어떻게 공유하나요",
    "Taoify 对您及您店铺消费者的全部个人信息承担严格保密义务，不会以营销为目的向任何第三方出售、出租、共享您的个人信息。仅在以下法定、约定情形下，可依规共享相关信息：": "Taoify는 귀하와 귀하의 가게 소비자의 모든 개인 정보를 엄격히 보호하며, 마케팅 목적으로 제3자에게 개인 정보를 판매, 임대, 공유하지 않습니다. 단, 법적, 약정된 상황에서 관련 정보를 공유할 수 있습니다：",
    "1、事先取得您明确、书面的同意或授权；": "1. 귀하의 명확하고 서면으로 된 동의 또는 권한을 미리 얻은 경우;",
    "2、依据生效法律文书、监管部门法定调查要求，配合司法、行政机关依法调取；": "2. 법적 문서, 규제 기관의 조사 요구에 따라 사법 및 행정 기관의 합법적인 정보 요청에 협력합니다;",
    "3、向 Taoify 母公司、子公司、全资关联主体共享信息，关联方同样受本隐私政策约束，仅可用于平台配套经营服务，不得对外二次泄露；": "3. Taoify의 모회사, 자회사, 완전 계열사와 정보를 공유하며, 해당 계열사는 본 개인정보 보호정책에 따라 동일하게 구속받으며, 플랫폼 운영 서비스에만 사용되며, 외부로 재누출되어서는 안 됩니다;",
    "4、向可信第三方服务商（支付、物流、风控、建站插件等）提供必要信息，服务商仅能按照 Taoify 指令处理数据，且需遵守同等保密、安全义务，超出服务范围不得使用、披露您的信息；": "4. 신뢰할 수 있는 제3자 서비스 제공자(결제, 물류, 리스크 관리, 웹사이트 플러그인 등)에게 필요한 정보를 제공합니다. 서비스 제공자는 Taoify의 지시에 따라 데이터를 처리해야 하며, 동등한 비밀 유지 및 보안 의무를 준수해야 합니다. 서비스 범위를 넘어서는 귀하의 정보를 사용하거나 공개해서는 안 됩니다;",
    "5、为保护 Taoify、平台其他用户、终端消费者的人身、财产、数据合法权益，确有必要披露相关信息；": "5. Taoify, 플랫폼의 다른 사용자, 최종 소비자의 인신, 재산, 데이터 합법적인 권익을 보호하기 위해 관련 정보를 공개하는 것이 필요할 경우;",
    "6、发生平台合并、收购、业务转让等情形，承接主体将继续受本隐私政策约束，若数据处理规则发生重大变更，平台将提前公示告知您。": "6. 플랫폼이 합병, 인수, 사업 양도 등의 상황이 발생할 경우, 승계 주체는 본 개인정보 보호정책을 준수하게 됩니다. 데이터 처리 방침에 중대한 변경이 있을 경우, 플랫폼은 사전에 공지하여 알려드리겠습니다.",
    "7、用户存在违反中华人民共和国法律法规、平台协议及平台规则的行为；": "7. 사용자가 중화인민공화국 법률, 플랫폼 약관 및 플랫폼 규칙을 위반한 경우;",
    "8、为保护 Taoify、其关联主体、平台其他用户及终端消费者的合法权益。": "8. Taoify, 그 관련 주체, 플랫폼의 다른 사용자 및 최종 소비자의 합법적인 권익을 보호하기 위해.",
    "六、争议解决": "육、분쟁 해결",
    "1、平台有关条款（包括但不限于本用户隐私政策等）可能会有除中文以外的其他版本。如果不同语言版本的用户隐私政策之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本用户隐私政策条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本用户隐私政策，予以明确排除。": "1. 플랫폼 관련 조항(본 사용자 개인 정보 정책 등을 포함하되 이에 국한되지 않음)은 중국어 외에도 다른 언어로 제공될 수 있습니다. 서로 다른 언어 버전의 사용자 개인 정보 정책 간에 어떠한 차이, 불일치 또는 모호성이 있어도 중국어 텍스트를 기준으로 하며, 다른 언어의 텍스트는 참고용이며 중국어 텍스트의 의미와 충돌하거나 변경하는 데 사용되어서는 안 됩니다. 본 사용자 개인 정보 정책 조항의 체결, 효력, 해석, 이행 및 분쟁 해결은 중화인민공화국 법을 준거법으로 하며, 해외 법적 충돌 규칙은 배제됩니다. 《유엔 국제 물품 매매 계약 협약》은 본 사용자 개인 정보 정책에 적용되지 않으며 명시적으로 배제됩니다.",
    "本平台由香港星橋國際貿易有限公司（https://aitaoify.com）运营，联系邮箱：liutaotao@taocarts.com，微信号：zzsist666。本政策更新日期：2026年1月1日。": "본 플랫폼은 홍콩 스타브리지 국제 무역 유한 회사 (https://aitaoify.com)가 운영하며, 연락처 이메일: liutaotao@taocarts.com, WeChat ID: zzsist666입니다. 본 정책 업데이트 날짜: 2026년 1월 1일.",
    "Taoify 服务条款": "Taoify 서비스 약관",
    "提示：您如需注册或使用 Taoify 平台服务，应当完整阅读并严格遵守《Taoify 服务条款》（以下简称\"本服务条款\"），重点关注免责声明、责任限制、违规处置等内容，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本服务条款约束。": "알림: Taoify 플랫폼 서비스를 등록하거나 사용하려면 《Taoify 서비스 약관》(이하 '본 서비스 약관')을 전체 읽고 엄격히 준수해야 합니다. 특히 면책 조항, 책임 제한, 위반 처리 등의 내용에 주목하고, 자신의 권리, 의무, 사용 규칙 및 위약 책임을 명확히 파악해야 합니다. 플랫폼에서 후속적으로 출시되는 모든 새로운 기능과 도구는 본 서비스 약관에 따라 구속됩니다.",
    "Taoify有权不定期更新、修改本服务条款里的内容，有权在 Taoify 网站上发布更新和修改更新本服务条款。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。": "Taoify는 본 서비스 약관의 내용을 주기적으로 업데이트, 수정할 권리가 있으며, Taoify 웹사이트에서 이러한 업데이트와 수정을 게시할 권리가 있습니다. 최신 버전은 쇼핑몰에서 통합적으로 공개되므로, 정기적으로 약관 업데이트 내용을 확인해 주세요. 만약 약관 개정 내용에 동의하지 않는다면, 즉시 플랫폼의 모든 서비스 사용을 중단해야 합니다.",
    "您完成账户注册，即代表您已充分知晓并自愿接受Taoify 平台所有协议、条款，包括《Taoify 用户使用协议》《Taoify用户隐私政策》。若您不认可Taoify 平台所有协议、条款内容，请立即停止注册。": "계정 등록을 완료하면, Taoify 플랫폼의 모든 약관, 조항, 《Taoify 사용자 이용 약관》, 《Taoify 사용자 개인 정보 정책》을 충분히 이해하고 자발적으로 수락하였음을 나타냅니다. Taoify 플랫폼의 모든 약관, 조항 내용에 동의하지 않는다면, 즉시 등록을 중단하십시오.",
    "一、定义": "일、정의",
    "1、服务：Taoify 为您提供独立站搭建、店铺管理、订单收款、配套工具等建站经营服务，用于商户面向境外消费者销售商品、提供服务。": "1. 서비스: Taoify는 독립적인 사이트 구축, 상점 관리, 주문 결제, 관련 도구 등 건설 및 운영 서비스를 제공하여 판매자가 해외 소비자에게 상품을 판매하거나 서비스를 제공하는데 사용합니다.",
    "2、用户或您：指完成 Taoify 平台注册，并使用平台各项服务的自然人、法人及其他组织，包括但不限于商店所有者及\"员工账户\"下的用户。": "2. 사용자 또는 귀하: Taoify 플랫폼 등록을 완료하고 플랫폼의 다양한 서비스를 사용하는 개인, 법인 및 기타 조직을 지칭하며, 상점 소유자 및 '직원 계정' 아래의 사용자를 포함하되 이에 국한되지 않습니다.",
    "3、平台：指Taoify 运营企业及平台软硬件系统、网站、服务端口等整体服务载体。": "3. 플랫폼: Taoify 운영 기업 및 플랫폼 소프트웨어, 하드웨어 시스템, 웹사이트, 서비스 포털 등 전체 서비스 운송체를 지칭합니다.",
    "二、通用运营规则": "이、일반 운영 규칙",
    "1、Taoify 服务相关的技术支持仅对已完成注册的有效商户开放。": "1. Taoify 서비스 관련 기술 지원은 등록이 완료된 유효한 판매자에게만 제공됩니다.",
    "2、因法律法规调整、服务优化、平台运营调整等，我方有权修订、增补本服务条款、用户使用协议、隐私政策等全部 Taoify 平台规则，亦有权调整或关停平台服务、终止您账户；服务终止不影响终止日前双方已产生的各项权利与义务。": "2. 법률, 규정 조정, 서비스 최적화, 플랫폼 운영 조정 등으로 인해, 당사는 본 서비스 약관, 사용자 이용 약관, 개인 정보 정책 등 Taoify 플랫폼의 모든 규칙을 수정, 추가할 권리가 있으며, 플랫폼 서비스를 조정하거나 종료하고, 귀하의 계정을 종료할 권리가 있습니다. 서비스 종료는 종료일 전 양측이 발생한 모든 권리와 의무에는 영향을 미치지 않습니다.",
    "3、您认可并同意 Taoify 可以通过在商城发布相关的修正或新增的任何条款，修订提前1个工作日在平台公示，资费调整提前1个月公示，在网站公示后的七（7）日公示期后生效。如果您在公示期间没有提出异议或在生效日后继续使用服务即表示您同意并接受此修订版。": "3. 귀하는 Taoify가 쇼핑몰에서 관련 수정 또는 추가 조항을 게시함으로써, 수정 사항을 플랫폼에서 1일 전에 공고하고, 요금 조정은 1개월 전에 공고하며, 웹사이트에서 7(칠)일간의 공고 기간 후에 효력을 발생시키는 것에 동의하고 이를 인정합니다. 공고 기간 동안 이의를 제기하지 않거나 효력 발생일 이후 계속해서 서비스를 사용하는 것은 귀하가 이 수정 버전에 동의하고 이를 수락한다는 것을 나타냅니다.",
    "4、您不得将服务用于任何非法目的，您在使用本服务期间须严格遵守经营所在地、客户所在地及中华人民共和国全部现行法律法规（包括但不限于版权相关法律）。": "4. 귀하는 본 서비스를 어떠한 불법적인 목적으로도 사용해서는 안 되며, 서비스 사용 기간 동안 귀하의 사업 장소, 고객 장소 및 중화인민공화국의 모든 현행 법률(저작권 관련 법률을 포함하되 이에 국한되지 않음)을 엄격히 준수해야 합니다.",
    "5、您须对本人名下 API 证书的使用行为承担全部责任，并妥善保管 API 证书，保障其使用安全。": "5. 귀하는 본인 명의의 API 인증서 사용에 대한 모든 책임을 져야 하며, API 인증서를 적절히 보관하여 사용 안전을 보장해야 합니다.",
    "6、未经 Taoify 书面许可，您不得对Taoify 平台、服务的任何部分进行任何形式的再生产、修改、编辑、破解、反编译、反向工程、拆解、改编、衍生开发等操作；不得修改源代码、默认模板、自带文档、功能模块、接口程序等与系统相关的任何内容；不得复制、销售、转售或以此牟利。": "6. Taoify의 서면 허가 없이는 Taoify 플랫폼, 서비스의 어떤 부분이라도 재생산, 수정, 편집, 해킹, 역컴파일, 역설계, 분해, 개조, 파생 개발 등 어떠한 형태의 작업도 수행할 수 없습니다. 소스 코드, 기본 템플릿, 자체 문서, 기능 모듈, 인터페이스 프로그램 등 시스템과 관련된 어떠한 내용도 수정할 수 없습니다. 복제, 판매, 재판매 또는 이를 통해 이익을 취득할 수 없습니다.",
    "7、您不得注册、购买或使用包含 Taoify、Taoify 商标，以及该商标衍生变体、近似错拼词汇的域名；亦不得将前述相关词汇用于搜索引擎推广或其他按点击付费广告（如谷歌广告）。": "7. Taoify, Taoify 상표, 해당 상표의 파생 변형, 유사한 오타 단어를 포함하는 도메인을 등록, 구매 또는 사용할 수 없습니다. 또한 이러한 관련 단어를 검색 엔진 프로모션이나 기타 클릭당 지불 광고(예: 구글 광고)에 사용할 수 없습니다.",
    "8、有关本服务条款的任何问题，请发邮件到 liutaotao@taocarts.com。": "8. 본 서비스 약관과 관련된 질문은 liutaotao@taocarts.com으로 이메일을 보내주세요.",
    "9、您知晓您的资料（不包括信用卡信息）可能未经加密转移，并涉及通过各种网络传输。": "9. 귀하의 정보(신용카드 정보 제외)가 암호화되지 않은 상태로 전송될 수 있으며, 다양한 네트워크를 통해 전송될 수 있다는 점을 알고 있습니다.",
    "10、平台有关条款（包括但不限于本服务条款等）可能会有除中文以外的其他版本。如果不同语言版本的服务条款之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本服务条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本服务条款，予以明确排除。": "10. 플랫폼 관련 조항(본 서비스 약관 등을 포함하되 이에 국한되지 않음)은 중국어 외 다른 언어 버전이 있을 수 있습니다. 서로 다른 언어 버전 간에 차이, 불일치, 모호성이 있는 경우, 중국어 텍스트가 기준이 되며, 다른 텍스트는 참고용이며 중국어 텍스트의 의미와 충돌하거나 변경할 수 없습니다. 본 서비스 약관의 체결, 효력, 해석, 이행 및 분쟁 해결은 중화인민공화국 법을 준거법으로 하며, 해외 법적 충돌 규칙은 배제됩니다. 《유엔 국제물품매매계약협약》은 본 서비스 약관에 적용되지 않으며 명시적으로 배제됩니다.",
    "11、本服务条款对双方、双方各自的继承人、权利义务承继人、合法受让方及法定代表人均具备约束力。Taoify 可无需向您发出通知、亦无需取得您同意，自行转让本服务条款项下全部权利义务。未经 Taoify 事先书面许可，您不得将本服务条款，或您在本协议项下享有的任何权利、承担的任何义务转让、变相转移予任何第三方。": "11. 본 서비스 약관은 양 당사자, 각각의 상속인, 권리 의무 승계자, 합법적인 양수인 및 대표자에게 구속력을 가지며, Taoify는 귀하에게 통지하거나 동의를 얻지 않고도 본 서비스 약관 하의 모든 권리와 의무를 양도할 수 있습니다. Taoify의 사전 서면 허가 없이는 본 약관, 또는 귀하가 본 계약 하에서 누리는 어떠한 권리나 부담하는 어떠한 의무도 제3자에게 양도하거나 사실상 양도할 수 없습니다.",
    "12、若因任何事由致使本服务条款任一完整条款或条款部分内容无效，仅该条款或对应部分丧失效力，其余所有条款效力不受影响。": "12. 어떠한 이유로든 본 서비스 약관의 어느 한 항목이나 그 일부가 무효가 되더라도, 오직 해당 항목이나 부분만 효력을 상실하며, 나머지 모든 항목의 효력에는 영향을 미치지 않습니다.",
    "13、无论您申请注销账号、还是平台因违规终止合作，本服务条款商业秘密保护约定、权责划分与损失赔偿规则、第三方服务风险兜底、知识产权相关约定、争议管辖与法律适用、费用结算、侵权赔付、数据合规相关全部条款仍具备法律效力，不受服务终止影响。": "13. 귀하가 계정 해지를 신청하거나 플랫폼이 위반으로 인해 협력을 종료하더라도, 본 서비스 약관의 영업 비밀 보호 규정, 책임 분담 및 손해 배상 규칙, 제3자 서비스 리스크 관리, 지식재산권 관련 약정, 분쟁 관할 및 법률 적용, 비용 정산, 침해 배상, 데이터 준수 관련 모든 조항은 여전히 법적 효력을 유지하며, 서비스 종료에 영향을 받지 않습니다.",
    "三、账户管理规范": "삼、계정 관리 규범",
    "1、您注册 Taoify 账号时必须提供合法完整姓名、现地址、电话号码、有效的电子邮件地址以及其他所需的任何信息。Taoify 有权基于任何理由拒绝您的账号申请或注销现有账户。": "1. Taoify 계정을 등록할 때는 합법적이고 완전한 이름, 현재 주소, 전화번호, 유효한 이메일 주소 및 필요한 모든 정보를 제공해야 합니다. Taoify는 어떠한 이유로든 귀하의 계정 신청을 거부하거나 기존 계정을 해지할 권리를 보유하고 있습니다.",
    "2、您必须年满18岁或达到您使用本服务所在地或经营所在地的法定成年的年龄。": "2. 귀하는 18세 이상이거나 본 서비스를 이용하는 지역이나 사업을 운영하는 지역의 법적 성년 연령에 도달해야 합니다.",
    "3、您承诺是为经营之商业目的使用Taoify 服务，不得将账号、店铺用于个人日常消费、家庭自用等非经营场景。": "3. 귀하는 Taoify 서비스를 사업 목적을 위해 사용한다는 것을 약속하며, 개인 일상 소비, 가정용 등 비사업 목적으로 계정이나 매장을 사용해서는 안 됩니다.",
    "4、店铺的创建与运营过程中的全部负责由您自行承担。": "4. 매장의 생성 및 운영 과정에서 발생하는 모든 책임은 귀하가 직접 부담합니다.",
    "5、Taoify 仅提供独立站建站技术工具，不介入您与第三方之间的订单、售后、货款往来，您与第三方进行的直接交易，相关纠纷均与 Taoify 无关，我方不承担任何调解、赔付责任。": "5. Taoify는 독립적인 웹사이트 구축 기술 도구만을 제공하며, 귀하와 제3자 사이의 주문, 사후 서비스, 화물 거래에는 개입하지 않습니다. 귀하와 제3자가 직접 진행하는 거래와 관련된 모든 분쟁은 Taoify와 관련이 없으며, 저희는 어떠한 중재나 배상 책임도 지지 않습니다.",
    "6、您对账户内所有操作行为，以及账户内上传、收集、生成、存储、展示、分发、传输的全部内容（包括图片、视频、图文素材、音频、代码、信息、数据等）承担全部责任。": "6. 계정 내 모든 작업 행위, 그리고 계정 내에 업로드, 수집, 생성, 저장, 표시, 배포, 전송되는 모든 콘텐츠(이미지, 비디오, 텍스트-그림 자료, 오디오, 코드, 정보, 데이터 등)에 대한 모든 책임은 귀하가 부담합니다.",
    "7、若因用户违反本协议约定，导致平台被第三方索赔、起诉、仲裁，或被行政机关处以罚款、责令赔付，全部责任均由用户独立承担。用户须向平台足额赔付平台由此产生的全部直接损失与间接损失，损失范围包括但不限于：平台向第三方支付的赔偿金、和解金、补偿金、违约金；行政机关、司法机关收取的罚款、滞纳金、诉讼费、仲裁费、保全费、执行费、鉴定费、评估费；平台为维权支出的律师费、公证费、调查取证费、差旅费、担保费；平台商誉受损损失、业务中断损失、可得利益损失、第三方追责产生的额外赔付等一切相关费用。": "7. 사용자가 본 계약을 위반하여 플랫폼이 제3자로부터 손해배상 청구, 소송, 중재를 받거나, 행정 기관으로부터 벌금, 배상 명령을 받게 될 경우, 모든 책임은 사용자가 독립적으로 부담합니다. 사용자는 플랫폼이 이를 통해 발생하는 모든 직접적 손실과 간접적 손실을 충분히 배상해야 하며, 손실 범위는 다음과 같습니다: 플랫폼이 제3자에게 지급한 배상금, 화해금, 보상금, 위약금; 행정 기관, 사법 기관이 부과한 벌금, 연체료, 소송비, 중재비, 보전비, 집행비, 감정비, 평가비; 플랫폼이 권익 보호를 위해 지출한 변호사비, 공증비, 조사 증거 수집비, 여행비, 담보비; 플랫폼의 상업 명성 손실, 사업 중단 손실, 얻을 수 있었던 이익 손실, 제3자의 추궁으로 인한 추가 배상 등 모든 관련 비용입니다.",
    "四、账户管理": "사、계정 관리",
    "1、Taoify 账户商店所有者": "1. Taoify 계정 상점 소유자",
    "1.1 完成注册服务的用户将是商店所有者，并且将被授权使用我方提供给商店所有者的相关服务。您需保证营业执照、行政许可、审批、备案、资质等注册资料，在店铺页面清晰公示，供监管部门、消费者核验。": "1.1. 등록 서비스를 완료한 사용자는 상점 소유자가 되며, Taoify가 상점 소유자에게 제공하는 관련 서비스를 사용할 권한이 부여됩니다. 귀하는 사업자 등록증, 행정 허가, 승인, 신고, 자격 등등의 등록 자료가 상점 페이지에서 명확하게 게시되어 있어야 함을 보장해야 합니다. 이를 통해 규제 기관, 소비자가 확인할 수 있도록 해야 합니다.",
    "1.2 若您代表第三方注册本服务，则第三方为商店所有者。您必须使用第三方名下或者指定的邮箱完成注册，同时声明并保证已取得第三方合法书面授权且有效，提交授权许可手续，明确已授权范围，包括但不限于授权注册、日常登录、授权认可并自愿接受Taoify 平台所有协议、条款等。": "1.2. 귀하가 제3자를 대신하여 본 서비스를 등록하는 경우, 제3자가 상점 소유자가 됩니다. 귀하는 제3자의 명의 또는 지정된 이메일을 사용하여 등록해야 하며, 제3자로부터 합법적인 서면 권한을 취득하였음을 선언하고 보장해야 하며, 권한 허가 절차를 제출하고, 권한 범위를 명확히 해야 합니다. 이는但不限于授权注册、日常登录、授权认可并自愿接受Taoify 平台所有协议、条款等。",
    "1.3 注册账户后，若您需在店铺内上架、展示、销售第三方品牌商品或服务，您须提前向平台提交品牌授权书、经销许可、使用许可等合法有效手续，并保证相关授权、许可持续有效。未按要求提供手续或授权失效的，平台有权下架对应商品、暂停服务直至终止账户，由此产生的全部法律责任与损失由您自行承担。": "1.3. 계정을 등록한 후, 상점 내에서 제3자 브랜드의 상품이나 서비스를 판매, 전시하려면, 귀하는 플랫폼에 브랜드 권한 위임서, 판매 허가, 사용 허가 등의 합법적이고 유효한 절차를 미리 제출해야 하며, 관련 권한, 허가가 지속적으로 유효함을 보장해야 합니다. 요구사항에 따라 절차를 제공하지 않거나 권한이 만료된 경우, 플랫폼은 해당 상품을 하선하거나 서비스를 일시 중지하거나 계정을 종료할 권리를 보유하며, 이로 인한 모든 법적 책임과 손실은 귀하가 부담합니다.",
    "1.4 一个 Taoify 商店只能有一名商店所有者，一名商店所有者可以有多家 Taoify 商店。\"商店\"表示与账户相关联的在线商店或者实体零售地点。": "1.4 Taoify 상점은 1명의 소유주만 가질 수 있으며, 1명의 소유주는 여러 개의 Taoify 상점을 가질 수 있습니다. \"상점\"은 계정과 연결된 온라인 상점 또는 실제 소매 장소를 의미합니다.",
    "2、员工账户": "2、직원 계정",
    "2.1 根据您订阅的 Taoify 套餐，您可以创建一个或多个员工账户，商店所有者必须设置权限，限制员工账户对业务数据、店铺功能的访问范围（例如限制查看销售报表、禁止修改店铺基础设置等）。": "2.1 구독하신 Taoify 패키지에 따라 하나 이상의 직원 계정을 생성할 수 있습니다. 상점 소유주는 권한을 설정하여 직원 계정이 사업 데이터 및 상점 기능(예: 판매 보고서 확인 제한, 상점 기본 설정 변경 금지 등)에 접근하는 범위를 제한해야 합니다.",
    "2.2 凡使用本平台为门店开立的员工账号所实施的全部行为，由此产生的一切法律责任、经济损失及相应后果，均由商店所有者承担；前述员工账号操作行为，视同商店所有者作出的行为。": "2.2 본 플랫폼을 통해 개설된 직원 계정으로 이루어진 모든 행위로 인해 발생하는 법적 책임, 경제적 손실 및 그 결과는 모두 상점 소유주가 부담합니다; 위 직원 계정의 운영 행위는 상점 소유주의 행위로 간주됩니다.",
    "3、收款结算账户": "3、결제 정산 계정",
    "3.1 注册成功后，Taoify 将提供多家支付服务商供您进行选择。您可以从中选择收取顾客款项的渠道。": "3.1 등록이 완료되면 Taoify는 여러 결제 서비스 제공업체 중에서 선택할 수 있도록 지원합니다. 고객 지불을 받기 위한 채널을 선택하실 수 있습니다.",
    "3.2 您须自行负责注册、激活及维护收款账户，自行承担收款账户需承担费用。如果您不再需要这些收款账户，您须自行关停账户。支付服务商属于本服务条款中的第三方服务。": "3.2 결제 계정의 등록, 활성화, 유지 관리는 귀하의 책임이며, 관련 비용도 귀하가 부담해야 합니다. 더 이상 해당 결제 계정이 필요하지 않다면, 직접 계정을 종료해야 합니다. 결제 서비스 제공업체는 본 서비스 약관에서 제3자 서비스로 분류됩니다.",
    "3.3 您在店铺内使用收款账户，即视为您同意遵守对应支付服务商的服务条款与规则；支付服务商可随时修订条款，修订内容一经公示即刻生效。若您在条款修订公示完成后，继续使用店铺收款账户开展业务操作，即代表您认可并完全接受修订后的全部条款内容。若您不认可条款变更，须立即注销收款账户，并停止使用该支付服务。": "3.3 상점 내에서 결제 계정을 사용함으로써, 해당 결제 서비스 제공업체의 서비스 약관과 규칙을 준수하는 데 동의하는 것으로 간주됩니다; 결제 서비스 제공업체는 언제든지 약관을 수정할 수 있으며, 수정 내용은 공개 즉시 효력을 발휘합니다. 약관 수정 공지 후에도 계속해서 상점 결제 계정을 이용하시면, 수정된 모든 약관 내용을 인정하고 완전히 수락하는 것으로 간주됩니다. 만약 약관 변경을 인정하지 않는다면, 결제 계정을 해지하고 해당 결제 서비스의 사용을 중단해야 합니다.",
    "五、Taoify权利": "다섯째, Taoify의 권리",
    "1、我方保留随时修改、暂停、终止全部或部分平台服务的权利，且无需提前通知用户。部分服务、功能并非在所有国家/地区使用，我方无义务在任意区域提供指定服务。": "1. 당사는 플랫폼 서비스의 전부 또는 일부를 수정, 일시 중지, 종료할 권리가 있으며, 사용자에게 사전 통지를 할 필요는 없습니다. 일부 서비스와 기능은 모든 국가/지역에서 사용할 수 없으며, 당사는 특정 서비스를 임의의 지역에서 제공할 의무가 없습니다.",
    "2、Taoify 拥有自主选择权，保留拒绝向任意主体提供平台服务的权利。": "2. Taoify는 자율 선택권을 가지고 있으며, 임의의 주체에게 플랫폼 서비스를 제공하지 않을 권리를 보유하고 있습니다.",
    "3、如果我方判定店铺提供的商品或服务或者发布到店铺的资料违反了 Taoify 的协议，包括但不限于《Taoify 用户使用协议》《Taoify用户隐私政策》、本服务条款等，我方有权要求整改、删除违规内容、暂停或永久终止全部服务，用户已缴纳的所有费用不予退还。": "3. 당사가 상점이 제공하는 상품이나 서비스, 또는 상점에 게시된 자료가 Taoify의 약관, 《Taoify 사용자 이용 약관》, 《Taoify 사용자 개인 정보 보호 정책》, 본 서비스 조건 등을 위반한다고 판단하는 경우, 당사는 시정 요구, 위반 내용 삭제, 일시 중지 또는 영구적인 서비스 종료 등의 조치를 취할 권한이 있으며, 사용자가 납부한 모든 비용은 환불되지 않습니다.",
    "4、凡以口头、书面其他任何形式辱骂 Taoify 客户、员工、工作人员，或打击报复类威胁言论的，其账户将被立即永久终止使用，用户已缴纳的所有费用不予退还。": "4. Taoify 고객, 직원, 스태프를 구두, 서면 또는 기타 어떠한 형태로든 모욕하거나, 보복을 위협하는 발언을 한 경우, 해당 계정은 즉시 영구적으로 사용이 중지되며, 사용자가 납부한 모든 비용은 환불되지 않습니다.",
    "5、平台内容由您负责、承担责任，Taoify 不预先审核用户发布内容，我方有权自行裁量，单方拒绝展示或删除平台内任意内容，Taoify 无提前告知义务。": "5、플랫폼의 콘텐츠는 귀하가 책임지고, Taoify는 사용자가 게시한 콘텐츠를 사전에 검토하지 않습니다. 당사는 재량에 따라 플랫폼 내의 임의의 콘텐츠를 표시 거부 또는 삭제할 권리가 있으며, Taoify는 사전 통지 의무가 없습니다.",
    "6、Taoify 可向您的同业竞争者提供服务，不向任何用户授予细分市场独家合作权益。您确认并同意，Taoify 的合作方及员工均有可能成为 Taoify 平台客户或入驻，前述主体可能与您开展同业竞争，但严禁擅自使用您保密信息。": "6、Taoify는 귀하의 동종 경쟁자에게 서비스를 제공할 수 있으며, 어떠한 사용자에게도 세분화된 시장 독점 협력 권리를 부여하지 않습니다. 귀하는 Taoify의 파트너 및 직원이 Taoify 플랫폼의 고객이거나 입점할 가능성이 있으며, 이러한 주체들이 귀하와 동종 경쟁을 벌일 수 있음을 확인하고 동의합니다. 그러나 귀하의 기밀 정보를 무단으로 사용하는 것은 엄격히 금지됩니다.",
    "7、若就商店所有者权属产生争议，我方有权要求相关方提交权属证明文件，包括但不限于营业执照扫描件、政府机关核发的有效身份证件、信用卡后四位卡号、在职证明等资料。": "7、상점 소유권에 대한 분쟁이 발생할 경우, 당사는 관련 당사자에게 소유권 증빙 서류를 제출하도록 요구할 권리가 있습니다. 이에는 영업 허가증 스캔본, 정부 기관에서 발급한 유효한 신분증, 신용카드 뒷면 4자리 번호, 재직 증명서 등이 포함되나 이에 국한되지 않습니다.",
    "8、依据现有材料，我方有权判定账户的商店所有者，并有权根据我方的单方判断将账户转让给商店所有者，若您有异议，请及时提出转让异议。如果我方无法判定账户合法所有者或者收到转让异议，Taoify 有权临时冻结该账户，直至争端双方直至争议各方达成纠纷解决方案。": "8、현재 자료를 바탕으로 당사는 계정의 상점 소유자를 판단할 권리가 있으며, 당사의 단독 판단에 따라 계정을 상점 소유자에게 이전할 수 있습니다. 만약 이의가 있다면, 즉시 이전 이의를 제기해 주십시오. 만약 당사가 계정의 합법적인 소유자를 판단할 수 없거나 이전 이의를 받은 경우, Taoify는 해당 계정을 일시적으로 동결할 권리가 있으며, 분쟁 당사자들이 분쟁 해결 방안에 도달할 때까지 유지될 것입니다.",
    "9、Taoify平台无需就您遭受的任何直接损失、间接损失、商誉损失、预期收益损失、经营利润损失等承担任何赔偿责任。": "9. Taoify 플랫폼은 귀하가 입은 모든 직접 손실, 간접 손실, 명예 손해, 예상 수익 손실, 영업 이익 손실 등에 대해 어떠한 배상 책임도 지지 않습니다.",
    "10、若存在法定或其他 Taoify 应当承担赔偿责任的情形，Taoify 对用户的全部累计赔偿责任（含违约金、赔偿金、维权支出）最高限额为：损失事件发生对应服务周期内，您实际向 Taoify 支付的服务费总金额。无论索赔事由多少、损失金额高低，合计赔付总额不得突破该上限。": "10. 법적으로 또는 기타 Taoify가 배상 책임을 져야 하는 상황이 존재하는 경우, Taoify의 사용자에 대한 총 누적 배상 책임(위약금, 배상금, 권리 보호 비용 포함)의 최고 한도는: 손실 사건 발생 시 해당 서비스 기간 동안 실제로 Taoify에 지불한 서비스 요금의 총액입니다. 청구 사유의 수나 손실 금액의 크기에 관계없이 합산 배상 총액은 이 상한선을 초과할 수 없습니다.",
    "六、责任限制": "육. 책임 제한",
    "1、您保证符合合法经营资质（包括但不限于营业执照、行政审批等）、保证商品质量合格、保证图文与实际物品规则、质量、功能等一致，不存在虚假宣传、不正当竞争等；": "1. 합법적인 운영 자격(영업 허가증, 행정 승인 등 포함)을 갖추고, 상품의 품질이 적합하며, 이미지와 실제 제품의 규칙, 품질, 기능 등이 일치하고, 거짓 광고나 부당 경쟁이 없다는 것을 보장합니다.",
    "2、在现行法律允许的最大范围内，因平台服务无法使用、系统故障产生的各类经营损失，平台及服务商均无需承担赔偿，包括经营收入减少、客户流失、品牌口碑受损、数据丢失、预期收益下滑等各类直接、间接经济损耗与衍生损失。": "2. 현행 법에서 허용하는 최대 범위 내에서, 플랫폼 서비스 사용 불가, 시스템 장애로 인한 다양한 영업 손실에 대해 플랫폼 및 서비스 제공자는 배상 책임을 지지 않습니다. 이는 영업 수입 감소, 고객 유실, 브랜드 평판 손상, 데이터 손실, 예상 수익 하락 등 모든 직접적, 간접적 경제적 손실과 파생 손실을 포함합니다.",
    "3、若您存在违反本服务条款及《Taoify 用户使用协议》《Taoify用户隐私政策》、违反法律法规或侵害第三方合法权益的行为，您须保障 Taoify及其关联主体、合作方、员工及供应商免受一切索赔追责，并须全额赔付 Taoify 及其关联方、合作方、员工、供应商遭受的全部损失、诉讼费、律师费。": "3. 본 서비스 약관, 《Taoify 사용자 이용 약관》, 《Taoify 사용자 개인정보 보호정책》을 위반하거나, 법률을 위반하거나, 제3자의 합법적 권익을 침해하는 경우, Taoify 및 그 관련 주체, 협력사, 직원, 공급업체를 모든 청구와 책임으로부터 보호해야 하며, Taoify 및 그 관련 주체, 협력사, 직원, 공급업체가 입은 모든 손실, 소송비, 변호사 비용을 전액 배상해야 합니다.",
    "4、您使用本服务需要自担风险。平台以\"现状\"提供服务，不作出任何书面、口头经营收益、系统稳定类承诺。": "4. 본 서비스를 사용함에 있어 스스로 위험을 감수해야 합니다. 플랫폼은 '현재 상태'로 서비스를 제공하며, 어떠한 서면 또는 구두의 영업 수익, 시스템 안정성 등의 약속도 하지 않습니다.",
    "5、Taoify 不保证服务及时、安全、零差错、不间断运行。": "5. Taoify는 서비스가 항상 즉시, 안전하게, 오류 없이, 중단 없이 작동한다는 것을 보장하지 않습니다.",
    "6、Taoify 不保证使用本服务所输出、取得的结果具备准确性与可靠性。": "6. Taoify는 본 서비스를 통해 얻은 결과의 정확성과 신뢰성을 보장하지 않습니다.",
    "7、因您使用本服务产生的全部税费缴纳义务，均由您自行承担并缴纳，Taoify 不承担任何相关责任。": "7. 본 서비스를 사용함으로써 발생하는 모든 세금 납부 의무는 귀하가 스스로 부담하고 납부해야 하며, Taoify는 어떠한 관련 책임도 지지 않습니다.",
    "8、Taoify 不保证平台产品、服务、信息符合您的预期，亦无义务修复服务内全部漏洞、差错。": "8. Taoify는 플랫폼의 제품, 서비스, 정보가 귀하의 기대에 부합한다는 것을 보장하지 않으며, 서비스 내 모든 버그와 오류를 수정할 의무도 없습니다.",
    "七、知识产权约定": "칠. 지식재산권 약정",
    "1、您上传至 Taoify 服务平台的图片、文案、商标、素材知识产权、所有权归您所有，您须保证上传图片、文案、商标、素材不侵犯任何第三人知识产权等权益，须确保前述内容符合全部法律法规。您可随时注销账户，同步清除其 Taoify 店铺内全部相关素材，清除后即无法恢复。": "1. Taoify 서비스 플랫폼에 업로드한 사진, 콘텐츠, 상표, 소재의 지식재산권, 소유권은 귀하에게 있습니다. 귀하는 업로드한 사진, 콘텐츠, 상표, 소재가 제3자의 지식재산권 등을 침해하지 않음을 보장해야 하며, 해당 내용이 모든 법률 및 규정을 준수하도록 해야 합니다. 계정을 언제든지 해지할 수 있으며, 동시에 Taoify 가게 내 모든 관련 소재를 삭제할 수 있습니다. 삭제 후 복구는 불가능합니다.",
    "2、您上传内容即视为同意下述约定：2.1 允许其他主体免费查阅您上传至 Taoify 店铺的全部内容；2.2 就您公开发布的内容，授予 Taoify 存储、免费展示及免费使用该等内容；2.3 Taoify 有权核查、删除您上传至本平台服务的任意内容，但并无开展前述操作的强制性义务。2.4 Taoify可免费使用与您店铺相关的商号、注册商标、服务标识及品牌标识，用于推广、宣传 Taoify 平台服务。": "2. 업로드한 내용은 다음과 같은 약정에 동의한 것으로 간주됩니다: 2.1 타인이 Taoify 가게에 업로드한 모든 내용을 무료로 열람할 수 있도록 허용합니다; 2.2 공개적으로 게시한 내용에 대해서는 Taoify가 이를 저장, 무료로 표시 및 무료로 사용할 수 있는 권리를 부여합니다; 2.3 Taoify는 본 플랫폼 서비스에 업로드된 임의의 내용을 검토, 삭제할 권리가 있지만, 그러한 조치를 취할 강제적인 의무는 없습니다. 2.4 Taoify는 귀하의 가게와 관련된 상호, 등록 상표, 서비스 마크, 브랜드 마크를 Taoify 플랫폼 서비스의 홍보 및 선전을 위해 무료로 사용할 수 있습니다.",
    "3、平台系统、程序（包括但不限于源代码、框架、设计、文档）、界面、官方文档等所有知识产权归平台所有，未经书面授权不得复制、传播、二次开发。": "3. 플랫폼 시스템, 프로그램(소스 코드, 프레임워크, 디자인, 문서 포함), 인터페이스, 공식 문서 등 모든 지식재산권은 플랫폼에 귀속되며, 서면 허가 없이는 복제, 유포, 2차 개발할 수 없습니다.",
    "八、商品发货与物流规则": "여덟째, 상품 발송 및 물류 규칙",
    "对于您Taoify商铺所售出的商品，您可以在发货时选择联系第三方承运商提供商处购买运输标签。商品发货、物流运输相关事宜、费用、风险均由您自行负责，Taoify不承担任何责任。": "Taoify 상점에서 판매한 상품을 발송할 때, 제3자 운송업체로부터 운송 라벨을 구매할 수 있습니다. 상품 발송, 물류 운송 관련 사항, 비용, 위험은 모두 귀하가 책임져야 하며, Taoify는 어떠한 책임도 지지 않습니다.",
    "九、商店主题规范": "아홉째, 상점 테마 규정",
    "1、平台提供的店铺模板页面可展示平台官方标识；如模板内页面内容违反平台各项管理规则，平台有权单方面调整页面内容，无义务提前通知商家，但平台无开展前述操作的强制性义务。": "1. 플랫폼이 제공하는 가게 템플릿 페이지에는 플랫폼 공식 로고를 표시할 수 있습니다. 템플릿 내 페이지 내용이 플랫폼 관리 규정을 위반하는 경우, 플랫폼은 단독으로 페이지 내용을 조정할 수 있으며, 상점에 미리 통지할 의무는 없지만, 이러한 조치를 취할 강제적인 의무는 없습니다.",
    "2、平台主题模版的知识产权仍属于设计者。您仅可在授权范围内使用；若超出授权范围使用，设计者可依法追责，平台亦有权修改店铺内容或关停账户，不利后果由您承担，Taoify 不承担任何责任。": "2. 플랫폼 테마 템플릿의 지식재산권은 설계자에게 귀속됩니다. 귀하는 허가 범위 내에서만 사용할 수 있으며, 허가 범위를 초과하여 사용하는 경우, 설계자는 법적으로 책임을 추궁할 수 있으며, 플랫폼도 가게 내용을 수정하거나 계정을 중단할 권한이 있습니다. 불이익은 귀하가 부담하며, Taoify는 어떠한 책임도 지지 않습니다.",
    "3、技术支持工作由设计者负责，Taoify 不承担提供此类支持的责任，但 Taoify 可帮助您联系设计者。": "3. 기술 지원 작업은 설계자가 담당하며, Taoify는 이러한 지원을 제공할 책임이 없습니다. 그러나 Taoify는 설계자와 연락을 돕는 데 도움을 줄 수 있습니다.",
    "4、您安装新模板时，必须自行做好数据备份，Taoify 无备份义务。因安装模板导致原有主题、界面、数据等内容损坏的，Taoify 不承担赔偿责任。": "4. 새로운 템플릿을 설치할 때, 데이터 백업은 귀하가 직접 수행해야 하며, Taoify는 백업 의무가 없습니다. 템플릿 설치로 인해 기존 테마, 인터페이스, 데이터 등이 손상되는 경우, Taoify는 배상 책임을 지지 않습니다.",
    "十、费用支付规则": "열번째, 비용 지불 규칙",
    "1、您必须向我方提供有效可用的支付方式，以避免扣款失败影响店铺使用。建议您绑定多张信用卡并授权使用自动支付。账单支付的技术由第三方专业金融公司提供技术支持。": "1. 유효한 결제 수단을 제공하셔야 합니다. 이는 결제 실패로 인한 서비스 중단을 방지하기 위함입니다. 여러 장의 신용카드를 등록하고 자동 결제를 설정하는 것을 권장드립니다. 결제 처리 기술은 제3자 전문 금융 회사가 지원합니다.",
    "5、订阅费用采用预付制，系统将在服务到期前5个自然日自动发起续费扣款。例：服务到期时间为2022-01-06 23:59:59，则预计续费扣费时间为2022-01-01 23:59:59。": "5. 구독 요금은 선불로 청구되며, 서비스 만료 5일 전에 자동으로 갱신됩니다. 예: 서비스 만료일이 2022-01-06 23:59:59인 경우, 예상 갱신 날짜는 2022-01-01 23:59:59입니다.",
    "6、我方提前30日发出服务费用变更通知后即可调整服务收费标准，我方可通过平台官网公告或您店铺后台管理页面公示的方式送达该通知。": "6. 서비스 비용 변경 사항은 30일 전에 공지하며, 플랫폼 웹사이트나 가맹점 관리 페이지를 통해 통지됩니다.",
    "7、我方不会就关于服务的任何修改、价格变动、暂停或终止对您或任何第三方承担任何责任。": "7. 서비스 수정, 가격 변동, 일시 중단 또는 종료와 관련하여 당사는 귀하나 제3자에게 어떠한 책임도 지지 않습니다.",
    "8、若我方无法通过授权银行卡成功扣取订阅费用，将向您所有者发送邮件告知扣款失败，并提示更新支付银行卡。我方每间隔24小时重复发起扣费，总计最多三次扣款尝试（含首次扣款）。第三次扣款仍失败的，我方有权暂停并限制您账户使用权限。您缴清全部未结清款项及下一计费周期订阅费用后，账户方可恢复正常访问权限。": "8. 승인된 카드에서 구독 요금을 성공적으로 청구할 수 없는 경우, 소유자에게 메일로 실패 알림과 함께 카드 정보 업데이트 요청을 보냅니다. 24시간마다 최대 3회(처음 시도 포함) 재청구를 시도합니다. 세 번째 시도에서도 실패할 경우, 계정 사용이 일시 중지될 수 있습니다. 모든 미결제 금액 및 다음 청구 주기의 구독 요금을 완납해야만 계정 접근이 재개됩니다.",
    "9、服务期限届满前您未及时续订阅费用的，服务自动终止；服务关闭满10日用户仍未续订阅费用的，Taoify 平台有权删除网站全部数据，相关损失由用户自行承担。": "9. 서비스 기간 만료 전에 구독료를 갱신하지 않으면 서비스가 자동으로 종료됩니다. 10일 동안 구독료를 갱신하지 않는 경우, Taoify 플랫폼은 사이트의 모든 데이터를 삭제할 권리가 있으며, 이로 인한 손실은 사용자가 부담합니다.",
    "10、Taoify 自行收取的平台服务费不包含各类政府征收的税金、规费及其他收费（本服务条款中统称为\"税费\"）。除平台服务费外，您因订阅、采购 Taoify 产品与服务产生的全部适用税费，均由您自行承担。税费将依据您提供的账单地址适用税率核算，并从您授权支付卡自动扣取。若您具备免税资格，须向我方提交有效免税凭证；部分司法辖区要求提供能够证实免税资质、符合当地法规的官方证明文件，免税政策自材料审核通过之日起生效。若 Taoify 未代为计收相关税费，您必须自行判断自身纳税义务，由您向税务主管机关完成申报缴纳税款。": "10. Taoify가 직접 부과하는 플랫폼 서비스 요금에는 정부가 부과하는 세금, 수수료, 기타 비용(본 약관에서는 '세금'이라고 함)이 포함되지 않습니다. 플랫폼 서비스 요금 외에도 Taoify 제품 및 서비스 구독, 구매로 발생하는 모든 적용 가능한 세금은 귀하가 부담합니다. 세금은 귀하가 제공한 청구 주소에 따라 결정되며, 승인된 카드에서 자동으로 청구됩니다. 면세 자격이 있는 경우, 유효한 면세 증빙 서류를 제출하셔야 합니다. 일부 지역에서는 현지 법규에 맞는 공식 증명서를 요구할 수 있으며, 면세 정책은 해당 자료 검토 후부터 적용됩니다. Taoify가 세금을 대신 징수하지 않은 경우, 귀하는 스스로 세무 의무를 판단하고 세무 당국에 신고 및 납부해야 합니다.",
    "11、除 Taoify 代为收取并上缴主管税务机关的税费外，法律法规规定的各类税款扣除、预提代缴义务均由您自行承担，并由您单独向对应税务机关完成缴纳。无论是否存在前述税款扣除或预提要求，Taoify 均有权按照本服务条款约定，从您授权支付卡扣收全部应付费用，但Taoify无主动扣费义务。": "11. Taoify가 대신 징수하고 세무 당국에 납부하는 세금 외에도, 법률이나 규정에 따른 모든 세금 차감, 예치금 납부 의무는 귀하가 직접 수행해야 합니다. 이러한 세금 차감이나 예치금 요구 여부와 상관없이, Taoify는 본 약관에 따라 귀하의 승인된 카드에서 모든 지급 가능 금액을 청구할 권리가 있으나, Taoify는 이를 자동으로 청구할 의무는 없습니다.",
    "12、您店铺经营销售行为产生的全部适用税费，均由您自行承担并依法缴纳。": "12. 귀하의 가맹점 운영 및 판매 활동으로 발생하는 모든 적용 가능한 세금은 귀하가 부담하고 법에 따라 납부해야 합니다.",
    "十一、保证金支付": "열한번째, 보증금 지불",
    "1、您完成 Taoify 账户注册时，须一次性足额缴纳经营保证金1000元。": "1. Taoify 계정을 등록할 때, 1000원의 운영 보증금을 일시불로 납부해야 합니다.",
    "2、保证金仅用于担保您履行本服务条款及《Taoify 用户使用协议》《Taoify用户隐私政策》等全部 Taoify 平台规则、全部义务，不能抵扣服务费用、税费。": "2. 보증금은 본 서비스 약관, 《Taoify 사용자 이용약관》, 《Taoify 개인정보 보호정책》 및 Taoify 플랫폼의 모든 규칙과 의무를 담보하기 위한 용도로만 사용되며, 서비스 요금이나 세금으로 사용될 수 없습니다.",
    "3、若您出现商品质量违规、虚假宣传、侵害消费者权益、侵权、行政处罚、违约欠款、第三方索赔、产生赔付款项、依据平台规则须向我方赔偿等情形，您同意我方有权直接从您已缴纳的保证金中抵扣对应赔偿金、罚款、欠款、维权支出、律师费、诉讼费等全部应付费用。保证金经抵扣后余额不足约定标准金额的，您须在我方发出补缴通知后3个自然日内补足差额，恢复保证金足额标准；逾期未足额补缴的，Taoify 有权暂停店铺全部经营功能、限制账户操作，直至保证金足额补齐。": "3. 상품 품질 위반, 거짓 광고, 소비자 권익 침해, 침해, 행정 처분, 채무 불이행, 제3자 청구, 배상금 발생, 플랫폼 규칙에 따라 당사에 배상해야 하는 등의 상황이 발생할 경우, 당사는 귀하가 납부한 보증금에서 해당 배상금, 벌금, 채무, 권리 보호 비용, 변호사 비용, 소송 비용 등을 직접 차감할 권리를 가지며, 귀하는 보증금 잔액이 약정된 금액 미달일 경우 3일 내에 차액을 보충하여 보증금을 원래의 금액으로 복원해야 합니다. 3일 내에 보충하지 않을 경우, Taoify는 가맹점의 모든 운영 기능을 일시 중지하고 계정 조작을 제한할 수 있으며, 보증금이 충분히 보충될 때까지 계속됩니다.",
    "4、在您主动申请注销账户、结清全部欠款、无未了结客诉、质量纠纷、行政处罚、侵权索赔后，我方将无息退还剩余保证金。存在未结清赔付、纠纷、处罚的，平台有权扣除对应款项后再无息退还剩余部分，不足部分平台保留向您追偿的权利。保证金不产生任何利息，我方无义务为保证金支付利息。": "4. 계정 해지를 신청하고, 모든 채무를 청산하고, 미해결 고객 불만, 품질 분쟁, 행정 처분, 침해 청구가 없는 경우, 당사는 남은 보증금을 이자 없이 환불합니다. 미결제 배상금, 분쟁, 처분이 있는 경우, 플랫폼은 해당 금액을 차감한 후 나머지를 이자 없이 환불하며, 부족한 금액에 대해서는 추후 청구할 권리를 보유합니다. 보증금은 어떠한 이자도 발생하지 않으며, 당사는 보증금에 대한 이자를 지급할 의무가 없습니다.",
    "十二、账户注销与服务终止": "십이, 계정 해지 및 서비스 종료",
    "1、服务期内您主动申请终止服务的，需提前一个月书面通知 Taoify 平台，已缴纳费用不予退还；用户擅自终止协议造成 Taoify 平台损失的，须予以赔偿，包括但不限于直接损失、间接损失、律师费等。": "1. 서비스 기간 중에 서비스 종료를 신청하는 경우, 1개월 전에 Taoify 플랫폼에 서면으로 통지해야 하며, 이미 납부한 비용은 환불되지 않습니다. 사용자가 무단으로 계약을 종료하여 Taoify 플랫폼에 손해를 입힌 경우, 직접적, 간접적 손해, 변호사 비용 등을 포함하여 배상해야 합니다.",
    "2、您在暂停使用、注销账户或终止服务前，须自行备份留存账户内全部数据，Taoify 无义务保管您账户相关数据资料。": "2. 계정 사용 중지, 해지 또는 서비스 종료 전에, 계정 내 모든 데이터를 백업하고 저장해야 합니다. Taoify는 귀하의 계정 관련 데이터를 보관할 의무가 없습니다.",
    "3、无论因何种事由任意一方终止本服务，Taoify 将即刻停止提供服务，您亦无法继续登录使用账户。除本服务条款另有约定外，您已缴纳费用不再退还。您因使用平台服务所欠付 Taoify 的全部款项立即届至清偿期，须一次性全额付清，同时您的 Taoify 店铺将被关停下架。": "3. 어떠한 이유로든 어느 한쪽이 본 서비스를 종료하는 경우, Taoify는 즉시 서비스 제공을 중단하며, 귀하는 더 이상 계정에 로그인하거나 사용할 수 없습니다. 본 서비스 약관에 특별히 명시된 경우를 제외하고, 이미 납부한 비용은 환불되지 않습니다. Taoify에 대한 모든 미결제 금액은 즉시 청구되며, 일시불로 전액 결제해야 합니다. 동시에 Taoify 가맹점은 폐쇄되고 오프라인 상태가 됩니다.",
    "4、服务终止后，与域名相关的全部事宜由您自行对接域名服务商处理。": "4. 서비스 종료 후, 도메인 관련 모든 사항은 귀하가 도메인 서비스 제공업체와 직접 처리해야 합니다.",
    "5、服务终止当日，若您存在未结清款项，我方将通过邮件向您发送最终账单，我方不再另行收取任何费用，也不再提供任何服务。": "5. 서비스 종료 당일, 미결제 금액이 있는 경우, 당사는 최종 청구서를 이메일로 보내드리며, 추가 비용은 청구하지 않고, 더 이상 서비스를 제공하지 않습니다.",
    "6、服务无论因何种原因终止，您须自行完整留存店铺经营全部资料（包括但不限于订单记录、商品资质、购销合同、品牌授权、物流凭证、客户交易台账、质检报告等）并自行备案存档，我方无义务代为保管、整理、备案任何资料。": "6. 서비스가 어떤 이유로 종료되더라도, 귀하는 상점 운영에 필요한 모든 자료(주문 기록, 상품 자격 증명, 구매 및 판매 계약, 브랜드 인증, 물류 증빙, 고객 거래 대장, 품질 검사 보고서 등)를 완전히 보관하고 자체적으로 보관해야 합니다. 당사는 어떠한 자료도 보관, 정리, 또는 보관 의무가 없습니다.",
    "7、即便服务终止，若您销售的商品、提供的服务存在质量缺陷、侵权、售后纠纷、行政处罚、消费者索赔等全部问题，相关法律责任、赔偿责任、整改义务仍全部由您独立承担，我方不承担任何责任。": "7. 서비스가 종료된 후에도, 귀하가 판매한 상품이나 제공한 서비스에 대한 품질 결함, 침해, 사후 분쟁, 행정 처벌, 소비자 청구 등의 문제가 발생할 경우, 관련 법적 책임, 배상 책임, 개선 의무는 모두 귀하가 독립적으로 부담하며, 당사는 어떠한 책임도 지지 않습니다.",
    "8、如果我方怀疑您涉嫌任何欺诈行为（通过判决、和解、保险、托管调查或其他方式），我方有权暂停或终止您的账户，且我方可采取任何其他补救措施。": "8. 당사가 귀하가 사기 행위(판결, 화해, 보험, 에스크로 조사 등을 포함)를 저지른 것으로 의심할 경우, 당사는 귀하의 계정을 일시 중지하거나 종료할 권리를 가지며, 기타 다른 보완 조치를 취할 수 있습니다.",
    "十三、第三方工具、支付服务商规则": "13. 제3자 도구, 결제 서비스 제공업체 규칙",
    "1、Taoify可提供并开放第三方软件、应用程序、产品、服务接口及网站链接（前述统称\"第三方服务\"，下同），您自主选择开通使用，您与第三方服务商形成独立合作关系，平台不参与双方权利义务约定，不对第三方产品做背书或质量担保，不存在联营、隶属合作关系。": "1. Taoify는 제3자 소프트웨어, 애플리케이션, 제품, 서비스 인터페이스 및 웹사이트 링크(이하 '제3자 서비스'라 함)를 제공하고 오픈합니다. 귀하는 이를 선택하여 사용하며, 제3자 서비스 제공업체와 독립적인 협력 관계를 형성하게 됩니다. 플랫폼은 양측의 권리와 의무를 규정하지 않으며, 제3자 제품에 대해 어떠한 보증이나 품질 보증도 하지 않으며, 공동 경영, 소속 관계는 존재하지 않습니다.",
    "2、对于使用第三方服务产生的风险，由您自行承担，您在使用第三方服务前先阅读第三方隐私政策、服务条款。Taoify 会从第三方服务提供商处获得收益份额，但该收益获取行为不代表 Taoify 需对第三方服务承担任何担保、赔偿等相关责任。": "2. 제3자 서비스 사용으로 인한 위험은 귀하가 직접 부담하며, 제3자 서비스를 사용하기 전에는 제3자의 개인정보 보호정책, 서비스 약관을 먼저 읽어야 합니다. Taoify는 제3자 서비스 제공업체로부터 수익을 얻을 수 있지만, 이는 Taoify가 제3자 서비스에 대한 어떠한 보증, 배상 등 관련 책임을 지는 것을 의미하지 않습니다.",
    "3、Taoify有权自主决定随时限制、关闭第三方服务访问权限，且无需提前通知；因暂停或禁用第三方服务产生的一切损失，Taoify 不向任何主体承担责任。第三方服务仅作参考，不可替代专业咨询。": "3. Taoify는 언제든지 제3자 서비스 접근 권한을 제한하거나 종료할 수 있으며, 사전 통보 없이 이를 실행할 수 있습니다. 제3자 서비스의 일시 중지나 비활성화로 인한 모든 손실에 대해서 Taoify는 어떠한 주체에게도 책임을 지지 않습니다. 제3자 서비스는 참고용이며, 전문적인 상담을 대체할 수 없습니다.",
    "4、您绑定第三方工具并开启数据互通后，第三方可读取对应店铺经营数据，您与第三方之间的数据交互仅约束双方数据传输，存储风险由您自行承担，平台不会为第三方的数据泄露、篡改行为承担赔偿责任。": "4. 제3자 도구를 바인딩하고 데이터 공유를 활성화한 후, 제3자는 해당 상점의 운영 데이터를 읽을 수 있습니다. 귀하와 제3자 간의 데이터 교환은 양측의 데이터 전송만을 제한하며, 저장 위험은 귀하가 직접 부담하며, 플랫폼은 제3자의 데이터 유출, 변조 행위에 대한 배상 책임을 지지 않습니다.",
    "5、Taoify 有权直接或间接获取您与第三方服务商往来的全部邮件内容。Taoify 可向第三方服务商披露、共享您提交的联络方式及相关背景资料。": "5. Taoify는 귀하와 제3자 서비스 제공업체 간의 모든 이메일 내용을 직접 또는 간접적으로 획득할 권리를 가집니다. Taoify는 제3자 서비스 제공업체에게 귀하가 제출한 연락처 정보 및 관련 배경 자료를 공개, 공유할 수 있습니다.",
    "6、因第三方或您与第三方服务商合作关系引发的一切直接、间接以及其他损失，Taoify 均不承担任何赔偿责任。即便提前告知风险，该免责条款仍有效。": "6. 제3자 또는 귀하와 제3자 서비스 제공업체 간의 협력 관계로 인해 발생하는 모든 직접적, 간접적, 기타 손실에 대해 Taoify는 어떠한 배상 책임도 지지 않습니다. 사전 위험 알림이 있더라도, 이 면책 조항은 유효합니다.",
    "7、您与第三方产生纠纷引发平台被起诉、索赔、行政处罚的，您需全额赔偿平台全部损失、维权开支，保障平台各方不受追责。": "7. 귀하와 제3자 간의 분쟁으로 인해 플랫폼이 소송, 청구, 행정 처벌을 받게 될 경우, 귀하는 플랫폼의 전체 손실, 권리 보호 비용을 전액 배상하고, 플랫폼의 모든 당사자가 책임을 지지 않도록 보장해야 합니다.",
    "十四、内测Beta功能规则": "14. 베타 테스트 기능 규칙",
    "1、平台不定期定向邀请商户体验未正式上线的Beta内测功能，内测使用需同步遵守单独下发的内测补充规则。内测相关资料、沟通记录属于平台保密信息，适用本条款保密有关约定。": "1. 플랫폼은 주기적으로 특정 상인을 초청하여 아직 공식 출시되지 않은 베타 테스트 기능을 체험하도록 합니다. 베타 테스트 사용 시 별도로 제공되는 추가 규칙을 준수해야 합니다. 베타 테스트 관련 자료, 커뮤니케이션 기록은 플랫폼의 기밀 정보로, 본 조항의 기밀 유지 관련 약정이 적용됩니다.",
    "2、未经平台书面许可，商户不得在任何社交平台等渠道发布内测截图、功能细节等与内测有关的内容，禁止向任何第三方泄露内测相关内容。": "2. 플랫폼의 서면 허가 없이는, 상인은 어떠한 소셜 플랫폼이나 채널에서도 베타 테스트 스크린샷, 기능 세부사항 등과 같은 베타 테스트 관련 내용을 게시하거나, 어떠한 제3자에게도 베타 테스트 관련 내용을 누설해서는 안 됩니다.",
    "3、Taoify不对Beta测试服务的功能作出任何明示或默示陈述或保证。内测功能不代表最终上线版本，平台有权根据开发需求调整、下线甚至永久放弃该功能上线；商家自愿参与测试产生的店铺故障、经营损耗等全部风险由商家自行承担，平台不提供补偿或赔付。": "3. Taoify는 베타 테스트 서비스의 기능에 대해 명시적이거나 묵시적인 진술이나 보증을 하지 않습니다. 베타 테스트 기능은 최종 출시 버전을 대표하지 않으며, 플랫폼은 개발 요구에 따라 기능을 조정, 종료, 또는 영구적으로 포기할 수 있는 권리를 보유합니다. 상인이 자발적으로 테스트 참여로 인한 상점 장애, 운영 손실 등 모든 위험은 상인이 직접 부담하며, 플랫폼은 보상이나 배상을 제공하지 않습니다.",
    "十五、商户评价规范": "15. 상인 평가 규범",
    "1、Taoify 欢迎您提交功能优化创意、经营改进建议、第三方工具评价。您向 Taoify 提供的全部创意、建议、配套资料、评价，Taoify 无需保密，无需向您支付任何报酬或补偿。您主动提交反馈、公开评价，即同意Taoify 无偿参考、落地优化相关方案，可按需修改后商用。": "1. Taoify는 기능 최적화 아이디어, 운영 개선 제안, 제3자 도구 평가를 환영합니다. 귀하가 Taoify에 제공하는 모든 아이디어, 제안, 관련 자료, 평가는 Taoify가 비밀로 유지할 의무가 없으며, 어떠한 보수나 보상을 지급할 필요가 없습니다. 귀하가 자발적으로 피드백을 제출하거나 공개적으로 평가하면, Taoify는 무상으로 참조, 수정, 상용화할 수 있는 권리를 갖습니다.",
    "2、您向 Taoify 提交的所有评论，均须如实撰写，不得包含违法、低俗色情、恐吓、诽谤、侵害知识产权以及其他损害第三方权益、引人不适的内容。Taoify有权自主删除违规评价，但无必须开展删除、编辑操作的义务；同时 Taoify 不承担定期核查用户已发布反馈内容的责任。": "2. Taoify에 제출하는 모든 댓글은 사실대로 작성되어야 하며, 불법, 저속한 성적 내용, 위협, 모욕, 지적 재산권 침해, 기타 제3자의 권익을 해치거나 불쾌감을 주는 내용을 포함해서는 안 됩니다. Taoify는 자체 판단에 따라 위반 평가를 삭제할 수 있지만, 반드시 삭제 또는 편집을 수행할 의무는 없습니다. 또한 Taoify는 사용자가 게시한 피드백 내용을 정기적으로 확인할 책임이 없습니다.",
    "十六、第三方权利限制": "16. 제3자 권리 제한",
    "除Taoify、Taoify关联企业、注册商户、合法权利受让方以外，未参与本协议签约的自然人、企业，无权依据本条款向平台主张任何权利，不能要求平台强制履行协议约定。": "Taoify, Taoify의 관련 회사, 등록 상인, 합법적인 권리 승계자 이외의 개인이나 기업은 본 조항을 근거로 플랫폼에 어떠한 권리도 주장할 수 없으며, 플랫폼이 계약 조건을 강제 이행하도록 요구할 수 없습니다.",
    "十七、隐私和数据保护": "17. 개인정보와 데이터 보호",
    "Taoify 非常重视对您的个人信息的隐私保护，您使用平台服务即认可平台按照《隐私政策》收集、存储、使用客户个人信息。若商户面向欧盟经济区消费者经营、向欧盟客户销售商品、需要遵守 GDPR 法规，双方另行签署《数据处理补充协议》规范跨境数据传输行为。": "Taoify는 귀하의 개인 정보 보호를 매우 중요하게 생각합니다. 플랫폼 서비스를 사용함으로써, 귀하는 《개인정보 보호정책》에 따라 플랫폼이 고객 개인 정보를 수집, 저장, 사용하는 것에 동의합니다. 판매자가 EU 경제 지역 소비자에게 상품을 판매하거나 GDPR 규정을 준수해야 하는 경우, 양측은 별도로 《데이터 처리 보충 협정》을 체결하여 해외 데이터 전송 행위를 규범화합니다.",
    "十八、商业秘密保护": "18. 영업 비밀 보호",
    "1、商业秘密：指双方获取、接触到的对方未对外公开的经营与技术资料，涵盖客户资源、潜在客户联系方式、产品研发方案、定价体系、经营成本、营销方案、内部运营流程、专属技术方案、未对外公示财务数据等一切具备商业价值的非公开资料，无论资料是否标注\"保密\"字样。平台内部运维方案、系统安全机制等内部资料同样属于平台商业秘密。": "1. 영업 비밀: 양측이 취득 또는 접촉한 상대방의 공개되지 않은 경영 및 기술 자료를 의미하며, 고객 리소스, 잠재 고객 연락처, 제품 개발 계획, 가격 체계, 운영 비용, 마케팅 계획, 내부 운영 프로세스, 전문 기술 방안, 공개되지 않은 재무 데이터 등 모든 상업적 가치가 있는 비공개 자료를 포함합니다. 자료에 '기밀'이라는 표시가 있든 없든 관계 없습니다. 플랫폼 내부 운영 계획, 시스템 보안 메커니즘 등의 내부 자료 역시 플랫폼의 영업 비밀에 속합니다.",
    "2、保密义务要求：仅能基于履行本协议约定经营事项使用对方商业秘密，同时采取与自身内部保密同等力度的防护手段，严防商业秘密泄露、复制、擅自对外流转：2.1 仅允许岗位必需员工接触涉密资料，并通过内部制度约束员工保守商业秘密；2.2 如收到法院、监管机关强制调取涉密资料的通知，在法律允许范围内第一时间书面告知资料持有方，并尽可能缩小信息披露范围。": "2. 기밀 유지 의무: 본 계약에서 약정된 경영 사항 수행을 위해만 상대방의 영업 비밀을 사용하고, 자신들의 내부 기밀 보호 수준과 동일한 보호 조치를 취하여 영업 비밀의 누출, 복사, 무단 외부 유출을 엄격히 방지합니다: 2.1 필요한 직원만 기밀 자료에 접근하도록 하며, 내부 제도를 통해 직원들이 영업 비밀을 보호하도록 합니다; 2.2 법원이나 감독 기관으로부터 기밀 자료의 강제 제공 요구를 받았다면, 법률 허용 범위 내에서 최대한 빨리 서면으로 자료 소유자에게 통보하고, 가능한 한 정보 공개 범위를 최소화합니다.",
    "3、豁免保密责任情形：3.1 在接触时已全网公开，或注册平台前就已合法持有该信息；3.2 合作方完全依靠自有资源、不参考对方涉密资料独立研发得到同类信息；3.3 合作方从无违约第三方渠道合法取得该信息，且该第三方不存在保密违约行为。": "3. 기밀 유지 책임 면제 사항: 3.1 접촉 당시 이미 전체 인터넷에 공개되었거나, 플랫폼 등록 전에 합법적으로 해당 정보를 소유하고 있었던 경우; 3.2 협력 파트너가 완전히 자체 자원에 의존하여 상대방의 기밀 자료를 참조하지 않고 독립적으로 동일한 정보를 개발한 경우; 3.3 협력 파트너가 위반하지 않은 제3자의 합법적인 채널을 통해 해당 정보를 취득한 경우, 그리고 해당 제3자가 기밀 유지 위반 행위가 없는 경우.",
    "十九、争议解决规则": "19. 분쟁 해결 규칙",
    "1、本服务条款为本平台主协议；《Taoify 用户使用协议》《Taoify 用户隐私政策》等其他协议均为该主协议补充文件，整套文件共同构成您与平台完整约定。若任一补充文件条款与本主协议内容存在冲突、不一致，一律以本服务条款约定为准。针对本主协议未作出细化、未明确约定的事项，以《Taoify 用户使用协议》《Taoify 用户隐私政策》等其他协议约定内容为准。": "1. 본 서비스 조건은 플랫폼의 주요 계약입니다; 《Taoify 사용자 이용 약관》, 《Taoify 사용자 개인정보 보호정책》 등 다른 모든 계약은 이 주요 계약의 보충 문서이며, 이들 문서들은 귀하와 플랫폼 간의 전체 약정을 구성합니다. 어떤 보충 문서 조항이든 본 주요 계약 내용과 충돌하거나 일치하지 않는 경우, 항상 본 서비스 조건 약정을 따릅니다. 본 주요 계약에서 세분화되거나 명확하게 약정되지 않은 사항은 《Taoify 사용자 이용 약관》, 《Taoify 사용자 개인정보 보호정책》 등 다른 계약의 약정 내용을 따릅니다.",
    "2、商户经营过程中产生的、与本服务条款相关的所有争议、索赔，统一由Taoify 平台运营主体所在地人民法院管辖。": "2. 본 서비스 조건과 관련된 모든 분쟁, 청구는 Taoify 플랫폼 운영 주체 소재지 인민법원의 관할에 속합니다.",
    "本平台由香港星橋國際貿易有限公司（https://aitaoify.com）运营，联系邮箱：liutaotao@taocarts.com，微信号：zzsist666。本条款更新日期：2026年1月1日。": "본 플랫폼은 홍콩 스타브릿지 국제 무역有限公司（https://aitaoify.com）가 운영하며, 연락 이메일: liutaotao@taocarts.com, WeChat ID: zzsist666 입니다. 본 조항의 업데이트 날짜: 2026년 1월 1일.",
    "Taoify 用户使用协议": "Taoify 사용자 이용 약관",
    "提示：您如需注册或使用 Taoify 平台服务，应当完整阅读并严格遵守《Taoify 用户使用协议》，重点关注免责声明、责任限制、违规处置等内容，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本使用协议约束。": "알림: Taoify 플랫폼 서비스를 등록하거나 사용하려면, 《Taoify 사용자 이용 약관》을 완전히 읽고 엄격히 준수해야 합니다. 특히 면책 조항, 책임 제한, 위반 처리 등의 내용에 주의를 기울이고, 자신의 권리, 의무, 사용 규칙 및 위반 책임을 명확히 이해해야 합니다. 플랫폼에서 후속적으로 출시되는 모든 새로운 기능, 도구는 본 이용 약관의 적용을 받습니다.",
    "Taoify有权不定期更新、修改本使用协议里的内容，有权在 Taoify 网站上发布更新和修改更新本使用协议。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。": "Taoify는 본 이용 약관의 내용을 주기적으로 업데이트, 수정할 권리를 보유하며, Taoify 웹사이트에서 이러한 업데이트와 수정을 게시할 수 있습니다. 최신 버전은 매장에서 통합적으로 공지될 것이므로, 정기적으로 약관 업데이트 내용을 확인해 주세요. 약관 개정 내용에 동의하지 않는 경우, 즉시 플랫폼의 모든 서비스 사용을 중단해야 합니다.",
    "除本协议明确约定内容以外，双方所有其他权利义务、规则约束均以《Taoify 服务条款》《Taoify消费协议》等为准。": "본 계약에서 명시적으로 약정된 내용 외에는, 양측의 모든 다른 권리, 의무, 규칙 제약은 《Taoify 서비스 조건》, 《Taoify 소비자 계약》 등을 기준으로 합니다.",
    "完成账户注册，即代表您已充分知晓并自愿接受Taoify 平台所有协议、条款，包括《Taoify 用户使用协议》《Taoify 服务条款》《Taoify用户隐私政策》等。若您不认可Taoify 平台所有协议、条款内容，请立即停止注册。": "계정 등록을 완료하면, Taoify 플랫폼의 모든 계약, 조건, 《Taoify 사용자 이용 약관》, 《Taoify 서비스 조건》, 《Taoify 사용자 개인정보 보호정책》 등을 충분히 알고 자발적으로 수락한다는 것을 나타냅니다. Taoify 플랫폼의 모든 계약, 조건 내용에 동의하지 않는 경우, 즉시 등록을 중단해야 합니다.",
    "用户：指完成 Taoify 平台注册，并使用平台各项服务的自然人、法人及其他组织。": "사용자: Taoify 플랫폼에 등록하고 플랫폼의 다양한 서비스를 사용하는 개인, 법인, 기타 조직을 의미합니다.",
    "平台：指Taoify 平台运营主体及平台软硬件系统、网站、服务端口等整体服务载体。": "플랫폼: Taoify 플랫폼 운영 주체 및 플랫폼 소프트웨어, 하드웨어 시스템, 웹사이트, 서비스 포털 등 전체 서비스 제공자를 의미합니다.",
    "二、账户注册与使用规范": "2. 계정 등록 및 사용 규칙",
    "（一）用户资质与信息管理": "(1) 사용자 자격 및 정보 관리",
    "1. 用户注册时，须向平台提交真实、合法、有效的身份信息、注册地址、实际经营地址、联系电话等资料，不得伪造、变造、隐瞒、虚报注册及资质资料。若用户依托本平台开展经营活动，除法律法规明确可不予登记的情形外，必须依法完成市场主体登记，取得有效营业执照，并在登记经营范围内开展业务。经营项目依法需要行政许可、审批、备案、资质认证的，用户须提前取得对应资质并保证资质持续有效，同时将相关文件提交平台留存。若许可资质被撤销、吊销、到期失效，用户须立即停止对应经营活动并同步告知平台，否则视为严重违约，由此产生的全部法律责任、经济损失由用户自行承担；造成平台损失的，用户须足额赔偿。平台依据监管要求中断、终止服务的，已收取费用不予退还。": "1. 사용자는 등록 시 플랫폼에 진실하고 합법적이며 유효한 신분 정보, 등록 주소, 실제 운영 주소, 연락처 등을 제출해야 하며, 등록 및 자격 정보를 위조, 변조, 은폐, 거짓으로 신고해서는 안 됩니다. 사용자가 본 플랫폼을 통해 사업 활동을 진행하는 경우, 법률 및 규정에서 명시적으로 등록이 필요없는 경우를 제외하고는 반드시 법적으로 시장 주체 등록을 완료하고 유효한 사업자 등록증을 취득해야 하며, 등록된 경영 범위 내에서 사업을 운영해야 합니다. 사업이 행정 허가, 승인, 신고, 자격 인증이 필요한 경우, 사용자는 미리 해당 자격을 취득하고 지속적으로 유효성을 유지하며, 관련 파일을 플랫폼에 제출해야 합니다. 허가 자격이 취소, 박탈, 만료되면, 사용자는 즉시 해당 사업 활동을 중단하고 플랫폼에 알려야 합니다. 그렇지 않으면 심각한 위반으로 간주되며, 발생하는 모든 법적 책임, 경제적 손실은 사용자가 부담해야 합니다. 플랫폼이 손실을 입힌 경우, 사용자는 충분한 배상을 해야 합니다. 플랫폼은 규제 요구에 따라 서비스를 중단하거나 종료할 수 있으며, 이미 징수된 비용은 환불되지 않습니다.",
    "用户须及时完善账户基础信息，因信息错误、失联产生的所有后果，由用户自行负责。用户信息、资质发生变更的，需在变更3个工作日内主动在平台完成更新备案。因资料虚假、失效、未及时更新引发的一切风险与责任，均由用户自行承担。用户需自行妥善保管账户资料、账号、密码等私密信息，不得向无关第三方泄露、转借。因保管不当、信息外泄造成的资金损失、财产损害及法律责任，全部由用户承担。": "사용자는 계정 기본 정보를 적시에 완성해야 하며, 잘못된 정보나 연락 불능으로 인한 모든 결과는 사용자가 책임집니다. 사용자 정보나 자격이 변경되는 경우 3일 이내에 플랫폼에서 업데이트 및 등록을 완료해야 합니다. 허위, 무효, 또는 미업데이트 정보로 인한 모든 위험과 책임은 사용자가 부담합니다. 사용자는 계정 정보, 아이디, 비밀번호 등의 개인 정보를 스스로 안전하게 보관하고, 관련 없는 제3자에게 누설하거나 대여해서는 안 됩니다. 부적절한 관리나 정보 유출로 인한 금전 손실, 재산 피해, 법적 책임은 모두 사용자가 부담합니다.",
    "（二）平台使用限制": "(2) 플랫폼 사용 제한",
    "1. 用户需严格按照所购服务档位的资源限额使用平台服务，超出限制的，平台有权采取限流、关停网站等管控措施，相关损失由用户自行承担，已支付费用不予退还。": "1. 사용자는 구매한 서비스 등급의 리소스 한도 내에서 플랫폼 서비스를 사용해야 합니다. 초과 시 플랫폼은 트래픽 제한, 웹사이트 중단 등 조치를 취할 수 있으며, 관련 손실은 사용자가 부담하며 이미 지불한 비용은 환불되지 않습니다.",
    "2. 用户严禁实施以下违规行为：": "2. 사용자는 다음의 위반 행위를 절대 해서는 안 됩니다:",
    "（1）通过群发垃圾邮件、商业广告等方式推广站点；": "(1) 스팸 메일, 상업 광고 등을 통해 사이트를 홍보하는 행위;",
    "（2）运行违规程序、进程，恶意占用服务器内存、CPU、宽带等资源，造成服务器卡顿、宕机，影响平台及其他用户正常使用；": "(2) 서버 메모리, CPU, 대역폭 등 리소스를 악의적으로 차지하여 서버가 멈추거나 다운되게 하는 행위;",
    "（3）发起网络攻击、篡改系统配置、破坏平台网络与信息安全；": "(3) 네트워크 공격, 시스템 설정 변경, 플랫폼 및 정보 보안을 해치는 행위;",
    "（4）运行干扰服务器正常运行的程序、软件；": "(4) 서버 정상 작동을 방해하는 프로그램, 소프트웨어를 실행하는 행위;",
    "（5）泄露自身及其他客户身份、隐私信息；": "(5) 자신이나 다른 고객의 신분, 개인정보를 누설하는 행위;",
    "（6）提供、售卖与未成年人相关的违规商品及服务；": "(6) 미성년자와 관련된 위법 상품 및 서비스 제공, 판매;",
    "（7）发布、提供带有骚扰、诽谤性质的商品与服务；": "(7) 괴롭힘, 명예훼손 성격의 상품 및 서비스 제공, 게시;",
    "（8）借助平台宣传、售卖基于种族、民族、肤色、宗教信仰等歧视他人、侵犯人权的商品或服务；": "(8) 인종, 민족, 피부색, 종교 신념 등으로 타인을 차별하거나 인권을 침해하는 상품 또는 서비스 홍보, 판매;",
    "（9）侵犯任何第三方知识产权；": "(9) 제3자의 지식재산권 침해;",
    "（10）售卖危险品、管制物品、侵权商品等国内外法律法规明令禁止流通、进出口的商品；": "(10) 위험물, 규제 물품, 저작권 침해 상품 등 국내외 법률에서 명시적으로 금지된 상품의 유통, 수입, 수출;",
    "（11）利用平台开展洗钱、逃税、非法交易等各类违法活动；": "(11) 플랫폼을 이용한 돈세탁, 탈세, 불법 거래 등 각종 불법 활동;",
    "（12）开展超出服务范围及国家法律法规禁止的其他行为。": "(12) 서비스 범위를 넘어서거나 국가 법률에서 금지하는 기타 행위.",
    "（三）用户基本义务": "(3) 사용자 기본 의무",
    "数据安全义务：用户须遵守国家数据保护相关法律法规，建立数据安全防护机制，妥善存储、管理平台数据，严禁泄露、篡改、非法使用数据。因用户行为引发数据安全违规的，由用户独立承担全部法律责任。": "데이터 보안 의무: 사용자는 국가 데이터 보호 관련 법률을 준수하고, 데이터 보안 방어 체계를 구축하여 플랫폼 데이터를 적절히 저장, 관리해야 합니다. 데이터 누출, 변조, 불법 사용은 엄격히 금지됩니다. 사용자의 행동으로 인한 데이터 보안 위반은 사용자가 전적인 법적 책임을 집니다.",
    "商品与服务合规义务：用户上架、销售、提供的商品及服务，必须符合国家安全、生产、环保等法律法规与行业标准，不得提供存在安全隐患、污染环境、危害公众健康的产品及服务。因商品、服务问题引发投诉、处罚、民事赔偿的，责任由用户全部承担。平台收到投诉后，可根据情节采取警示、下架商品、删除内容、暂停服务、封禁账号等处置措施。": "상품 및 서비스 준수 의무: 사용자가 판매, 제공하는 상품 및 서비스는 국가 안전, 생산, 환경 보호 등 관련 법률과 산업 표준을 준수해야 하며, 안전 위험, 환경 오염, 공중 건강을 해치는 제품 및 서비스 제공은 금지됩니다. 상품, 서비스 문제로 인한 불만, 처벌, 민사 배상 책임은 사용자가 전적으로 부담합니다. 플랫폼은 불만 접수 후 경고, 상품 하OnInitiation, 콘텐츠 삭제, 서비스 일시 중단, 계정 폐쇄 등 조치를 취할 수 있습니다.",
    "税务与票据义务：用户开展经营活动须依法纳税，如实申报税费，按规定向交易方开具正规发票，严禁偷税、漏税、逃税、虚开发票、拒开发票，不得参与走私、变相避税等违法活动。平台有权核验票据及纳税凭证，用户违规的，平台可暂停或终止全部服务。": "세금 및 영수증 의무: 사용자는 사업 활동을 수행하면서 법에 따라 세금을 납부하고, 세금을 정확히 신고하며, 거래 상대방에게 적합한 영수증을 발행해야 합니다. 탈세, 미신고, 허위 발행, 발행 거부, 밀수, 간접적인 세금 회피 등 불법 활동 참여는 금지됩니다. 플랫폼은 영수증 및 납세 증빙을 검증할 권리가 있으며, 사용자가 위반 시 서비스를 일시 중단하거나 종료할 수 있습니다.",
    "信息发布义务：用户发布内容需严格遵守法律法规，不得制作、复制、发布、传播违法违规、损害公共利益及他人合法权益的信息，不得为违规内容提供跳转、链接等便利。用户收到平台整改通知后须立即整改；拒不整改的，平台有权暂停或终止全部服务。因用户或其客户发布违规内容造成平台损失的，由客户、用户承担全部赔偿责任。": "정보 게시 의무: 사용자는 법률과 규정을 준수하여 내용을 게시해야 하며, 불법적인, 공공 이익이나 타인의 합법적 권리를 침해하는 정보를 제작, 복제, 배포, 전파하거나 이를 위한 링크나 점프를 제공해서는 안 됩니다. 플랫폼으로부터 수정 요구를 받은 경우 즉시 조치해야 합니다; 수정을 거부할 경우, 플랫폼은 서비스를 일시 중지하거나 종료할 수 있습니다. 사용자 또는 고객이 불법적인 내용을 게시하여 플랫폼에 손실을 입힌 경우, 해당 손실은 고객 및 사용자가 전액 부담합니다.",
    "个人信息保护义务：用户收集、使用、存储、传输客户个人信息，需严格遵守法律法规，严禁非法收集、泄露、出售、篡改他人隐私信息。若发生信息泄露、侵权事件，用户承担全部民事、行政及刑事责任。": "개인 정보 보호 의무: 사용자는 고객의 개인 정보를 수집, 사용, 저장, 전송할 때 법률과 규정을 엄격히 준수하고, 타인의 개인정보를 불법적으로 수집, 누출, 판매, 변조하는 행위를 금지합니다. 정보 누출이나 침해 사고가 발생할 경우, 사용자는 모든 민사, 행정, 형사 책임을 집니다.",
    "知识产权保护义务：用户在平台上传、发布的文字、图片、视频、商标、设计等内容，需拥有知识产权或取得权利人授权，不得侵犯第三方著作权、商标权、专利权等合法权益。用户因侵权引发投诉、诉讼、索赔、行政处罚的，赔偿金、诉讼费、律师费、罚款等所有费用由用户承担，同时用户需赔偿平台方直接、间接损失。": "지식재산권 보호 의무: 사용자가 플랫폼에 업로드하거나 게시하는 텍스트, 이미지, 비디오, 상표, 디자인 등의 콘텐츠는 지식재산권을 소유하거나 권리자의 허가를 받아야 하며, 제3자의 저작권, 상표권, 특허권 등 합법적 권리를 침해해서는 안 됩니다. 사용자가 침해로 인해 항소, 소송, 청구, 행정 처벌 등을 받게 될 경우, 배상금, 소송비, 변호사 비용, 벌금 등 모든 비용은 사용자가 부담하며, 동시에 플랫폼의 직접적, 간접적 손실도 배상해야 합니다.",
    "账号安全义务：用户全权负责账号、站点内容、登录密码的安全保管，因账号外泄、保管不当造成的损失，由用户自行承担。用户需向平台报备对接人员及联系方式，相关人员行为产生的后果由用户承担。": "계정 보안 의무: 사용자는 계정, 사이트 콘텐츠, 로그인 비밀번호의 안전한 관리를 전적으로 책임집니다. 계정 유출이나 관리 부주의로 인한 손실은 사용자가 부담합니다. 사용자는 플랫폼에 연락 담당자와 연락처를 신고해야 하며, 관련 인원의 행동으로 인한 결과는 사용자가 책임집니다.",
    "平台知识产权约定：平台所有技术资料、软件、系统、技术服务的知识产权均归 Taoify 平台所有，用户不得擅自复制、传播、转让、授权第三方使用，违者承担相应法律责任。": "플랫폼 지식재산권 약정: 플랫폼의 모든 기술 자료, 소프트웨어, 시스템, 기술 서비스의 지식재산권은 Taoify 플랫폼에 귀속되며, 사용자는 이를 무단으로 복제, 전파, 양도, 제3자에게 사용 허가하지 않아야 합니다. 위반 시 법적 책임을 집니다.",
    "服务使用规则：站点开通后，用户须及时登录会员中心完成基础配置。用户可同时订购多项平台服务，各项服务周期自购买当日起计算，服务期内不支持暂停。": "서비스 이용 규칙: 사이트가 개통된 후, 사용자는 회원 센터에 접속하여 기본 설정을 완료해야 합니다. 사용자는 여러 플랫폼 서비스를 동시에 주문할 수 있으며, 각 서비스 기간은 구매일로부터 계산되며, 서비스 기간 중 일시 중지는 지원하지 않습니다.",
    "订单履约义务：用户收到平台警告后须及时优化发货效率、完成整改，长期拒不整改的，平台有权单方面终止服务。": "주문 이행 의무: 사용자는 플랫폼으로부터 경고를 받은 후 발송 효율성을 개선하고 수정 조치를 완료해야 합니다. 장기간 수정을 거부할 경우, 플랫폼은 일방적으로 서비스를 종료할 수 있습니다.",
    "投诉处置规则：若平台收到第三方针对用户发布内容、在售商品、提供服务、隐私侵权、知识产权侵权、违法违规等投诉或实名举报，平台有权不经用户同意，直接对用户相关内容、页面、商品、链接进行删除、屏蔽、下架处理；情节严重、拒不整改的，平台可直接暂停、终止全部服务，用户已缴纳的所有费用不予退还。": "불만 처리 규칙: 플랫폼이 제3자로부터 사용자의 게시물, 판매 상품, 제공 서비스, 프라이버시 침해, 지식재산권 침해, 불법 행위 등에 대한 불만이나 실명 제보를 받으면, 플랫폼은 사용자 동의 없이 해당 콘텐츠, 페이지, 상품, 링크를 삭제, 차단, 판매 중단 처리할 수 있습니다. 심각한 경우나 수정을 거부할 경우, 플랫폼은 서비스를 일시 중지하거나 종료할 수 있으며, 사용자가 낸 모든 비용은 환불되지 않습니다.",
    "三、服务费用、续费与佣金": "삼, 서비스 비용, 갱신 및 수수료",
    "本平台服务价格以 Taoify 平台官网、购买页面实时公示为准，用户须按约定方式、期限足额支付费用；未付清费用前，Taoify 平台有权暂停、终止提供服务。": "본 플랫폼의 서비스 가격은 Taoify 플랫폼 웹사이트, 구매 페이지에서 실시간으로 공개되는 가격을 따릅니다. 사용자는 약정된 방식과 기간 내에 충분한 금액을 지불해야 합니다; 비용을 완납하기 전까지 Taoify 플랫폼은 서비스 제공을 일시 중지하거나 종료할 수 있습니다.",
    "平台赠送服务、优惠活动均为一次性福利，赠送服务不包含修改、更新、维护费用，亦不得折价抵扣服务费，赠送服务最终解释权归 Taoify 平台所有。": "플랫폼이 제공하는 무료 서비스, 할인 행사는 일회성 혜택이며, 무료 서비스에는 수정, 업데이트, 유지 관리 비용이 포함되지 않으며, 서비스 비용으로 대체할 수 없습니다. 무료 서비스의 최종 해석 권한은 Taoify 플랫폼에 있습니다.",
    "服务期限届满前用户未及时续订阅费用的，服务自动终止；服务关闭满10日用户仍未续订阅费用的，Taoify 平台有权删除网站全部数据，相关损失由用户自行承担。": "서비스 기간 만료 전에 사용자가 재구독 비용을 지불하지 않을 경우, 서비스는 자동으로 종료됩니다; 서비스 종료 10일 후에도 재구독 비용을 지불하지 않는 경우, Taoify 플랫폼은 웹사이트의 모든 데이터를 삭제할 수 있으며, 관련 손실은 사용자가 부담합니다.",
    "若用户实际交易额超出对应产品套装免佣额度，超出部分用户须按约定支付佣金。佣金按单笔实时扣除或自然月统一核算，用户收到账单后5个工作日内完成支付；逾期未支付的，Taoify 平台有权终止服务。": "사용자의 실제 거래액이 해당 제품 세트의 면제 수수료 한도를 초과할 경우, 초과 부분에 대해 약정된 수수료를 지불해야 합니다. 수수료는 단일 거래별 실시간으로 차감되거나 자연월별로 통합 계산되며, 사용자는 청구서를 받은 후 5 영업일 이내에 지불해야 합니다; 지불이 늦어질 경우, Taoify 플랫폼은 서비스를 종료할 수 있습니다.",
    "用户有权要求 Taoify 平台就实付服务费用开具正规发票，赠送服务对应的金额不纳入开票范围。": "사용자는 Taoify 플랫폼에 실제 지불한 서비스 비용에 대해 정식 세금계산서 발급을 요청할 수 있으며, 무료 서비스에 해당하는 금액은 세금계산서 발급 범위에 포함되지 않습니다.",
    "第四条 服务终止": "제4조 서비스 종료",
    "服务期内用户主动申请终止服务的，需提前一个月书面通知 Taoify 平台，已缴纳费用不予退还；用户擅自终止协议造成 Taoify 平台损失的，须予以赔偿，包括但不限于直接损失、间接损失、律师费等。": "서비스 기간 중 사용자가 서비스 종료를 신청하려면, 1개월 전 서면으로 Taoify 플랫폼에 통보해야 하며, 이미 낸 비용은 환불되지 않습니다; 사용자가 일방적으로 계약을 종료하여 Taoify 플랫폼에 손실을 입힌 경우, 직접적, 간접적 손실, 변호사 비용 등을 포함하여 배상해야 합니다.",
    "因系统停机、升级、维护；电信线路、设备故障，银行系统异常等第三方问题造成服务中断、卡顿、故障的，Taoify 平台不承担责任。": "시스템 정지, 업그레이드, 유지 보수; 통신 회선, 장비 고장, 은행 시스템 이상 등 제3자 문제로 인해 서비스가 중단되거나 지연, 오류가 발생하는 경우, Taoify 플랫폼은 책임을 지지 않습니다.",
    "因用户原因造成服务中断、卡顿、故障的，Taoify 平台不承担责任。": "사용자의 원인으로 인해 서비스가 중단되거나 지연, 오류가 발생하는 경우, Taoify 플랫폼은 책임을 지지 않습니다.",
    "网络拥堵；黑客攻击、电信故障、政府管制、不可抗力、第三方原因等非 Taoify 平台原因造成服务中断、卡顿、故障的，Taoify 平台不承担责任。": "네트워크 혼잡; 해킹 공격, 통신 장애, 정부 규제, 불가항력, 제3자 원인 등 Taoify 플랫폼의 책임이 아닌 이유로 서비스가 중단되거나 지연, 오류가 발생하는 경우, Taoify 플랫폼은 책임을 지지 않습니다.",
    "用户违规占用资源、发布违法信息、侵权、泄露隐私、违法经营、拒不整改等违反本协议约定的，Taoify 平台有权立即关闭网站、终止服务、冻结账号，余款不予退还，同时用户须赔偿 Taoify 平台全部损失，包括但不限于直接损失、间接损失、律师费等。": "사용자가 자원을 불법적으로 점유하거나, 불법 정보를 게시하거나, 침해 행위를 하거나, 프라이버시를 누출하거나, 불법 사업을 운영하거나, 수정을 거부하는 등의 본 계약 위반 행위를 하는 경우, Taoify 플랫폼은 웹사이트를 즉시 폐쇄, 서비스를 종료, 계정을 동결할 수 있으며, 잔여 금액은 환불되지 않으며, 동시에 사용자는 Taoify 플랫폼의 전체 손실, 직접적, 간접적 손실, 변호사 비용 등을 배상해야 합니다.",
    "因用户使用第三方服务导致网站故障、无法使用的，Taoify 平台不承担任何责任。": "사용자가 제3자 서비스를 사용하여 발생한 웹사이트 장애나 이용 불가에 대해 Taoify 플랫폼은 어떠한 책임도 지지 않습니다.",
    "Taoify平台无需就用户遭受的任何直接损失、间接损失、商誉损失、预期收益损失、经营利润损失等承担任何赔偿责任。": "Taoify 플랫폼은 사용자가 입은 모든 직접적 손실, 간접적 손실, 명성 손해, 예상 수익 손실, 영업 이익 손실 등에 대한 배상 책임을 지지 않습니다.",
    "若存在法定或其他 Taoify 应当承担赔偿责任的情形，Taoify 对用户的全部累计赔偿责任（含违约金、赔偿金、维权支出）最高限额为：损失事件发生对应服务周期内，您实际向 Taoify 支付的服务费总金额。无论索赔事由多少、损失金额高低，合计赔付总额不得突破该上限。": "법적으로 또는 기타 Taoify가 배상 책임을 지어야 하는 상황이 있는 경우, Taoify의 사용자에 대한 총 누적 배상 책임(위약금, 배상금, 권리 보호 비용 포함)의 최대 한도는: 손실 사건이 발생한 해당 서비스 기간 동안 Taoify에 실제로 지불한 총 서비스 요금입니다. 청구 사유와 손실 금액에 관계없이 합산 배상 총액은 이 상한선을 초과할 수 없습니다.",
    "第五条 知识产权与平台内容约定": "제5조 지식재산권 및 플랫폼 내용 약정",
    "Taoify平台全部内容，包括但不限于文字、图片、文档、资讯、网站架构、界面设计、程序代码等，相关商标权、著作权、专利权、商业秘密等知识产权均归Taoify平台所有。未经 Taoify 平台书面许可，任何主体不得擅自使用、复制、修改、传播、分发平台内容及程序。": "Taoify 플랫폼의 전체 콘텐츠, 텍스트, 이미지, 문서, 정보, 웹사이트 구조, 인터페이스 디자인, 프로그램 코드 등을 포함하되 이에 국한되지 않으며, 관련 상표권, 저작권, 특허권, 영업 비밀 등의 지식재산권은 모두 Taoify 플랫폼에 귀속됩니다. Taoify 플랫폼의 서면 허가 없이는 어떠한 주체도 플랫폼 콘텐츠 및 프로그램을 무단으로 사용, 복제, 수정, 전파, 배포할 수 없습니다.",
    "用户仅可在 Taoify平台指定专属服务器内使用本平台搭建的网站，不得将网站迁移至非本平台、非本平台提供的服务器运行。": "사용자는 Taoify 플랫폼에서 제공하는 지정된 전용 서버 내에서만 본 플랫폼에서 구축한 웹사이트를 사용할 수 있으며, 이를 본 플랫폼이나 본 플랫폼이 제공하지 않는 서버로 이전해서는 안 됩니다.",
    "用户自行在网站创建、上传的内容，由用户独立承担全部法律责任；基于本平台开发的第三方应用，其行为、内容、数据由第三方自行负责，Taoify 平台不承担连带责任。": "사용자가 웹사이트에서 생성하거나 업로드한 콘텐츠에 대한 모든 법적 책임은 사용자가 독립적으로 부담합니다; 본 플랫폼을 기반으로 개발된 제3자 애플리케이션의 행위, 콘텐츠, 데이터는 제3자가 자체적으로 책임지고 Taoify 플랫폼은 연대 책임을 지지 않습니다.",
    "第六条 条款修订": "제6조 조항 개정",
    "Taoify平台有权随时修订本协议条款、服务定价，协议条款修订提前1个工作日在平台公示，资费调整提前1个月公示。修订后的条款公示后继续使用服务的，视为用户自愿接受全部修订内容。": "Taoify 플랫폼은 언제든지 본 계약 조항, 서비스 가격을 개정할 권리를 보유하며, 계약 조항 개정은 1일 전, 요금 조정은 1개월 전에 플랫폼에 공고됩니다. 개정된 조항이 공고된 후 계속 서비스를 사용하는 것은 사용자가 모든 개정 내용을 자발적으로 수락하는 것으로 간주됩니다.",
    "第七条 通知": "제7조 통지",
    "用户确认，在 Taoify平台注册所提供的身份信息、地址、联系方式为本协议履行、相关的诉讼、仲裁程序中的法定送达地址及送达方式，司法机关可直接据此送达各类司法文书。双方均同意以邮寄、电子送达方式收取司法文书。上述送达地址及方式的效力涵盖仲裁、一审、二审、再审及执行等全部诉讼阶段。若一方信息变更，需提前3个工作日申请变更，未变更的，原约定地址及方式仍视为有效送达地址，任何一方、司法机关按原地址送达即便被退回，也视为有效送达。": "사용자는 Taoify 플랫폼에 등록 시 제공한 신분 정보, 주소, 연락처가 본 계약의 이행, 관련 소송, 중재 절차에서의 법적 송달 주소 및 방법임을 확인합니다. 양측은 우편, 전자 송달 방식으로 사법 문서를 받는 것에 동의합니다. 위 송달 주소 및 방법의 효력은 중재, 1심, 2심, 재심 및 집행 등 모든 소송 단계를 포괄합니다. 일방의 정보 변경 시 3일 전에 변경을 신청해야 하며, 변경되지 않은 경우 원래 약정된 주소 및 방법은 여전히 유효한 송달 주소로 간주되며, 어느 일방이나 사법 기관이 원 주소로 송달하더라도 반송되어도 유효한 송달로 간주됩니다.",
    "第八条 不可抗力": "제8조 불가항력",
    "不可抗力指战争、武装冲突、自然灾害（如地震、洪水）、罢工、暴乱、政府行为（如禁令、制裁）、司法限制、全国性疫情等不能预见、不能避免且不能克服的客观事件。": "불가항력은 전쟁, 무장 충돌, 자연 재해(지진, 홍수 등), 파업, 폭동, 정부 행위(금지령, 제재 등), 사법 제한, 전국적인 역병 등 예측할 수 없고 피할 수 없으며 극복할 수 없는 객관적인 사건을 의미합니다.",
    "第九条 其他约定": "제9조 기타 약정",
    "1. Taoify平台发生上市、收购、合并、名称变更等情形时，有权将本协议项下全部权利、义务转移给权利义务承接方，用户对此无异议。": "1. Taoify 플랫폼이 상장, 인수, 합병, 명칭 변경 등의 상황이 발생할 경우, 본 계약 하의 모든 권리와 의무를 권리 의무 승계자에게 이양할 권리를 가지며, 사용자는 이에 이의를 제기하지 않습니다.",
    "2. Taoify 平台内服务说明、价格公示、申请表格等文件，均为本协议不可分割的组成部分，与本协议具有同等法律效力。": "2. Taoify 플랫폼 내의 서비스 설명, 가격 공시, 신청 양식 등 문서는 본 계약의 분리 불가능한 구성 부분이며, 본 계약과 동등한 법적 효력을 갖습니다.",
    "3. 若因用户违反本协议约定，导致平台被第三方索赔、起诉、仲裁，或被行政机关处以罚款、责令赔付，全部责任均由用户独立承担。用户须向平台足额赔付平台由此产生的全部直接损失与间接损失，损失范围包括但不限于：平台向第三方支付的赔偿金、和解金、补偿金、违约金；行政机关、司法机关收取的罚款、滞纳金、诉讼费、仲裁费、保全费、执行费、鉴定费、评估费；平台为维权支出的律师费、公证费、调查取证费、差旅费、担保费；平台商誉受损损失、业务中断损失、可得利益损失、第三方追责产生的额外赔付等一切相关费用。": "3. 사용자가 본 계약 위반으로 인해 플랫폼이 제3자로부터 청구, 소송, 중재를 당하거나 행정 기관으로부터 벌금, 배상 명령을 받게 되는 경우, 모든 책임은 사용자가 독립적으로 부담합니다. 사용자는 플랫폼이 이로 인해 발생하는 모든 직접적 손실과 간접적 손실을 플랫폼에 충분히 배상해야 합니다. 손실 범위는 다음과 같습니다: 플랫폼이 제3자에게 지급한 배상금, 화해금, 보상금, 위약금; 행정 기관, 사법 기관이 부과한 벌금, 연체료, 소송비, 중재비, 보전비, 집행비, 감정비, 평가비; 플랫폼이 권리 보호를 위해 지출한 변호사 비용, 공증 비용, 증거 수집 비용, 여행 비용, 보증 비용; 플랫폼의 명성 손해, 사업 중단 손해, 얻을 수 있었던 이익 손실, 제3자의 추궁으로 인한 추가 배상 등 모든 관련 비용.",
    "第十条 争议解决": "제10조 분쟁 해결",
    "1. 平台有关条款（包括但不限于本使用协议等）可能会有除中文以外的其他版本。如果不同语言版本的使用协议之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本使用协议条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本使用协议，予以明确排除。": "1. 플랫폼 관련 조항(본 사용 계약을 포함하되 이에 국한되지 않음)에는 중국어 외에도 다른 언어 버전이 있을 수 있습니다. 서로 다른 언어 버전의 사용 계약 사이에 어떠한 차이, 불일치 또는 모호성이 있더라도 중국어 텍스트를 기준으로 하며, 다른 텍스트는 참고용으로만 사용되며 중국어 텍스트의 의미를 변경하거나 대치할 수 없습니다. 본 사용 계약 조항의 체결, 효력, 해석, 이행 및 분쟁 해결은 중화인민공화국 법률을 준거법으로 하며, 해외 법률 충돌 규칙은 배제됩니다. 《유엔 국제물품매매계약협약》은 본 사용 계약에 적용되지 않으며, 명확히 배제됩니다.",
    "2. 因本协议引起或与本协议有关的任何争议，双方应友好协商解决；协商不成的，任何一方均有权向Taoify 平台经营地有管辖权的人民法院提起诉讼。": "2. 본 계약으로 인해 또는 본 계약과 관련된 어떠한 분쟁이라도 양측은 친절하게 협상을 통해 해결해야 합니다; 협상이 성립되지 않을 경우, 어느 일방이라도 Taoify 플랫폼 경영지의 관할 법원에 소송을 제기할 권리를 가집니다.",
    "争议处理期间，除争议事项外，双方应继续履行本协议其他约定。本协议部分条款被废止、无效或不能执行，并不影响其他条款效力。": "분쟁 처리 기간 중, 분쟁 사항을 제외하고는 양 당사자는 본 계약의 다른 조항을 계속 이행해야 합니다. 본 계약의 일부 조항이 폐지되거나 무효 또는 집행 불능인 경우, 다른 조항의 효력에는 영향을 미치지 않습니다.",
    "本平台由香港星橋國際貿易有限公司（https://aitaoify.com）运营，联系邮箱：liutaotao@taocarts.com，微信号：zzsist666。本协议更新日期：2026年1月1日。": "본 플랫폼은 홍콩 스타브리지 국제무역有限公司（https://aitaoify.com）가 운영하며, 연락처 이메일: liutaotao@taocarts.com, 위챗 ID: zzsist666입니다. 본 계약 업데이트 날짜: 2026년 1월 1일.",
    "适用于任何项目的": "모든 프로젝트에 적용 가능",
    "根据自己的需求选择合适的模板，并在其基础上进行自定义和修改，以满足自己的品牌形象和功能要求。": "자신의 요구사항에 맞는 템플릿을 선택하고, 이를 기반으로 커스터마이징하여 자신의 브랜드 이미지와 기능 요구를 충족시키세요.",
    "用 AI 设计你的专属模板": "AI로 당신만의 템플릿 디자인",
    "一句话描述你的店铺风格，AI 自动生成专属模板": "상점 스타일을 한 문장으로 설명하면 AI가 전용 템플릿을 자동 생성합니다",
    "无需设计经验": "디자인 경험이 필요 없음",
    "秒级生成": "초 단위로 생성",
    "可二次修改": "재수정 가능",
    "立即 AI 设计": "즉시 AI 디자인 시작",
    "搜索您想要的模版": "원하는 템플릿 검색",
    "注册卖家": "판매자 등록",
    "行业模板": "업계 템플릿",
    "满意度": "만족도",
    "精选模板": "추천 템플릿",
    "查看模板设计": "템플릿 디자인 확인",
    "最新的主题和模板": "최신 주제 및 템플릿",
    "查看更多": "더 보기",
    "暂无模板，稍后再来看看吧": "현재 템플릿이 없습니다. 나중에 다시 확인해보세요",
    "本周精选创作者": "이주의 추천 크리에이터",
    "个作品": "개의 작품",
    "查看主页": "홈페이지 보기",
    "数百万创意资源、无限下载": "수백만 개의 창의적 리소스, 무제한 다운로드",
    "立即订阅、可随时取消": "즉시 구독, 언제든 취소 가능",
    "轻松的设计有您自己在线制作": "간편하게 온라인에서 직접 디자인 제작",
    "适合任何技能水平的智能模板": "모든 스킬 레벨에 적합한 스마트 템플릿",
    "如何用 AI 设计模板": "AI 디자인 템플릿 사용 방법",
    "描述你的店铺类型和风格，如“欧美简约服饰店”": "가게 유형과 스타일을 설명하세요. 예: '유럽-미국 심플 의류 가게'",
    "AI 自动生成多套模板设计供你选择": "AI가 여러 템플릿 디자인을 자동 생성하여 선택할 수 있게 합니다",
    "选中模板后一键启用，随时调整细节": "템플릿 선택 후 한 번의 클릭으로 활성화하고 세부 사항을 조정할 수 있습니다",
    "去模板列表看看": "템플릿 목록 확인하기",
    "我知道了": "알겠습니다",
    "个筛选": "개의 필터",
    "全部模板": "전체 템플릿",
    "没有结果": "결과 없음",
    "作者": "작성자",
    "更新时间": "업데이트 시간",
    "实时预览": "실시간 미리보기",
    "立即购买": "지금 구매",
    "应用到当前店铺": "현재 가게에 적용",
    "模板介绍": "템플릿 소개",
    "主题模板特点": "테마 템플릿 특징",
    "模版价格": "템플릿 가격",
    "支付方式": "결제 방법",
    "未来更新": "향후 업데이트",
    "提供6个月的支持": "6개월 지원 제공",
    "由Taoify检查质量": "Taoify 품질 검사",
    "模板规格": "템플릿 사양",
    "高分辨率": "고해상도",
    "是的": "예",
    "不支持": "지원 안 함",
    "可兼容浏览器": "호환 브라우저",
    "布局": "레이아웃",
    "模版ID": "템플릿 ID",
    "发表时间": "게시 날짜",
    "关于作者": "작성자 정보",
    "其他作品": "다른 작품들",
    "购买成功": "구매 성공",
    "购买成功！请在模板中心查看使用。": "구매 성공! 템플릿 센터에서 사용을 확인하세요.",
    "仅关闭": "닫기만",
    "查看已购买模版": "구매한 템플릿 확인",
    "预览站点暂时不可用，请稍后再试或联系平台": "사이트 미리보기가 현재 사용 불가능합니다. 나중에 다시 시도하거나 플랫폼에 연락해주세요",
    "返回": "돌아가기",
    "审核失败": "심사 실패",
    "（审核失败请到原创作平台进行编辑后更新）": "(심사 실패 시 원래의 제작 플랫폼에서 수정 후 업데이트해주세요)",
    "失败原因": "실패 사유",
    "申请时间": "신청 시간",
    "审核时间": "심사 시간",
    "未发布": "발행되지 않음",
    "已发布": "발행됨",
    "审核通过": "심사 통과",
    "当前版本号": "현재 버전 번호",
    "发布模版": "템플릿 발행",
    "删除当前模版": "현재 템플릿 삭제",
    "删除模板": "템플릿 삭제",
    "确定删除该模板吗？删除后不可恢复。": "정말로 이 템플릿을 삭제하시겠습니까? 삭제된 템플릿은 복구할 수 없습니다.",
    "取消": "취소",
    "确认删除": "삭제 확인",
    "申请发布模版，TaoifyShop会尽快审核，请在个人中心查看结果。": "템플릿 발행 신청, TaoifyShop이 가능한 한 빨리 심사하겠습니다. 개인 센터에서 결과를 확인하세요.",
    "确定": "확인",
    "模板设计师工作台": "템플릿 디자이너 작업대",
    "把你的设计变成收入": "당신의 디자인을 수익으로 바꾸세요",
    "你制作的模板可以发布到模版市场，其他卖家购买后你即可获得佣金收益。": "제작한 템플릿을 템플릿 마켓에 게시하면, 다른 판매자가 구매할 때마다 수수료를 얻을 수 있습니다.",
    "发布我的模板": "내 템플릿 게시하기",
    "去模版市场看看": "템플릿 마켓 둘러보기",
    "个": "개",
    "我的模板": "나의 템플릿",
    "已购模板": "구매한 템플릿",
    "模板审核通过上架后，被其他卖家购买即可获得佣金收益": "심사 통과 후 게시된 템플릿이 다른 판매자에게 구매되면 수수료를 얻을 수 있습니다",
    "想快速出模板？试试 AI 设计": "빠른 템플릿 제작이 필요하세요? AI 디자인을 시도해 보세요",
    "一句话描述店铺风格，AI 自动生成专属模板，省时又省力": "가게 스타일을 한 문장으로 설명하면, AI가 전용 템플릿을 자동 생성하여 시간과 노력을 절약할 수 있습니다",
    "发布你的设计，赚取佣金": "디자인을 게시하고 수수료를 벌어보세요",
    "发布模板": "템플릿 게시",
    "全选": "전체 선택",
    "已选": "선택됨",
    "批量删除": "일괄 삭제",
    "查看": "보기",
    "发布": "게시",
    "更新": "업데이트",
    "应用": "적용",
    "无结果": "결과 없음",
    "已购买模版": "구매한 템플릿",
    "当前店铺": "현재 상점",
    "当前店铺应用版本": "현재 상점 앱 버전",
    "还未购买模版": "아직 템플릿을 구매하지 않음",
    "提交后由平台审核": "제출 후 플랫폼에서 검토",
    "生成待发布模版，可在个人中心提交发布到模版市场，TaoifyShop会尽快审核，审核通过后将上架到模版市场，其他人购买后，可赚佣金。审核结果请在个人中心的自定义模版中查看，大概需要1~2个工作日。": "발행 대기 중인 템플릿 생성, 개인 센터에서 템플릿 마켓에 제출 가능. TaoifyShop이 가능한 빨리 검토하고, 승인되면 템플릿 마켓에 등록됩니다. 다른 사람이 구매하면 수수료를 얻을 수 있습니다. 검토 결과는 개인 센터의 사용자 정의 템플릿에서 확인 가능하며, 대략 1~2일 소요됩니다.",
    "选择要发布的模板": "발행할 템플릿 선택",
    "新发布": "새로 발행",
    "发布新版本": "새 버전 발행",
    "暂无未发布模板，请先在工作台制作模板": "발행되지 않은 템플릿이 없습니다. 작업대에서 먼저 템플릿을 제작해주세요",
    "作品信息": "작품 정보",
    "名称": "이름",
    "模板名称": "템플릿 이름",
    "封面图": "표지 이미지",
    "上传封面": "표지 업로드",
    "模板描述": "템플릿 설명",
    "模版亮点": "템플릿 하이라이트",
    "付费": "유료",
    "标签": "태그",
    "按Enter键保存和添加更多": "Enter 키를 눌러 저장하고 더 추가하기",
    "特点": "특징",
    "按Enter键添加特点": "Enter 키를 눌러 특징 추가",
    "关闭": "닫기",
    "提交": "제출",
    "批量删除模板": "템플릿 일괄 삭제",
    "确定删除选中的": "선택한 항목을 삭제하시겠습니까?",
    "个模板吗？删除后不可恢复。": "템플릿을 삭제하시겠습니까? 삭제된 템플릿은 복구할 수 없습니다.",
    "删除已购模板": "구매한 템플릿 삭제",
    "确定删除已购模板": "구매한 템플릿을 삭제하시겠습니까?",
    "吗？删除后将无法继续使用。": "삭제하시겠습니까? 삭제한 후에는 더 이상 사용할 수 없습니다.",
    "立即去设计": "지금 디자인하러 가기",
    "全部自定义模版": "모든 사용자 정의 템플릿",
    "待发布": "발행 대기 중",
    "待审核": "심사 대기 중",
    "审核未通过": "심사 미통과",
    "自适应": "자기 조정",
    "仅支持PC": "PC만 지원",
    "仅支持H5": "H5만 지원",
    "删除成功": "삭제 성공",
    "余额提现": "잔액 인출",
    "提现明细": "인출 내역",
    "可提现金额": "인출 가능 금액",
    "提现到支付宝": "알리페이로 인출",
    "提现到银行卡": "은행 카드로 인출",
    "购买记录": "구매 기록",
    "查看你购买过的模板与订单": "구매한 템플릿 및 주문 보기",
    "类型": "유형",
    "订单编号": "주문 번호",
    "已支付": "지불 완료",
    "暂无购买记录": "구매 기록이 없습니다",
    "消费记录": "소비 기록",
    "时间": "시간",
    "详情": "상세 정보",
    "支出": "지출",
    "收入": "수입",
    "收益明细": "수익 내역",
    "已失效": "만료됨",
    "待结算": "정산 대기 중",
    "已结算": "정산 완료",
    "提现记录": "출금 기록",
    "模版名称": "템플릿 이름",
    "在线咨询": "온라인 상담",
    "在线客服暂时没接上，稍后再试一次；着急的话直接发邮件，我们会尽快回。": "온라인 고객 서비스가 일시적으로 연결되지 않았습니다. 나중에 다시 시도해 주세요; 급하신 경우 이메일을 보내주시면 가능한 빨리 답변드리겠습니다.",
    "重新连接": "다시 연결",
    "月": "월",
    "想了解开店、选品、物流？直接问…": "가게 오픈, 상품 선택, 물류에 대해 알고 싶으신가요? 직접 물어보세요…",
    "拖动调整大小": "크기 조정 드래그",
    "开店顾问": "스토어 컨설턴트",
    "人工在线": "인공 고객 지원",
    "全天候自动应答": "24시간 자동 응답",
    "网络异常，请稍后再试": "네트워크 오류입니다. 나중에 다시 시도해 주세요.",
    "AI 顾问": "AI 컨설턴트",
    "待人工确认": "확인 대기 중",
    "转人工": "인공 고객센터로 전환",
    "开店与起步": "가게 오픈과 시작",
    "注册、选模板、绑域名、第一件商品": "등록, 템플릿 선택, 도메인 바인딩, 첫 상품",
    "店铺装修": "가게 꾸미기",
    "模板、组件、配色、手机端排版": "템플릿, 구성 요소, 색상 조합, 모바일 배치",
    "商品与库存": "상품 및 재고",
    "采集、改价、规格、库存同步": "수집, 가격 변경, 사양, 재고 동기화",
    "采购、打单、发货、轨迹异常": "구매, 주문서 출력, 배송, 트래킹 이상",
    "绑账户、余额、提现、服务费": "계좌연결, 잔액, 출금, 서비스 수수료",
    "营销与 AI": "마케팅 및 AI",
    "AI 客服、AI 员工、优惠券、邮件": "AI 고객 서비스, AI 직원, 쿠폰, 이메일",
    "账号与权限": "계정 및 권한",
    "子账号、角色、登录、安全": "하위 계정, 역할, 로그인, 보안",
    "API、Webhook、对接自己的系统": "API, Webhook, 자체 시스템 연결",
    "注册开店要准备什么？多久能跑起来？": "가게 등록을 위해 무엇이 필요할까요? 얼마나 걸릴까요?",
    "一个能收验证码的邮箱或手机号就能注册，不需要先有营业执照。流程是：选套餐、选模板、绑域名、传第一个商品，一般一小时内能在后台跑通一单测试订单。": "인증 코드를 받을 수 있는 이메일이나 휴대폰 번호만 있으면 등록할 수 있으며, 사업자등록증이 필요하지 않습니다. 절차는 다음과 같습니다: 패키지 선택, 템플릿 선택, 도메인 연결, 첫 상품 업로드, 일반적으로 1시간 내에 백오피스에서 테스트 주문을 실행할 수 있습니다.",
    "店铺能不能绑自己的域名？需要备案吗？": "자신의 도메인을 매장에 연결할 수 있나요? 도메인 등록이 필요하나요?",
    "可以。在后台「店铺设置 → 域名」里填你的域名，按提示加两条 DNS 解析，一般十分钟生效，SSL 证书自动签发。服务器在境外，不需要国内备案；自有域名按套餐权限开放。": "네. 백오피스의 '상점 설정 → 도메인'에서 도메인을 입력하고, 안내에 따라 두 가지 DNS 레코드를 추가하면 일반적으로 10분 내로 적용됩니다. SSL 인증서는 자동으로 발급됩니다. 서버가 해외에 위치해 있어 중국 내 등록이 필요하지 않습니다; 자체 도메인은 패키지 권한에 따라 제공됩니다.",
    "模板市场里的模板怎么用？换了会不会影响商品和订单？": "템플릿 마켓의 템플릿은 어떻게 사용하나요? 변경하면 상품과 주문에 영향을 미치나요?",
    "模板只改变店铺外观，不动商品、订单和客户数据，随时可以换回来。应用模板后，再在装修页调首页模块和配色，保存发布后前台才生效。": "템플릿은 상점의 외관만 변경하며, 상품, 주문 및 고객 데이터에는 영향을 미치지 않습니다. 언제든지 원래대로 되돌릴 수 있습니다. 템플릿을 적용한 후, 데코레이션 페이지에서 홈 모듈과 색상을 조정하고, 저장하여 게시하면 프론트엔드에 반영됩니다.",
    "装修改完，前台看还是老样子？": "인테리어를 마쳤는데, 프론트 데스크는 여전히 예전 그대로인가요?",
    "先确认改动是否已经保存并发布；再强制刷新一次前台（Ctrl 或 Cmd 加 Shift 加 R），浏览器可能缓存了旧样式。手机上还要清一下站点缓存。仍然不对，把店铺编号和页面地址发给客服。": "먼저 변경 사항이 저장되고 게시되었는지 확인한 후, 프론트엔드에서 강제 새로고침을 시도하세요 (Ctrl 또는 Cmd + Shift + R). 브라우저가 이전 스타일을 캐시할 수 있습니다. 휴대폰에서는 사이트 캐시를 지워주세요. 그래도 문제가 해결되지 않으면, 상점 번호와 페이지 주소를 고객 지원에 알려주세요.",
    "怎么把 1688、淘宝的商品搬到店铺里？": "1688, 타오바오 상품을 어떻게 가게에 옮길까요?",
    "在后台「商品 → 采集」里贴商品链接，选目标分类和加价规则，确认后生成商品草稿；检查图片、规格、库存再上架。带别人店铺 logo 或水印的图，建议换掉再用。": "관리자 페이지의 '상품 → 수집'에서 상품 링크를 붙이고, 대상 카테고리와 가격 조정 규칙을 선택한 후 확인하면 상품 초안이 생성됩니다. 이미지, 사양, 재고를 확인하고 상품을 판매 준비하세요. 다른 가게 로고나 워터마크가 있는 이미지는 교체하는 것이 좋습니다.",
    "商品价格怎么定？汇率和加价率在哪里改？": "상품 가격은 어떻게 설정하나요? 환율과 마진율은 어디에서 변경할 수 있나요?",
    "在价格规则里配汇率和加价率，商品价格会按规则自动算；单个商品也可以在编辑页手工改价。改规则只影响之后的价格计算，已经生成的订单金额不变。": "가격 규칙에서 환율과 가격 상승률을 설정하면, 상품 가격이 자동으로 계산됩니다. 개별 상품의 가격은 편집 페이지에서 수동으로 변경할 수도 있습니다. 규칙을 변경해도 이미 생성된 주문 금액에는 영향을 미치지 않습니다.",
    "客户下单以后，我要做哪些操作？": "고객이 주문한 후에 어떤 작업을 해야 하나요?",
    "订单列表里能看到待采购和待发货。先按订单采购，再录入物流单号发货；单号录入后，客户在店铺前台就能看到轨迹。状态卡在某一环节时，后台会有提示。": "주문 목록에서 구매 대기 중인 항목과 발송 대기 중인 항목을 확인할 수 있습니다. 먼저 주문에 따라 구매한 후, 운송 번호를 입력하여 발송하세요. 운송 번호가 입력되면 고객이 상점 프론트에서 추적 정보를 확인할 수 있습니다. 상태가 특정 단계에서 멈출 경우, 백오피스에서 알림이 표시됩니다.",
    "物流轨迹一直不更新，是丢件了吗？": "물류 정보가 계속 업데이트되지 않아, 소실되었나요?",
    "单号录入后通常 24 小时内才有第一条轨迹，节假日会更慢。超过 48 小时没有更新，先核对单号和渠道有没有填错；确认无误就把订单号发给客服，由平台向渠道查件。": "운송장 번호 입력 후 일반적으로 24시간 내에 첫 트래킹 정보가 업데이트됩니다. 공휴일에는 더 느릴 수 있습니다. 48시간 이상 업데이트가 없으면, 먼저 운송장 번호와 채널이 정확한지 확인하세요; 문제가 없다면 주문번호를 고객센터로 보내주세요. 플랫폼에서 채널에 조회 요청을 하겠습니다.",
    "客户要退款，钱是从哪里退的？": "고객이 환불을 요청하면, 어디서 돈이 반환되나요?",
    "从你绑定的收款账户原路退回，平台不经手这笔钱。在订单详情点「退款」，填金额和原因，客户一般 3 到 5 个工作日收到。已经发货的订单，建议先和客户确认拒收或退回。": "결제하신 계좌로 직접 환불됩니다, 플랫폼은 이 돈을 거치지 않습니다. 주문 상세에서 '환불'을 클릭하고 금액과 이유를 입력하세요. 일반적으로 고객은 3~5 영업일 내에 환불을 받습니다. 이미 발송된 주문의 경우, 먼저 고객과 반품 또는 수령 거부를 확인하는 것이 좋습니다.",
    "后台余额怎么充值？提现多久到账？": "백오피스 잔액을 어떻게 충전하나요? 인출은 얼마나 걸리나요?",
    "充值在「余额」页按提示转账并提交凭证，到账后就能用于采购和扣费。提现提交后按后台显示的结算周期处理，具体时效和手续费以提现页说明为准。": "「잔액」페이지에서 안내에 따라 송금하고 증빙을 제출하세요. 입금이 확인되면 구매와 요금 결제에 사용할 수 있습니다. 출금 신청은 백오피스에서 표시되는 정산 주기에 따라 처리되며, 실제 소요 시간과 수수료는 출금 페이지의 설명을 따릅니다.",
    "平台服务费和佣金是怎么算的？在哪里看？": "플랫폼 서비스 비용과 수수료는 어떻게 계산되나요? 어디에서 확인할 수 있나요?",
    "按订单实付金额和你所在套餐的费率计算，账单在后台的账单与佣金页可以逐单核对。对某笔金额有疑问，带上订单号问客服，能查到具体的计费口径。": "주문 실제 지불 금액과 고객님의 패키지 요율에 따라 계산되며, 백오피스의 청구 및 수수료 페이지에서 각 주문을 확인할 수 있습니다. 특정 금액에 대해 의문이 있다면, 주문 번호와 함께 고객 서비스에 문의하시면 구체적인 요금 정보를 확인할 수 있습니다.",
    "AI 客服答错了，怎么调整？": "AI 고객센터가 잘못 답변했을 때, 어떻게 조정할까요?",
    "AI 客服只按你给的知识库和话术回答。答错通常是知识库缺这一条：把标准答案补进去，再实测几次。涉及价格、售后时效这类敏感问题，建议写成明确规则，让它照规则说。": "AI 고객센터는 제공된 지식베이스와 대본에 따라 답변합니다. 잘못 답변하는 경우 대부분 해당 정보가 지식베이스에 없는 경우입니다: 정확한 답변을 추가하고 몇 번 더 테스트해보세요. 가격이나 사후 서비스 기간과 같은 민감한 문제의 경우, 명확한 규칙으로 작성하여 AI가 그에 따라 말하도록 하세요.",
    "前台能显示多种语言吗？翻译不准能不能自己改？": "프론트엔드에서 여러 언어를 표시할 수 있나요? 번역이 정확하지 않으면 직접 수정할 수 있나요?",
    "支持 20 种语言，访客进来会按浏览器语言自动显示对应版本。词条在后台语言包里可以直接改，改完前台即时生效；某个语种整段没翻译时，会回退显示英文。": "20개 언어를 지원하며, 방문자는 브라우저 언어에 따라 자동으로 해당 버전을 표시받습니다. 용어는 백오피스 언어 패키지에서 직접 수정할 수 있으며, 수정 후 즉시 프론트엔드에 반영됩니다; 특정 언어로 번역되지 않은 경우 영어로 표시됩니다.",
    "子账号怎么开？能不能限制他只能看一部分功能？": "서브 계정은 어떻게 생성하나요? 특정 기능만 볼 수 있도록 제한할 수 있나요?",
    "在「权限管理」里新增管理员并勾选他能访问的菜单，子账号登录后只看到被授权的页面，订单、提现这类敏感操作可以单独关掉。员工离职直接停用账号即可。": "권한 관리에서 관리자를 추가하고 접근 가능한 메뉴를 선택하세요. 서브 계정으로 로그인하면 권한이 부여된 페이지만 볼 수 있으며, 주문이나 출금과 같은 민감한 작업은 개별적으로 비활성화할 수 있습니다. 직원이 퇴사하면 계정을 바로 중지하면 됩니다.",
    "忘记密码 / 换了手机号，怎么找回？": "비밀번호를 잊으셨거나 휴대폰 번호를 변경하셨나요? 어떻게 계정을 찾으실 수 있을까요?",
    "登录页点「忘记密码」，用注册邮箱收验证码重置。邮箱也收不到、或者注册手机号已经停用，就把店铺编号和注册邮箱发给客服，核验后人工处理。": "로그인 페이지에서 '비밀번호 찾기'를 클릭하고, 등록한 이메일로 인증 코드를 받아 비밀번호를 재설정하세요. 이메일로도 받지 못하거나, 등록된 휴대폰 번호가 사용 불가능한 경우, 상점 번호와 등록 이메일을 고객센터에 보내 주세요. 확인 후 수동으로 처리해 드립니다.",
    "能不能对接我自己的 ERP？数据怎么同步？": "자신의 ERP와 연동할 수 있나요? 데이터는 어떻게 동기화되나요?",
    "可以。平台开放 REST 接口和 Webhook：用 ERP 管货的，只同步库存；用自己系统管订单的，只拉订单。接口按店铺隔离，一个 Token 只能读自己店的数据，先在沙箱环境联调。": "네. 플랫폼은 REST 인터페이스와 Webhook을 제공합니다: ERP로 재고를 관리하는 경우, 재고만 동기화됩니다; 자체 시스템으로 주문을 관리하는 경우, 주문만 가져옵니다. 인터페이스는 가게별로 분리되어 있으며, 하나의 Token은 해당 가게의 데이터만 읽을 수 있습니다. 먼저 샌드박스 환경에서 테스트해보세요.",
    "首页": "홈",
    "功能": "기능",
    "案例": "사례",
    "试用版": "체험판",
    "单店版": "단일 가게 버전",
    "起步版": "스타트 버전",
    "成长版": "성장 버전",
    "先免费用 14 天，把店开起来看效果": "먼저 14일 무료로 사용해보고 가게 운영 효과를 확인하세요.",
    "一个人做代购，够用就好": "개인 대리구매, 충분합니다.",
    "有团队之后的第一档": "팀 구성 후 첫 번째 요금제",
    "多店、批量铺货、要账期": "다수의 가게, 대량 상품 등록, 대금 지급 기간 필요"
}
